// AUTO-GENERATED (gen_usecases_i18n.py). Use-case SEO landing pages, 6 keys x 22 languages.
export const USECASE_GEN = {
 "gestion-ferme": {
  "fr": {
   "slug": "logiciel-gestion-ferme",
   "title": "Logiciel de gestion de ferme | Ma Petite Ferme",
   "description": "Logiciel de gestion de ferme tout-en-un : animaux, stocks, clients, commandes, factures et boutique en ligne. Simple, en français — essai gratuit.",
   "h1": "Le logiciel simple pour gérer toute votre ferme",
   "intro": "Ma Petite Ferme réunit dans une seule application la gestion de vos animaux, de vos productions, de vos stocks, de vos clients et de vos ventes. Pensé pour les petites fermes qui veulent gagner du temps sans usine à gaz.",
   "bullets": [
    "Centralisez animaux, productions, stocks et documents au même endroit",
    "Suivez clients, commandes et facturation sans ressaisie",
    "Pilotez votre activité avec des statistiques claires et un calendrier"
   ],
   "faq": [
    {
     "q": "À qui s'adresse Ma Petite Ferme ?",
     "a": "Aux petites fermes, éleveurs et producteurs fermiers qui veulent gérer élevage, production et ventes simplement."
    },
    {
     "q": "Faut-il installer un logiciel ?",
     "a": "Non, Ma Petite Ferme fonctionne en ligne depuis un navigateur, sur ordinateur, tablette et mobile."
    },
    {
     "q": "Puis-je essayer gratuitement ?",
     "a": "Oui, une offre gratuite à 0 €/mois vous permet de démarrer immédiatement."
    }
   ]
  },
  "en": {
   "slug": "farm-management-software",
   "title": "Farm Management Software for Small Farms | Ma Petite Ferme",
   "description": "Farm management software: track animals, inventory, customers, orders, invoices & online shop. Easy to use — start your free trial today.",
   "h1": "The simple way to run your whole farm",
   "intro": "Ma Petite Ferme brings everything together in one place — animals, production, inventory, customers, and sales. Built for small farms that want to save time without the complexity of enterprise tools.",
   "bullets": [
    "Keep animals, production records, stock, and documents all in one place",
    "Manage customers, orders, and invoicing with zero double-entry",
    "Track your farm performance with clear stats and a built-in calendar"
   ],
   "faq": [
    {
     "q": "Who is Ma Petite Ferme designed for?",
     "a": "It is built for small farms, livestock keepers, and direct-sale producers who want a straightforward way to manage their animals, production, and sales."
    },
    {
     "q": "Do I need to install anything?",
     "a": "No installation needed. Ma Petite Ferme runs entirely in your browser and works on desktop, tablet, and mobile."
    },
    {
     "q": "Can I try it for free?",
     "a": "Yes, a free plan at $0/month lets you get started right away with no credit card required."
    }
   ]
  },
  "it": {
   "slug": "software-gestione-fattoria",
   "title": "Software gestione fattoria tutto-in-uno | Ma Petite Ferme",
   "description": "Software gestione fattoria: animali, scorte, clienti, ordini, fatture e negozio online. Semplice e intuitivo — prova gratuita subito.",
   "h1": "Il software semplice per gestire tutta la tua fattoria",
   "intro": "Ma Petite Ferme riunisce in un unico strumento la gestione degli animali, delle produzioni, delle scorte, dei clienti e delle vendite. Pensato per le piccole aziende agricole che vogliono risparmiare tempo senza complicarsi la vita.",
   "bullets": [
    "Centralizza animali, produzioni, scorte e documenti in un solo posto",
    "Gestisci clienti, ordini e fatturazione senza reinserire dati",
    "Monitora la tua attività con statistiche chiare e un calendario integrato"
   ],
   "faq": [
    {
     "q": "A chi si rivolge Ma Petite Ferme?",
     "a": "A piccoli agricoltori, allevatori e produttori che vogliono gestire allevamento, produzione e vendite in modo semplice ed efficace."
    },
    {
     "q": "Devo installare un programma sul mio computer?",
     "a": "No, Ma Petite Ferme funziona interamente online dal browser, su computer, tablet e smartphone, senza nessuna installazione."
    },
    {
     "q": "Posso provarlo gratuitamente?",
     "a": "Sì, un piano gratuito a 0 euro al mese ti permette di iniziare subito, senza carta di credito."
    }
   ]
  },
  "nl": {
   "slug": "boerderij-beheersoftware",
   "title": "Boerderij beheersoftware voor kleine bedrijven | Ma Petite Ferme",
   "description": "Boerderij beheersoftware: dieren, voorraden, klanten, bestellingen en facturen in één app. Eenvoudig en snel — probeer gratis.",
   "h1": "De slimme software voor uw kleine boerderij",
   "intro": "Ma Petite Ferme bundelt het beheer van uw dieren, productie, voorraden, klanten en verkopen in één overzichtelijke applicatie. Speciaal ontwikkeld voor kleine boerderijen die tijd willen besparen zonder ingewikkelde systemen.",
   "bullets": [
    "Beheer dieren, producties, voorraden en documenten op één centrale plek",
    "Volg klanten, bestellingen en facturatie zonder dubbele invoer",
    "Stuur uw activiteit met duidelijke statistieken en een praktische agenda"
   ],
   "faq": [
    {
     "q": "Voor wie is Ma Petite Ferme bedoeld?",
     "a": "Voor kleine boerderijen, fokkers en hoeve-producenten die hun veeteelt, productie en verkoop eenvoudig willen beheren."
    },
    {
     "q": "Moet ik software installeren?",
     "a": "Nee, Ma Petite Ferme werkt volledig online via een browser, op computer, tablet en smartphone."
    },
    {
     "q": "Kan ik het gratis uitproberen?",
     "a": "Ja, met ons gratis abonnement van 0 euro per maand kunt u meteen van start gaan, zonder creditcard."
    }
   ]
  },
  "es": {
   "slug": "software-gestion-granja",
   "title": "Software de gestión de granja todo en uno | Ma Petite Ferme",
   "description": "Software de gestión de granja: animales, stock, clientes, pedidos y tienda online. Fácil y completo — prueba gratuita sin compromiso.",
   "h1": "La app sencilla para gestionar tu granja sin complicaciones",
   "intro": "Ma Petite Ferme reúne en una sola herramienta la gestión de tus animales, producciones, inventario, clientes y ventas. Diseñada para pequeñas granjas y ganaderos que quieren ahorrar tiempo sin perderse en pantallas complejas.",
   "bullets": [
    "Centraliza animales, producciones, stock y documentos en un único lugar",
    "Gestiona clientes, pedidos y facturación sin introducir datos dos veces",
    "Toma decisiones con estadísticas claras y un calendario integrado"
   ],
   "faq": [
    {
     "q": "¿Para quién está pensado Ma Petite Ferme?",
     "a": "Para pequeñas granjas, ganaderos y productores rurales que quieren gestionar su cría, producción y ventas de forma sencilla y desde un solo sitio."
    },
    {
     "q": "¿Hay que instalar algún programa?",
     "a": "No, Ma Petite Ferme funciona directamente desde el navegador, sin instalaciones, tanto en ordenador como en tablet o móvil."
    },
    {
     "q": "¿Puedo probarlo gratis?",
     "a": "Sí, existe un plan gratuito a 0 €/mes que te permite empezar de inmediato, sin tarjeta ni compromiso."
    }
   ]
  },
  "de": {
   "slug": "hof-verwaltung-software",
   "title": "Hofverwaltung Software für kleine Betriebe | Ma Petite Ferme",
   "description": "Hofverwaltung Software: Tiere, Bestände, Kunden, Bestellungen und Rechnungen zentral verwalten. Einfach & kostenlos starten mit Ma Petite Ferme.",
   "h1": "Die einfache Software für Ihren landwirtschaftlichen Betrieb",
   "intro": "Ma Petite Ferme vereint Tierhaltung, Produktion, Lagerverwaltung, Kundenpflege und Verkauf in einer einzigen Anwendung. Entwickelt für kleine Höfe und Direktvermarkter, die Zeit sparen wollen – ohne unnötige Komplexität.",
   "bullets": [
    "Tiere, Produktionen, Bestände und Dokumente an einem einzigen Ort verwalten",
    "Kunden, Bestellungen und Rechnungen ohne doppelte Dateneingabe nachverfolgen",
    "Betrieb mit übersichtlichen Statistiken und einem integrierten Kalender steuern"
   ],
   "faq": [
    {
     "q": "Für wen ist Ma Petite Ferme geeignet?",
     "a": "Für kleine landwirtschaftliche Betriebe, Tierhalter und Direktvermarkter, die Tierhaltung, Produktion und Verkauf unkompliziert verwalten möchten."
    },
    {
     "q": "Muss ich eine Software installieren?",
     "a": "Nein, Ma Petite Ferme läuft vollständig im Browser – auf Computer, Tablet und Smartphone, ohne Installation."
    },
    {
     "q": "Kann ich Ma Petite Ferme kostenlos testen?",
     "a": "Ja, mit dem kostenlosen Einstiegsplan für 0 €/Monat können Sie sofort loslegen – ohne Kreditkarte."
    }
   ]
  },
  "sv": {
   "slug": "programvara-gardshantering",
   "title": "Programvara för gårdshantering | Ma Petite Ferme",
   "description": "Gårdshantering samlat på ett ställe: djur, lager, kunder, beställningar och fakturor. Enkelt och smart — prova gratis idag.",
   "h1": "Enkel programvara för hela din gård",
   "intro": "Ma Petite Ferme samlar djurskötsel, produktion, lager, kunder och försäljning i en och samma app. Skapad för små gårdar som vill spara tid utan onödig komplexitet.",
   "bullets": [
    "Håll koll på djur, produktion, lager och dokument på ett ställe",
    "Följ upp kunder, beställningar och fakturering utan dubbelregistrering",
    "Styr verksamheten med tydlig statistik och en överskådlig kalender"
   ],
   "faq": [
    {
     "q": "Vem passar Ma Petite Ferme för?",
     "a": "För små gårdar, djuruppfödare och lokala producenter som vill hantera djurskötsel, produktion och försäljning på ett enkelt sätt."
    },
    {
     "q": "Behöver jag installera något?",
     "a": "Nej, Ma Petite Ferme fungerar direkt i webbläsaren på dator, surfplatta och mobil — ingen installation krävs."
    },
    {
     "q": "Kan jag prova gratis?",
     "a": "Ja, med vårt kostnadsfria abonnemang på 0 kr/månad kan du komma igång direkt utan några förpliktelser."
    }
   ]
  },
  "da": {
   "slug": "landbrugssoftware-lille-gaarde",
   "title": "Landbrugssoftware til små gårde | Ma Petite Ferme",
   "description": "Landbrugssoftware til små gårde: dyr, lager, kunder, ordrer og fakturaer samlet ét sted. Prøv gratis i dag.",
   "h1": "Den enkle løsning til at drive din gård",
   "intro": "Ma Petite Ferme samler styring af dyr, produktion, lager, kunder og salg i én overskuelig app. Udviklet til små gårde og landmænd, der vil spare tid uden komplicerede systemer.",
   "bullets": [
    "Saml dyr, produktion, lager og dokumenter ét centralt sted",
    "Følg kunder, ordrer og fakturering uden dobbeltindtastning",
    "Styr din drift med klare statistikker og en integreret kalender"
   ],
   "faq": [
    {
     "q": "Hvem er Ma Petite Ferme til?",
     "a": "Ma Petite Ferme er til små gårde, opdrættere og lokale producenter, der ønsker en enkel måde at styre dyr, produktion og salg på."
    },
    {
     "q": "Skal jeg installere noget på min computer?",
     "a": "Nej, Ma Petite Ferme kører direkte i browseren og virker på computer, tablet og mobil uden installation."
    },
    {
     "q": "Kan jeg prøve det gratis?",
     "a": "Ja, du kan komme i gang med det samme via vores gratis plan til 0 kr./md. uden kreditkort."
    }
   ]
  },
  "hr": {
   "slug": "softver-upravljanje-farmom",
   "title": "Softver za upravljanje farmom | Ma Petite Ferme",
   "description": "Softver za upravljanje farmom: životinje, zalihe, klijenti, narudžbe, fakture i online trgovina. Jednostavno — isprobajte besplatno.",
   "h1": "Jednostavan softver za vođenje vaše male farme",
   "intro": "Ma Petite Ferme okuplja u jednoj aplikaciji upravljanje životinjama, proizvodnjom, zalihama, klijentima i prodajom. Stvoreno za male farme i uzgajivače koji žele uštediti vrijeme bez kompliciranih alata.",
   "bullets": [
    "Centralizirajte životinje, proizvodnju, zalihe i dokumente na jednom mjestu",
    "Pratite klijente, narudžbe i fakturiranje bez ponovnog unosa podataka",
    "Upravljajte poslovanjem uz jasne statistike i pregledni kalendar"
   ],
   "faq": [
    {
     "q": "Kome je namijenjen Ma Petite Ferme?",
     "a": "Malim farmama, uzgajivačima i seoskim proizvođačima koji žele jednostavno upravljati uzgojem, proizvodnjom i prodajom."
    },
    {
     "q": "Trebam li instalirati softver?",
     "a": "Ne, Ma Petite Ferme radi online putem preglednika, na računalu, tabletu i mobitelu."
    },
    {
     "q": "Mogu li isprobati besplatno?",
     "a": "Da, besplatni plan od 0 €/mjesec omogućuje vam da odmah počnete koristiti aplikaciju."
    }
   ]
  },
  "bg": {
   "slug": "softuer-upravlenie-ferma",
   "title": "Софтуер за управление на ферма | Ma Petite Ferme",
   "description": "Софтуер за ферма: животни, складове, клиенти, поръчки и онлайн магазин в едно. Лесен за ползване — започнете безплатно.",
   "h1": "Управлявайте цялата си ферма с едно просто приложение",
   "intro": "Ma Petite Ferme обединява в една платформа управлението на животните, производството, складовете, клиентите и продажбите ви. Създадено специално за малки ферми, които искат да спестят време без излишна сложност.",
   "bullets": [
    "Животни, продукции, наличности и документи — всичко на едно място",
    "Следете клиенти, поръчки и фактури без повторно въвеждане на данни",
    "Управлявайте дейността си с ясна статистика и удобен календар"
   ],
   "faq": [
    {
     "q": "За кого е подходящ Ma Petite Ferme?",
     "a": "За малки ферми, животновъди и земеделски производители, които искат лесно да управляват отглеждането, производството и продажбите си."
    },
    {
     "q": "Трябва ли да инсталирам нещо?",
     "a": "Не, Ma Petite Ferme работи изцяло онлайн от браузър — на компютър, таблет или смартфон, без инсталация."
    },
    {
     "q": "Мога ли да го пробвам безплатно?",
     "a": "Да, безплатният план на стойност 0 лв/месец ви позволява да започнете веднага, без кредитна карта."
    }
   ]
  },
  "fi": {
   "slug": "maatilan-hallintaohjelmisto",
   "title": "Maatilan hallintaohjelmisto pienille tiloille | Ma Petite Ferme",
   "description": "Maatilan hallintaohjelmisto: eläimet, varastot, asiakkaat, tilaukset ja verkkokauppa yhdessä paikassa. Helppo käyttää — kokeile ilmaiseksi.",
   "h1": "Helppo ohjelmisto koko maatilasi hallintaan",
   "intro": "Ma Petite Ferme kokoaa eläinten, tuotannon, varastojen, asiakkaiden ja myynnin hallinnan yhteen sovellukseen. Suunniteltu pienille tiloille, jotka haluavat säästää aikaa ilman monimutkaisia järjestelmiä.",
   "bullets": [
    "Hallitse eläimiä, tuotantoa, varastoja ja asiakirjoja yhdessä paikassa",
    "Seuraa asiakkaita, tilauksia ja laskutusta ilman kaksinkertaista työtä",
    "Ohjaa toimintaasi selkeillä tilastoilla ja kalenterilla"
   ],
   "faq": [
    {
     "q": "Kenelle Ma Petite Ferme on tarkoitettu?",
     "a": "Pienille maatiloille, kasvattajille ja tilatuottajille, jotka haluavat hallita eläimiä, tuotantoa ja myyntiä helposti."
    },
    {
     "q": "Täytyykö ohjelmisto asentaa?",
     "a": "Ei, Ma Petite Ferme toimii selaimessa verkossa — tietokoneella, tabletilla ja puhelimella."
    },
    {
     "q": "Voinko kokeilla ilmaiseksi?",
     "a": "Kyllä, ilmainen 0 €/kk -paketti antaa sinulle mahdollisuuden aloittaa heti ilman sitoumuksia."
    }
   ]
  },
  "el": {
   "slug": "logismiko-diacheirisis-agroktematos",
   "title": "Λογισμικό διαχείρισης αγροκτήματος | Ma Petite Ferme",
   "description": "Λογισμικό αγροκτήματος: ζώα, αποθέματα, πελάτες, παραγγελίες, τιμολόγια και ηλεκτρονικό κατάστημα. Απλό και εύχρηστο — δοκιμάστε δωρεάν.",
   "h1": "Το απλό λογισμικό για τη διαχείριση ολόκληρης της φάρμας σας",
   "intro": "Το Ma Petite Ferme συγκεντρώνει σε μία εφαρμογή τη διαχείριση ζώων, παραγωγής, αποθεμάτων, πελατών και πωλήσεων. Σχεδιασμένο για μικρές φάρμες που θέλουν να κερδίζουν χρόνο χωρίς περιττές πολυπλοκότητες.",
   "bullets": [
    "Συγκεντρώστε ζώα, παραγωγή, αποθέματα και έγγραφα σε ένα μόνο σημείο",
    "Παρακολουθήστε πελάτες, παραγγελίες και τιμολόγηση χωρίς διπλή καταχώριση",
    "Διαχειριστείτε την επιχείρησή σας με σαφή στατιστικά και ημερολόγιο δραστηριοτήτων"
   ],
   "faq": [
    {
     "q": "Σε ποιους απευθύνεται το Ma Petite Ferme;",
     "a": "Σε μικρές φάρμες, κτηνοτρόφους και αγροτοπαραγωγούς που θέλουν να διαχειρίζονται εκτροφή, παραγωγή και πωλήσεις με απλό τρόπο."
    },
    {
     "q": "Χρειάζεται εγκατάσταση λογισμικού;",
     "a": "Όχι, το Ma Petite Ferme λειτουργεί online μέσω προγράμματος περιήγησης, σε υπολογιστή, tablet και κινητό."
    },
    {
     "q": "Μπορώ να το δοκιμάσω δωρεάν;",
     "a": "Ναι, υπάρχει δωρεάν πρόγραμμα 0 €/μήνα που σας επιτρέπει να ξεκινήσετε αμέσως χωρίς καμία χρέωση."
    }
   ]
  },
  "et": {
   "slug": "taluhalduse-tarkvara",
   "title": "Taluhalduse tarkvara väikestele farmidele | Ma Petite Ferme",
   "description": "Taluhalduse tarkvara: loomad, laod, kliendid, tellimused, arved ja e-pood ühes kohas. Lihtne ja tõhus — proovi tasuta.",
   "h1": "Lihtne tarkvara kogu talu haldamiseks",
   "intro": "Ma Petite Ferme koondab ühte rakendusse loomade, toodangu, laovarude, klientide ja müügi haldamise. Loodud väikestele taludele, kes soovivad säästa aega ilma keeruliste süsteemideta.",
   "bullets": [
    "Hoia loomad, toodang, laod ja dokumendid ühes kohas",
    "Jälgi kliente, tellimusi ja arveid ilma topeltsisestuseta",
    "Juhi oma tegevust selgete statistikate ja kalendri abil"
   ],
   "faq": [
    {
     "q": "Kellele on Ma Petite Ferme mõeldud?",
     "a": "Väikestele taludele, loomakasvatajatele ja talutootjatele, kes soovivad hallata loomi, toodangut ja müüki lihtsalt ning tõhusalt."
    },
    {
     "q": "Kas pean tarkvara installima?",
     "a": "Ei, Ma Petite Ferme töötab veebis otse brauserist — arvutis, tahvelarvutis ja mobiiltelefonis."
    },
    {
     "q": "Kas saan seda tasuta proovida?",
     "a": "Jah, tasuta pakett 0 €/kuus võimaldab sul kohe alustada ilma mingite kulutusteta."
    }
   ]
  },
  "hu": {
   "slug": "gazdasag-iranyito-szoftver",
   "title": "Gazdaságirányító szoftver kisgazdaságoknak | Ma Petite Ferme",
   "description": "Gazdaságirányító szoftver: állatok, készletek, ügyfelek, rendelések, számlák és webáruház egy helyen. Egyszerű — próbáld ki ingyen!",
   "h1": "Az egyszerű szoftver, amivel az egész gazdaságodat kezelheted",
   "intro": "A Ma Petite Ferme egyetlen alkalmazásban egyesíti az állatok, a termelés, a készletek, az ügyfelek és az értékesítés kezelését. Kifejezetten kisgazdaságoknak tervezték, akik időt akarnak spórolni bonyolult rendszerek nélkül.",
   "bullets": [
    "Kezeld az állatokat, a termelést, a készleteket és a dokumentumokat egy helyen",
    "Kövesd nyomon az ügyfeleket, a rendeléseket és a számlázást ismételt adatbevitel nélkül",
    "Irányítsd vállalkozásodat áttekinthető statisztikákkal és naptárral"
   ],
   "faq": [
    {
     "q": "Kinek szól a Ma Petite Ferme?",
     "a": "Kisgazdaságoknak, állattenyésztőknek és termelőknek, akik egyszerűen szeretnék kezelni az állattartást, a termelést és az értékesítést."
    },
    {
     "q": "Kell szoftvert telepíteni?",
     "a": "Nem, a Ma Petite Ferme online működik, bármilyen böngészőből elérhető számítógépen, tableten és okostelefonon is."
    },
    {
     "q": "Ki lehet próbálni ingyen?",
     "a": "Igen, az ingyenes csomag 0 Ft/hó áron azonnal elindítható, regisztráció után rögtön használhatod."
    }
   ]
  },
  "pl": {
   "slug": "oprogramowanie-zarzadzanie-gospodarstwem",
   "title": "Oprogramowanie do zarządzania gospodarstwem | Ma Petite Ferme",
   "description": "Oprogramowanie dla małych gospodarstw: zwierzęta, stany magazynowe, klienci, zamówienia, faktury i sklep online. Proste i skuteczne — wypróbuj za darmo.",
   "h1": "Proste oprogramowanie do prowadzenia całego gospodarstwa",
   "intro": "Ma Petite Ferme łączy w jednej aplikacji zarządzanie zwierzętami, produkcją, magazynem, klientami i sprzedażą. Stworzone z myślą o małych gospodarstwach, które chcą oszczędzać czas bez zbędnych komplikacji.",
   "bullets": [
    "Zarządzaj zwierzętami, produkcją, magazynem i dokumentami w jednym miejscu",
    "Śledź klientów, zamówienia i faktury bez wielokrotnego wprowadzania danych",
    "Kontroluj swoją działalność dzięki przejrzystym statystykom i kalendarzowi"
   ],
   "faq": [
    {
     "q": "Dla kogo jest Ma Petite Ferme?",
     "a": "Dla małych gospodarstw, hodowców i producentów rolnych, którzy chcą prosto zarządzać hodowlą, produkcją i sprzedażą."
    },
    {
     "q": "Czy trzeba instalować oprogramowanie?",
     "a": "Nie, Ma Petite Ferme działa w przeglądarce internetowej — na komputerze, tablecie i smartfonie, bez żadnej instalacji."
    },
    {
     "q": "Czy mogę wypróbować za darmo?",
     "a": "Tak, plan bezpłatny w cenie 0 zł/miesiąc pozwala zacząć natychmiast, bez podawania danych karty."
    }
   ]
  },
  "lt": {
   "slug": "ukio-valdymo-programele",
   "title": "Ūkio valdymo programėlė smulkiems ūkiams | Ma Petite Ferme",
   "description": "Ūkio valdymo programėlė: gyvūnai, atsargos, klientai, užsakymai, sąskaitos ir internetinė parduotuvė. Paprasta ir patogi — išbandyk nemokamai.",
   "h1": "Paprasta programėlė visam jūsų ūkiui valdyti",
   "intro": "Ma Petite Ferme viename įrankyje sujungia gyvūnų, produkcijos, atsargų, klientų ir pardavimų valdymą. Sukurta smulkiems ūkiams, kurie nori taupyti laiką be bereikalingo sudėtingumo.",
   "bullets": [
    "Tvarkykite gyvūnus, produkciją, atsargas ir dokumentus vienoje vietoje",
    "Sekite klientus, užsakymus ir sąskaitas be pakartotinio duomenų įvedimo",
    "Valdykite veiklą su aiškia statistika ir kalendoriumi"
   ],
   "faq": [
    {
     "q": "Kam skirta Ma Petite Ferme?",
     "a": "Smulkiems ūkiams, augintojams ir ūkininkams, kurie nori paprastai valdyti gyvulininkystę, produkciją ir pardavimus."
    },
    {
     "q": "Ar reikia diegti programą?",
     "a": "Ne, Ma Petite Ferme veikia internete per naršyklę — kompiuteryje, planšetėje ar telefone."
    },
    {
     "q": "Ar galima išbandyti nemokamai?",
     "a": "Taip, nemokamas planas už 0 €/mėn. leidžia pradėti iš karto be jokių įsipareigojimų."
    }
   ]
  },
  "lv": {
   "slug": "saimniecibas-parvaldibas-programmatra",
   "title": "Saimniecības pārvaldības programmatūra mazajiem saimniekiem | Ma Petite Ferme",
   "description": "Saimniecības pārvaldība vienā rīkā: dzīvnieki, krājumi, klienti, pasūtījumi un rēķini. Vienkārši un ērti — izmēģini bez maksas.",
   "h1": "Vienkāršs rīks visas saimniecības pārvaldībai",
   "intro": "Ma Petite Ferme apvieno vienā lietotnē dzīvnieku uzskaiti, ražošanu, krājumu kontroli, klientus un pārdošanu. Radīts mazajām saimniecībām, kas vēlas ietaupīt laiku bez liekas sarežģītības.",
   "bullets": [
    "Centralizē dzīvniekus, ražošanu, krājumus un dokumentus vienā vietā",
    "Seko klientiem, pasūtījumiem un rēķiniem bez atkārtotas datu ievades",
    "Pārrauga saimniecību ar skaidrām statistikām un ērtu kalendāru"
   ],
   "faq": [
    {
     "q": "Kam paredzēts Ma Petite Ferme?",
     "a": "Mazajām saimniecībām, lopkopjiem un lauku ražotājiem, kas vēlas vienkārši pārvaldīt lopu audzēšanu, ražošanu un pārdošanu."
    },
    {
     "q": "Vai nepieciešams instalēt programmu?",
     "a": "Nē, Ma Petite Ferme darbojas tiešsaistē caur pārlūkprogrammu — datorā, planšetē vai mobilajā tālrunī."
    },
    {
     "q": "Vai varu izmēģināt bez maksas?",
     "a": "Jā, bezmaksas plāns par 0 €/mēnesī ļauj sākt uzreiz bez jebkādām saistībām."
    }
   ]
  },
  "ro": {
   "slug": "software-gestionare-ferma",
   "title": "Software gestionare fermă mică | Ma Petite Ferme",
   "description": "Software gestionare fermă: animale, stocuri, clienți, comenzi și facturi într-o singură aplicație. Simplu și eficient — încearcă gratuit.",
   "h1": "Aplicația simplă pentru ferma ta mică",
   "intro": "Ma Petite Ferme reunește într-o singură platformă tot ce ai nevoie: gestionarea animalelor, a producției, a stocurilor, a clienților și a vânzărilor. Creat special pentru fermieri care vor să economisească timp fără să se piardă în programe complicate.",
   "bullets": [
    "Centralizează animale, producție, stocuri și documente într-un singur loc",
    "Urmărește clienți, comenzi și facturi fără să introduci datele de mai multe ori",
    "Monitorizează activitatea fermei cu statistici clare și un calendar integrat"
   ],
   "faq": [
    {
     "q": "Cui se adresează Ma Petite Ferme?",
     "a": "Fermierilor mici, crescătorilor de animale și producătorilor locali care doresc să gestioneze simplu creșterea animalelor, producția și vânzările."
    },
    {
     "q": "Trebuie să instalez ceva pe calculator?",
     "a": "Nu, Ma Petite Ferme funcționează 100% online din orice browser, pe calculator, tabletă sau telefon."
    },
    {
     "q": "Pot testa aplicația gratuit?",
     "a": "Da, oferta gratuită la 0 lei/lună îți permite să începi imediat, fără card bancar."
    }
   ]
  },
  "pt": {
   "slug": "software-gestao-pequena-fazenda",
   "title": "Software de gestão de fazenda para pequenos produtores | Ma Petite Ferme",
   "description": "Gestão de fazenda completa: animais, estoques, clientes, pedidos e loja online. Simples e eficiente — experimente grátis hoje mesmo.",
   "h1": "Gerencie sua pequena fazenda com simplicidade",
   "intro": "Ma Petite Ferme reúne em um único aplicativo tudo o que você precisa: animais, produções, estoques, clientes e vendas. Feito para pequenos produtores e criadores que querem organizar o dia a dia sem complicação.",
   "bullets": [
    "Centralize animais, produções, estoques e documentos em um só lugar",
    "Acompanhe clientes, pedidos e faturamento sem retrabalho",
    "Tome decisões melhores com estatísticas claras e calendário integrado"
   ],
   "faq": [
    {
     "q": "Para quem é indicado o Ma Petite Ferme?",
     "a": "Para pequenos fazendeiros, criadores e produtores rurais que desejam gerenciar criação, produção e vendas de forma simples e eficiente."
    },
    {
     "q": "Preciso instalar algum programa no computador?",
     "a": "Não, o Ma Petite Ferme funciona totalmente online pelo navegador, em computador, tablet ou celular, sem instalação necessária."
    },
    {
     "q": "Posso testar gratuitamente antes de assinar?",
     "a": "Sim, há um plano gratuito a 0 reais por mês que permite começar imediatamente, sem compromisso."
    }
   ]
  },
  "sk": {
   "slug": "software-na-spravu-farmy",
   "title": "Softvér na správu farmy pre malých farmárov | Ma Petite Ferme",
   "description": "Softvér na správu farmy: zvieratá, sklady, klienti, objednávky a faktúry na jednom mieste. Jednoduchý nástroj — vyskúšajte zadarmo.",
   "h1": "Jednoduchý softvér pre vašu malú farmu",
   "intro": "Ma Petite Ferme združuje správu zvierat, výroby, skladov, zákazníkov aj predaja v jedinej aplikácii. Navrhnutý pre malé farmy, ktoré chcú ušetriť čas bez zbytočnej zložitosti.",
   "bullets": [
    "Zvieratá, produkcia, zásoby aj dokumenty prehľadne na jednom mieste",
    "Sledujte zákazníkov, objednávky a faktúry bez opakovaného zadávania údajov",
    "Riaďte svoju farmu pomocou prehľadných štatistík a integrovaného kalendára"
   ],
   "faq": [
    {
     "q": "Pre koho je Ma Petite Ferme určená?",
     "a": "Pre malých farmárov, chovateľov a roľníkov, ktorí chcú jednoducho spravovať chov, výrobu aj predaj."
    },
    {
     "q": "Musím si niečo inštalovať?",
     "a": "Nie, Ma Petite Ferme funguje online priamo v prehliadači — na počítači, tablete aj mobile."
    },
    {
     "q": "Môžem to vyskúšať zadarmo?",
     "a": "Áno, bezplatný plán za 0 €/mesiac vám umožní začať okamžite bez viazanosti."
    }
   ]
  },
  "sl": {
   "slug": "programska-oprema-upravljanje-kmetije",
   "title": "Programska oprema za upravljanje kmetije | Ma Petite Ferme",
   "description": "Upravljanje kmetije vse v enem: živali, zaloge, stranke, naročila, računi in spletna trgovina. Preprosto — brezplačni preizkus.",
   "h1": "Preprosta rešitev za upravljanje vaše kmetije",
   "intro": "Ma Petite Ferme v eni aplikaciji združuje upravljanje živali, pridelkov, zalog, strank in prodaje. Ustvarjeno za male kmetije, ki želijo prihraniti čas brez nepotrebnih zapletov.",
   "bullets": [
    "Centralizirajte živali, pridelke, zaloge in dokumente na enem mestu",
    "Sledite strankam, naročilom in računom brez ponovnega vnašanja podatkov",
    "Vodite svoje poslovanje z jasnimi statistikami in preglednim koledarjem"
   ],
   "faq": [
    {
     "q": "Komu je Ma Petite Ferme namenjena?",
     "a": "Malim kmetijam, rejcem in kmečkim pridelovalcem, ki želijo preprosto upravljati rejo, pridelavo in prodajo."
    },
    {
     "q": "Ali je potrebna namestitev programske opreme?",
     "a": "Ne, Ma Petite Ferme deluje v oblaku prek brskalnika, na računalniku, tablici in mobilnem telefonu."
    },
    {
     "q": "Ali lahko preizkusim brezplačno?",
     "a": "Da, brezplačni paket za 0 €/mesec vam omogoča takojšen začetek brez obveznosti."
    }
   ]
  },
  "cs": {
   "slug": "software-pro-spravu-farmy",
   "title": "Software pro správu farmy – zvířata, sklady, objednávky | Ma Petite Ferme",
   "description": "Software pro správu farmy: zvířata, zásoby, zákazníci, objednávky a faktury v jedné aplikaci. Jednoduché a přehledné – vyzkoušejte zdarma.",
   "h1": "Jednoduchý software pro řízení celé vaší farmy",
   "intro": "Ma Petite Ferme spojuje v jediné aplikaci evidenci zvířat, sklady, zákazníky i prodeje – vše na jednom místě. Navrženo pro malé farmy a chovatele, kteří chtějí ušetřit čas bez zbytečné složitosti.",
   "bullets": [
    "Evidujte zvířata, zásoby, produkci a dokumenty přehledně na jednom místě",
    "Sledujte zákazníky, objednávky a faktury bez opakovaného zadávání údajů",
    "Řiďte svůj provoz pomocí přehledných statistik a integrovaného kalendáře"
   ],
   "faq": [
    {
     "q": "Pro koho je Ma Petite Ferme určena?",
     "a": "Pro malé farmy, chovatele a zemědělské výrobce, kteří chtějí jednoduše spravovat chov, produkci i prodej."
    },
    {
     "q": "Je nutné instalovat nějaký program?",
     "a": "Ne, Ma Petite Ferme funguje online přímo v prohlížeči – na počítači, tabletu i mobilním telefonu."
    },
    {
     "q": "Mohu to vyzkoušet zdarma?",
     "a": "Ano, bezplatný plán za 0 €/měsíc vám umožní začít okamžitě a bez závazků."
    }
   ]
  }
 },
 "gestion-elevage": {
  "fr": {
   "slug": "logiciel-gestion-elevage",
   "title": "Logiciel de gestion d'élevage | Ma Petite Ferme",
   "description": "Logiciel de gestion d'élevage : suivi des animaux, santé vétérinaire, reproduction et productions. Multi-espèces, simple, en français — essai gratuit.",
   "h1": "Gérez votre élevage simplement, quelle que soit l'espèce",
   "intro": "Suivez chaque animal ou lot, sa santé, sa reproduction et ses productions dans une application claire. Poules, chèvres, moutons, bovins, lapins, abeilles… Ma Petite Ferme s'adapte à votre élevage.",
   "bullets": [
    "Fiches animaux et lots avec suivi sanitaire et vaccinations",
    "Enregistrez productions (œufs, lait, miel…) et suivez les rendements",
    "Planifiez saillies, mises bas et interventions au bon moment"
   ],
   "faq": [
    {
     "q": "Quelles espèces sont gérées ?",
     "a": "Volailles, caprins, ovins, bovins, porcins, lapins et apiculture, entre autres."
    },
    {
     "q": "Puis-je suivre la santé de mes animaux ?",
     "a": "Oui, vaccinations, traitements et évènements sanitaires sont enregistrés par animal ou par lot."
    },
    {
     "q": "Est-ce adapté aux petits élevages ?",
     "a": "Oui, l'outil est conçu pour rester simple pour les petites fermes et éleveurs."
    }
   ]
  },
  "en": {
   "slug": "livestock-management-software",
   "title": "Livestock Management Software for Small Farms | Ma Petite Ferme",
   "description": "Livestock management software: track animals, health records, breeding & production. Multi-species, easy to use — start your free trial today.",
   "h1": "Manage Your Livestock with Ease, Whatever the Species",
   "intro": "Keep track of every animal or group, their health, breeding cycles, and daily production in one straightforward app. From chickens and goats to bees and cattle, Ma Petite Ferme adapts to your operation.",
   "bullets": [
    "Individual and group animal profiles with health records and vaccination tracking",
    "Log daily production (eggs, milk, honey…) and monitor your yields over time",
    "Schedule breeding, births, and vet interventions so nothing slips through the cracks"
   ],
   "faq": [
    {
     "q": "Which species does the software support?",
     "a": "Poultry, goats, sheep, cattle, pigs, rabbits, and honeybees are all supported, among others."
    },
    {
     "q": "Can I track the health of my animals?",
     "a": "Absolutely. Vaccinations, treatments, and health events can be logged per individual animal or per group."
    },
    {
     "q": "Is it suitable for small-scale livestock keepers?",
     "a": "Yes, Ma Petite Ferme is built to stay simple and practical for small farms and hobby breeders alike."
    }
   ]
  },
  "es": {
   "slug": "software-gestion-ganaderia",
   "title": "Software de gestión ganadera para pequeñas granjas | Ma Petite Ferme",
   "description": "Gestión ganadera: control de animales, salud veterinaria, reproducción y producción. Multiespecies, fácil de usar — prueba gratuita.",
   "h1": "Lleva tu granja al día, sin importar la especie",
   "intro": "Controla cada animal o lote, su salud, reproducción y producción desde una sola aplicación sencilla y visual. Gallinas, cabras, ovejas, vacas, conejos, abejas… Ma Petite Ferme se adapta a tu ganadería.",
   "bullets": [
    "Fichas de animales y lotes con seguimiento sanitario y vacunaciones",
    "Registra producciones (huevos, leche, miel…) y analiza rendimientos fácilmente",
    "Planifica cubriciones, partos e intervenciones en el momento justo"
   ],
   "faq": [
    {
     "q": "¿Qué especies puedo gestionar?",
     "a": "Aves de corral, caprinos, ovinos, bovinos, porcinos, conejos y apicultura, entre otras."
    },
    {
     "q": "¿Puedo hacer un seguimiento de la salud de mis animales?",
     "a": "Sí, vacunaciones, tratamientos y eventos sanitarios quedan registrados por animal o por lote."
    },
    {
     "q": "¿Es adecuado para pequeñas explotaciones?",
     "a": "Sí, Ma Petite Ferme está diseñado para ser simple y práctico en granjas y ganaderías a pequeña escala."
    }
   ]
  },
  "it": {
   "slug": "software-gestione-allevamento",
   "title": "Software gestione allevamento: animali, salute e produzioni | Ma Petite Ferme",
   "description": "Software gestione allevamento: schede animali, salute veterinaria, riproduzione e produzioni. Multi-specie, semplice e intuitivo — prova gratuita.",
   "h1": "Gestisci il tuo allevamento in modo semplice, qualunque sia la specie",
   "intro": "Tieni traccia di ogni animale o lotto, della sua salute, riproduzione e produzioni in un'unica app chiara e intuitiva. Galline, capre, pecore, bovini, conigli, api… Ma Petite Ferme si adatta al tuo allevamento.",
   "bullets": [
    "Schede animali e lotti con monitoraggio sanitario e vaccinazioni",
    "Registra le produzioni (uova, latte, miele…) e tieni sotto controllo i rendimenti",
    "Pianifica monti, parti e interventi veterinari al momento giusto"
   ],
   "faq": [
    {
     "q": "Quali specie animali sono supportate?",
     "a": "Pollame, caprini, ovini, bovini, suini, conigli e apicoltura, tra le altre specie."
    },
    {
     "q": "Posso monitorare la salute dei miei animali?",
     "a": "Sì, vaccinazioni, trattamenti ed eventi sanitari vengono registrati per singolo animale o per lotto."
    },
    {
     "q": "Il software è adatto ai piccoli allevamenti?",
     "a": "Assolutamente sì, lo strumento è pensato per restare semplice e accessibile per piccole fattorie e allevatori."
    }
   ]
  },
  "de": {
   "slug": "tierhaltung-software-kleinbetrieb",
   "title": "Tierhaltung Software für kleine Betriebe | Ma Petite Ferme",
   "description": "Tierhaltung Software: Tierakten, Gesundheit, Zucht und Produktion verwalten. Mehrere Tierarten, einfach und übersichtlich — jetzt kostenlos testen.",
   "h1": "Ihren Tierbestand einfach im Griff — egal welche Tierart",
   "intro": "Verwalten Sie jedes Tier oder jede Gruppe mit allen wichtigen Daten zu Gesundheit, Zucht und Produktion in einer übersichtlichen App. Hühner, Ziegen, Schafe, Rinder, Kaninchen, Bienen… Ma Petite Ferme passt sich Ihrem Betrieb an.",
   "bullets": [
    "Tierakten und Gruppenprofile mit Impf- und Gesundheitsprotokoll",
    "Produktionsmengen erfassen (Eier, Milch, Honig…) und Erträge auswerten",
    "Deckvorgänge, Geburten und tierärztliche Eingriffe rechtzeitig planen"
   ],
   "faq": [
    {
     "q": "Welche Tierarten werden unterstützt?",
     "a": "Geflügel, Ziegen, Schafe, Rinder, Schweine, Kaninchen und Bienen — unter anderem."
    },
    {
     "q": "Kann ich die Gesundheit meiner Tiere verfolgen?",
     "a": "Ja, Impfungen, Behandlungen und Gesundheitsereignisse werden pro Tier oder Gruppe erfasst und dokumentiert."
    },
    {
     "q": "Ist die Software für kleine Höfe geeignet?",
     "a": "Ja, Ma Petite Ferme wurde speziell für Kleinbetriebe und Hobbyhalter entwickelt — einfach und ohne Einarbeitungsaufwand."
    }
   ]
  },
  "nl": {
   "slug": "software-veebeheer-kleine-boerderij",
   "title": "Veebeheer software voor kleine boerderijen | Ma Petite Ferme",
   "description": "Veebeheer software: dieren volgen, diergezondheid, fokkerij en productie bijhouden. Meerdere diersoorten, eenvoudig — probeer gratis.",
   "h1": "Beheer uw veestapel eenvoudig, voor elke diersoort",
   "intro": "Volg elk dier of elke koppel op het vlak van gezondheid, voortplanting en productie in één overzichtelijke app. Van kippen en geiten tot schapen, runderen, konijnen en bijen — Ma Petite Ferme past zich aan uw bedrijf aan.",
   "bullets": [
    "Dierfiches en koppels met sanitaire opvolging en vaccinaties",
    "Registreer producties (eieren, melk, honing…) en bewaak uw rendementen",
    "Plan dekkingen, geboorten en ingrepen op het juiste moment"
   ],
   "faq": [
    {
     "q": "Welke diersoorten worden ondersteund?",
     "a": "Pluimvee, geiten, schapen, runderen, varkens, konijnen en bijen, en nog veel meer."
    },
    {
     "q": "Kan ik de gezondheid van mijn dieren bijhouden?",
     "a": "Ja, vaccinaties, behandelingen en gezondheidsevenementen worden per dier of per koppel geregistreerd."
    },
    {
     "q": "Is dit geschikt voor kleine boerderijen?",
     "a": "Zeker, de tool is speciaal ontworpen om eenvoudig en overzichtelijk te blijven voor kleine boeren en hobbyhouders."
    }
   ]
  },
  "sv": {
   "slug": "programvara-djurhantering-lantbruk",
   "title": "Djurhanteringsprogram för småbruk | Ma Petite Ferme",
   "description": "Djurhanteringsprogram: spåra djur, hälsa, reproduktion och produktion. Flera djurslag, enkelt att använda — starta gratis idag.",
   "h1": "Hantera ditt lantbruk enkelt – oavsett djurslag",
   "intro": "Håll koll på varje djur eller grupp, deras hälsa, reproduktion och produktion i en överskådlig app. Höns, getter, får, nötkreatur, kaniner, bin… Ma Petite Ferme anpassas till just ditt lantbruk.",
   "bullets": [
    "Djurprofiler och grupper med hälsouppföljning och vaccinationer",
    "Registrera produktion (ägg, mjölk, honung…) och följ upp avkastning",
    "Planera betäckning, förlossningar och ingrepp i rätt tid"
   ],
   "faq": [
    {
     "q": "Vilka djurslag stöds?",
     "a": "Fjäderfä, getter, får, nötkreatur, grisar, kaniner och bin – bland annat."
    },
    {
     "q": "Kan jag följa mina djurs hälsa?",
     "a": "Ja, vaccinationer, behandlingar och hälsohändelser registreras per djur eller grupp."
    },
    {
     "q": "Passar programmet för små gårdar?",
     "a": "Absolut, verktyget är utformat för att vara enkelt och överskådligt för småbrukare och hobbyodlare."
    }
   ]
  },
  "da": {
   "slug": "software-til-dyrehold-styring",
   "title": "Dyreholdstyring til små landbrug | Ma Petite Ferme",
   "description": "Dyreholdstyring: spor dyr, sundhed, avl og produktion. Flerarts-app, enkel og overskuelig – prøv gratis i dag.",
   "h1": "Styr dit dyrehold nemt – uanset art",
   "intro": "Hold styr på hvert dyr eller hold, deres sundhed, avl og daglig produktion i én overskuelig app. Fra høns og geder til kvæg og bier – Ma Petite Ferme tilpasser sig dit landbrug.",
   "bullets": [
    "Dyreoversigt og holdkort med sundhedsjournal og vaccinationer",
    "Registrer produktion (æg, mælk, honning…) og følg udbyttet over tid",
    "Planlæg parringer, fødsel og veterinære indgreb på det rette tidspunkt"
   ],
   "faq": [
    {
     "q": "Hvilke dyrearter understøttes?",
     "a": "Fjerkræ, geder, får, kvæg, svin, kaniner og bier – samt flere andre arter."
    },
    {
     "q": "Kan jeg følge mine dyrs sundhed løbende?",
     "a": "Ja, vaccinationer, behandlinger og sundhedshændelser registreres pr. dyr eller hold."
    },
    {
     "q": "Passer appen til et lille dyrehold?",
     "a": "Ja, Ma Petite Ferme er designet til at forblive enkel og overskuelig for små landbrug og dyreholdere."
    }
   ]
  },
  "bg": {
   "slug": "softuer-upravlenie-zhivotnovadstvo",
   "title": "Софтуер за управление на животновъдство | Ma Petite Ferme",
   "description": "Животновъдски софтуер: следене на животни, здраве, размножаване и продукции. Мулти-видов, лесен за използване — безплатен пробен период.",
   "h1": "Управлявайте фермата си лесно, независимо от вида животни",
   "intro": "Следете всяко животно или група, тяхното здраве, размножаване и продукции в едно удобно приложение. Кокошки, кози, овце, крави, зайци, пчели… Ma Petite Ferme се адаптира към вашето животновъдство.",
   "bullets": [
    "Досиета на животни и групи със здравно наблюдение и ваксинации",
    "Записвайте продукции (яйца, мляко, мед…) и следете добивите",
    "Планирайте чифтосване, раждания и ветеринарни интервенции навреме"
   ],
   "faq": [
    {
     "q": "Кои видове животни се поддържат?",
     "a": "Птици, кози, овце, едър рогат добитък, свине, зайци и пчелини, наред с други."
    },
    {
     "q": "Мога ли да следя здравето на животните си?",
     "a": "Да, ваксинации, лечения и здравни събития се записват за всяко животно или група поотделно."
    },
    {
     "q": "Подходящо ли е за малки ферми?",
     "a": "Да, инструментът е създаден да остане прост и достъпен за малки ферми и животновъди."
    }
   ]
  },
  "hr": {
   "slug": "softver-upravljanje-stocarstvom",
   "title": "Softver za upravljanje stočarstvom | Ma Petite Ferme",
   "description": "Upravljanje stočarstvom: praćenje životinja, zdravlje, rasplod i proizvodnja. Viševrstan, jednostavan, besplatno isprobajte.",
   "h1": "Vodite svoju farmu jednostavno, bez obzira na vrstu stoke",
   "intro": "Pratite svaku životinju ili skupinu, njezino zdravlje, rasplod i production u jednoj preglednoj aplikaciji. Kokoši, koze, ovce, goveda, kunići, pčele… Ma Petite Ferme prilagođava se vašoj farmi.",
   "bullets": [
    "Kartice životinja i skupina s praćenjem zdravlja i cijepljenja",
    "Bilježite proizvodnju (jaja, mlijeko, med…) i pratite prinose",
    "Planirajte parenja, okote i veterinarske intervencije u pravo vrijeme"
   ],
   "faq": [
    {
     "q": "Koje vrste stoke su podržane?",
     "a": "Perad, kozarstvo, ovčarstvo, govedarstvo, svinjogojstvo, kunićarstvo i pčelarstvo, između ostalog."
    },
    {
     "q": "Mogu li pratiti zdravlje svojih životinja?",
     "a": "Da, cijepljenja, tretmani i zdravstveni događaji bilježe se po životinji ili skupini."
    },
    {
     "q": "Je li alat prikladan za male farme?",
     "a": "Da, alat je osmišljen da ostane jednostavan za male farme i uzgajivače."
    }
   ]
  },
  "el": {
   "slug": "logismiko-diacheirisis-ktinotrophias",
   "title": "Λογισμικό διαχείρισης κτηνοτροφίας | Ma Petite Ferme",
   "description": "Λογισμικό κτηνοτροφίας: παρακολούθηση ζώων, κτηνιατρική υγεία, αναπαραγωγή και παραγωγές. Πολλά είδη, απλό — δοκιμάστε δωρεάν.",
   "h1": "Διαχειριστείτε την κτηνοτροφία σας εύκολα, ανεξαρτήτως είδους",
   "intro": "Παρακολουθήστε κάθε ζώο ή ομάδα, την υγεία, την αναπαραγωγή και τις παραγωγές του σε μια ξεκάθαρη εφαρμογή. Κότες, κατσίκες, πρόβατα, βοοειδή, κουνέλια, μέλισσες… το Ma Petite Ferme προσαρμόζεται στη δική σας εκτροφή.",
   "bullets": [
    "Ατομικά δελτία ζώων και ομάδων με υγειονομική παρακολούθηση και εμβολιασμούς",
    "Καταγράψτε παραγωγές (αυγά, γάλα, μέλι…) και παρακολουθήστε τις αποδόσεις",
    "Προγραμματίστε οχείες, τοκετούς και κτηνιατρικές παρεμβάσεις την κατάλληλη στιγμή"
   ],
   "faq": [
    {
     "q": "Ποια είδη ζώων υποστηρίζονται;",
     "a": "Πτηνά, αιγοειδή, προβατοειδή, βοοειδή, χοιροειδή, κουνέλια και μέλισσες, μεταξύ άλλων."
    },
    {
     "q": "Μπορώ να παρακολουθώ την υγεία των ζώων μου;",
     "a": "Ναι, εμβολιασμοί, θεραπείες και υγειονομικά συμβάντα καταγράφονται ανά ζώο ή ανά ομάδα."
    },
    {
     "q": "Είναι κατάλληλο για μικρές εκτροφές;",
     "a": "Ναι, το εργαλείο έχει σχεδιαστεί για να παραμένει απλό για μικρές φάρμες και κτηνοτρόφους."
    }
   ]
  },
  "et": {
   "slug": "loomakasvatus-tarkvara",
   "title": "Loomakasvatuse tarkvara väikefarmidele | Ma Petite Ferme",
   "description": "Loomakasvatuse tarkvara: loomade jälgimine, veterinaaria, sigimine ja toodang. Mitme liigiga, lihtne — proovi tasuta.",
   "h1": "Halda oma farmi loomi lihtsalt ja tõhusalt",
   "intro": "Jälgi iga looma või karja tervist, sigimist ja toodangut ühes selges rakenduses. Kanad, kitsed, lambad, veised, küülikud, mesilased… Ma Petite Ferme kohandub sinu farmiga.",
   "bullets": [
    "Loomade ja karjade kaardid koos tervise- ja vaktsineerimisandmetega",
    "Registreeri toodang (munad, piim, mesi…) ja jälgi saagikust",
    "Planeeri paaritused, pojad ja veterinaarsed sekkumised õigel ajal"
   ],
   "faq": [
    {
     "q": "Milliseid loomaliike saab hallata?",
     "a": "Kodulinnud, kitsed, lambad, veised, sead, küülikud ja mesilased, teiste hulgas."
    },
    {
     "q": "Kas saan jälgida oma loomade tervist?",
     "a": "Jah, vaktsineerimised, ravimid ja terviseandmed registreeritakse iga looma või karja kohta eraldi."
    },
    {
     "q": "Kas see sobib väikestele farmidele?",
     "a": "Jah, Ma Petite Ferme on loodud olema lihtne ja kasutatav just väikeste farmide ja kasvatajate jaoks."
    }
   ]
  },
  "hu": {
   "slug": "allattartas-gazdasag-szoftver",
   "title": "Állattartás-kezelő szoftver kisgazdaságoknak | Ma Petite Ferme",
   "description": "Állattartás szoftver: állatnyilvántartás, egészségügyi napló, szaporodás és hozamkövetés. Több faj, egyszerű használat — ingyenes próba.",
   "h1": "Kezelje állatait egyszerűen, fajtától függetlenül",
   "intro": "Kövesse nyomon minden állatát vagy csoportját: egészségi állapotát, szaporodását és termelési adatait egyetlen áttekinthető alkalmazásban. Tyúkok, kecskék, juhok, szarvasmarhák, nyulak, méhek… a Ma Petite Ferme az Ön gazdaságához igazodik.",
   "bullets": [
    "Egyedi állatkartonok és csoportok egészségügyi és oltási naplóval",
    "Rögzítse a termelést (tojás, tej, méz…) és kövesse a hozamokat",
    "Tervezze meg a fedeztetést, ellést és beavatkozásokat időben"
   ],
   "faq": [
    {
     "q": "Milyen állatfajokat lehet kezelni?",
     "a": "Baromfi, kecske, juh, szarvasmarha, sertés, nyúl és méhészet — és még sok más faj is kezelhető."
    },
    {
     "q": "Nyomon követhetem az állataim egészségi állapotát?",
     "a": "Igen, az oltások, kezelések és egészségügyi események egyedenként vagy csoportonként rögzíthetők."
    },
    {
     "q": "Kisgazdaságoknak is megfelelő az eszköz?",
     "a": "Igen, a Ma Petite Ferme kifejezetten kis gazdaságok és hobbifarmok számára lett tervezve, egyszerű és átlátható kezeléssel."
    }
   ]
  },
  "fi": {
   "slug": "kotielain-hallintaohjelmisto",
   "title": "Kotieläinten hallintaohjelmisto pienille tiloille | Ma Petite Ferme",
   "description": "Kotieläinten hallinta helposti: eläinseuranta, eläinlääkintä, lisääntyminen ja tuotanto. Monilajinen, selkeä sovellus — kokeile ilmaiseksi.",
   "h1": "Hallitse eläintilasi helposti, lajista riippumatta",
   "intro": "Seuraa jokaista eläintä tai partta, sen terveyttä, lisääntymistä ja tuotantoa yhdessä selkeässä sovelluksessa. Kanat, vuohet, lampaat, naudat, kanit, mehiläiset… Ma Petite Ferme sopeutuu tilaasi.",
   "bullets": [
    "Eläin- ja parttikortit terveys- ja rokotusseurannalla",
    "Kirjaa tuotannot (munat, maito, hunaja…) ja seuraa saantoja",
    "Suunnittele astutukset, poikimiset ja toimenpiteet oikeaan aikaan"
   ],
   "faq": [
    {
     "q": "Mitä eläinlajeja ohjelmisto tukee?",
     "a": "Siipikarja, vuohet, lampaat, naudat, siat, kanit ja mehiläishoito, muiden muassa."
    },
    {
     "q": "Voinko seurata eläinteni terveyttä?",
     "a": "Kyllä, rokotukset, hoidot ja terveystapahtumat kirjataan eläin- tai parttitasolla."
    },
    {
     "q": "Sopiiko tämä pienille tiloille?",
     "a": "Kyllä, työkalu on suunniteltu pysymään yksinkertaisena pienille tiloille ja kasvattajille."
    }
   ]
  },
  "pl": {
   "slug": "oprogramowanie-zarzadzania-hodowla",
   "title": "Oprogramowanie do zarządzania hodowlą zwierząt | Ma Petite Ferme",
   "description": "Zarządzanie hodowlą online: kartoteki zwierząt, zdrowie, reprodukcja i produkcja. Wiele gatunków, proste w obsłudze — wypróbuj za darmo.",
   "h1": "Zarządzaj swoją hodowlą łatwo, niezależnie od gatunku",
   "intro": "Śledź każde zwierzę lub grupę, ich zdrowie, rozród i produkcję w jednej przejrzystej aplikacji. Kury, kozy, owce, bydło, króliki, pszczoły… Ma Petite Ferme dopasowuje się do Twojej hodowli.",
   "bullets": [
    "Kartoteki zwierząt i grup z rejestrem weterynaryjnym i szczepieniami",
    "Rejestruj produkcję (jaja, mleko, miód…) i monitoruj wydajność",
    "Planuj krycia, porody i interwencje weterynaryjne w odpowiednim czasie"
   ],
   "faq": [
    {
     "q": "Jakie gatunki są obsługiwane?",
     "a": "Drób, kozy, owce, bydło, trzoda chlewna, króliki i pszczoły — to tylko niektóre z obsługiwanych gatunków."
    },
    {
     "q": "Czy mogę śledzić stan zdrowia moich zwierząt?",
     "a": "Tak, szczepienia, leczenie i zdarzenia sanitarne są rejestrowane dla każdego zwierzęcia lub grupy."
    },
    {
     "q": "Czy aplikacja nadaje się dla małych hodowli?",
     "a": "Tak, narzędzie zostało zaprojektowane tak, aby pozostać proste i dostępne dla małych farm i hodowców."
    }
   ]
  },
  "lv": {
   "slug": "lopkopibas-parvaldibas-programma",
   "title": "Lopkopības pārvaldības programma mazajām saimniecībām | Ma Petite Ferme",
   "description": "Lopkopības programma: dzīvnieku uzskaite, veselība, vairošanās un produkcija. Vairākas sugas, vienkārša lietošana — izmēģini bez maksas.",
   "h1": "Pārvaldi savu saimniecību vienkārši — jebkurai sugai",
   "intro": "Seko katram dzīvniekam vai ganāmpulkam — tā veselībai, vairošanās ciklam un produkcijai vienā pārskatāmā lietotnē. Vistas, kazas, aitas, liellopi, truši, bites… Ma Petite Ferme pielāgojas tieši tavai saimniecībai.",
   "bullets": [
    "Dzīvnieku un ganāmpulku kartiņas ar veselības uzskaiti un vakcinācijām",
    "Reģistrē produkciju (olas, piens, medus…) un seko ražīgumam",
    "Plāno pārošanos, atnešanos un veterinārās iejaukšanās savlaicīgi"
   ],
   "faq": [
    {
     "q": "Kādas dzīvnieku sugas ir atbalstītas?",
     "a": "Putni, kazas, aitas, liellopi, cūkas, truši un bites — un ne tikai."
    },
    {
     "q": "Vai varu sekot savu dzīvnieku veselībai?",
     "a": "Jā, vakcinācijas, ārstēšanas un veselības notikumi tiek reģistrēti katram dzīvniekam vai ganāmpulkam atsevišķi."
    },
    {
     "q": "Vai programma ir piemērota mazām saimniecībām?",
     "a": "Jā, rīks ir īpaši veidots, lai paliktu vienkāršs mazajiem lopkopjiem un saimniecībām."
    }
   ]
  },
  "pt": {
   "slug": "software-gestao-criacao-animais",
   "title": "Software de gestão de criação animal | Ma Petite Ferme",
   "description": "Gestão de criação animal: acompanhe saúde, reprodução e produção dos seus animais. Multiespecies, simples e gratuito para testar.",
   "h1": "Gerencie sua criação com facilidade, qualquer que seja o animal",
   "intro": "Acompanhe cada animal ou lote, sua saúde, reprodução e produção em um aplicativo intuitivo e completo. Galinhas, cabras, ovelhas, bovinos, coelhos, abelhas… Ma Petite Ferme se adapta à sua realidade.",
   "bullets": [
    "Fichas de animais e lotes com controle sanitário e vacinação",
    "Registre produções (ovos, leite, mel…) e acompanhe o rendimento",
    "Planeje coberturas, partos e intervenções no momento certo"
   ],
   "faq": [
    {
     "q": "Quais espécies são suportadas?",
     "a": "Aves, caprinos, ovinos, bovinos, suínos, coelhos e apicultura, entre outras espécies."
    },
    {
     "q": "Posso acompanhar a saúde dos meus animais?",
     "a": "Sim, vacinas, tratamentos e eventos sanitários são registrados por animal ou por lote, de forma simples e organizada."
    },
    {
     "q": "O software é indicado para pequenas criações?",
     "a": "Sim, a ferramenta foi pensada para ser acessível e prática para pequenos criadores e agricultores familiares."
    }
   ]
  },
  "lt": {
   "slug": "ukio-gyvuliu-valdymo-programele",
   "title": "Gyvulių valdymo programėlė smulkiems ūkiams | Ma Petite Ferme",
   "description": "Gyvulių valdymo programėlė: gyvūnų stebėjimas, sveikata, veisimas ir produkcija. Daugiarūšė, paprasta naudoti — išbandykite nemokamai.",
   "h1": "Valdykite savo ūkio gyvulius paprastai ir efektyviai",
   "intro": "Stebėkite kiekvieną gyvūną ar bandą, jų sveikatą, veisimąsi ir produkciją vienoje aiškioje programėlėje. Vištos, ožkos, avys, galvijai, triušiai, bitės… Ma Petite Ferme prisitaiko prie jūsų ūkio.",
   "bullets": [
    "Gyvūnų ir bandų kortelės su sveikatos stebėjimu ir vakcinacijų įrašais",
    "Fiksuokite produkciją (kiaušinius, pieną, medų…) ir sekite našumą",
    "Planuokite poravimąsi, apsiveršiavimą ir veterinarinius įsikišimus laiku"
   ],
   "faq": [
    {
     "q": "Kokios gyvūnų rūšys palaikomos?",
     "a": "Paukščiai, ožkos, avys, galvijai, kiaulės, triušiai ir bitininkystė — ir tai tik dalis palaikomų rūšių."
    },
    {
     "q": "Ar galiu stebėti savo gyvūnų sveikatą?",
     "a": "Taip, vakcinacijos, gydymas ir sveikatos įvykiai registruojami kiekvienam gyvūnui arba bandai atskirai."
    },
    {
     "q": "Ar programa tinka mažiems ūkiams?",
     "a": "Taip, Ma Petite Ferme sukurta būti paprasta ir patogi smulkiems ūkininkams bei gyvulių augintojams."
    }
   ]
  },
  "ro": {
   "slug": "software-gestiune-ferma-animale",
   "title": "Software gestiune animale pentru ferme mici | Ma Petite Ferme",
   "description": "Gestiune animale de fermă: sănătate, reproducere, producții. Multi-specii, simplu de folosit, pentru ferme mici — încearcă gratuit acum.",
   "h1": "Gestionează-ți ferma de animale fără bătăi de cap",
   "intro": "Urmărești fiecare animal sau lot — sănătate, reproducere și producții — dintr-o singură aplicație intuitivă. Găini, capre, oi, bovine, iepuri, albine… Ma Petite Ferme se adaptează fermei tale.",
   "bullets": [
    "Fișe individuale și pe loturi cu evidența sănătății și vaccinărilor",
    "Înregistrează producțiile (ouă, lapte, miere…) și monitorizează randamentele",
    "Planifică montele, fătările și intervențiile veterinare la momentul potrivit"
   ],
   "faq": [
    {
     "q": "Ce specii de animale pot fi gestionate?",
     "a": "Păsări de curte, caprine, ovine, bovine, porcine, iepuri și albine, printre altele."
    },
    {
     "q": "Pot urmări starea de sănătate a animalelor mele?",
     "a": "Da, vaccinările, tratamentele și evenimentele sanitare sunt înregistrate per animal sau per lot."
    },
    {
     "q": "Este potrivit pentru ferme mici?",
     "a": "Da, aplicația este gândită să rămână simplă și accesibilă pentru crescătorii mici și fermele de familie."
    }
   ]
  },
  "sk": {
   "slug": "software-na-spravu-chovu",
   "title": "Softvér na správu chovu zvierat | Ma Petite Ferme",
   "description": "Správa chovu zvierat: sledovanie zdravia, reprodukcie a produkcií. Viacdruhový, jednoduchý nástroj pre malé farmy — vyskúšajte zadarmo.",
   "h1": "Spravujte svoj chov jednoducho, pre každý druh zvierat",
   "intro": "Sledujte každé zviera alebo skupinu, ich zdravotný stav, reprodukciu a produkciu v prehľadnej aplikácii. Sliepky, kozy, ovce, hovädzí dobytok, králiky, včely… Ma Petite Ferme sa prispôsobí vášmu chovu.",
   "bullets": [
    "Karty zvierat a skupín so zdravotným sledovaním a očkovaniami",
    "Zaznamenávajte produkciu (vajcia, mlieko, med…) a sledujte výnosy",
    "Plánujte párenie, pôrody a veterinárne zásahy v správnom čase"
   ],
   "faq": [
    {
     "q": "Aké druhy zvierat sú podporované?",
     "a": "Hydina, kozy, ovce, hovädzí dobytok, ošípané, králiky a včely, a mnohé ďalšie."
    },
    {
     "q": "Môžem sledovať zdravotný stav svojich zvierat?",
     "a": "Áno, očkovania, ošetrenia a zdravotné udalosti sú zaznamenávané pre každé zviera alebo skupinu."
    },
    {
     "q": "Je nástroj vhodný pre malé farmy?",
     "a": "Áno, Ma Petite Ferme je navrhnutý tak, aby zostal jednoduchý a prehľadný aj pre malých chovateľov."
    }
   ]
  },
  "cs": {
   "slug": "software-pro-rizeni-chovu",
   "title": "Software pro řízení chovu zvířat | Ma Petite Ferme",
   "description": "Řízení chovu zvířat: evidence stáda, zdraví, reprodukce a produkce. Více druhů, jednoduché, v češtině — vyzkoušejte zdarma.",
   "h1": "Spravujte svůj chov snadno, ať chováte cokoli",
   "intro": "Sledujte každé zvíře nebo skupinu, jejich zdravotní stav, reprodukci a produkci v přehledné aplikaci. Slepice, kozy, ovce, skot, králíci, včely… Ma Petite Ferme se přizpůsobí vašemu chovu.",
   "bullets": [
    "Karty zvířat a skupin se sanitárním sledováním a očkováním",
    "Zaznamenávejte produkci (vejce, mléko, med…) a sledujte výnosy",
    "Plánujte připouštění, porody a zásahy ve správný čas"
   ],
   "faq": [
    {
     "q": "Jaká zvířata lze v aplikaci spravovat?",
     "a": "Drůbež, kozy, ovce, skot, prasata, králíci a včely — a mnoho dalších druhů."
    },
    {
     "q": "Mohu sledovat zdravotní stav svých zvířat?",
     "a": "Ano, očkování, ošetření a zdravotní události se zaznamenávají u každého zvířete nebo skupiny."
    },
    {
     "q": "Je software vhodný pro malé chovy?",
     "a": "Ano, nástroj je navržen tak, aby zůstal jednoduchý a přehledný pro malé farmy a chovatele."
    }
   ]
  },
  "sl": {
   "slug": "programska-oprema-upravljanje-reje",
   "title": "Upravljanje reje živali – programska oprema | Ma Petite Ferme",
   "description": "Programska oprema za rejo živali: sledenje živalim, veterinarsko zdravje, razmnoževanje in pridelava. Večvrstna, preprosta – brezplačno preizkusite.",
   "h1": "Upravljajte svojo rejo preprosto – za vsako vrsto živali",
   "intro": "Spremljajte vsako žival ali skupino, njeno zdravje, razmnoževanje in pridelavo v eni pregledni aplikaciji. Kokoši, koze, ovce, govedo, zajci, čebele… Ma Petite Ferme se prilagodi vaši reji.",
   "bullets": [
    "Kartoteke živali in skupin s sanitarnim sledenjem ter cepljenji",
    "Beležite pridelke (jajca, mleko, med…) in spremljajte donosnost",
    "Načrtujte paritve, poroditve in veterinarske posege ob pravem času"
   ],
   "faq": [
    {
     "q": "Katere vrste živali so podprte?",
     "a": "Perutnina, koze, ovce, govedo, prašiči, zajci in čebelarstvo – ter še druge vrste."
    },
    {
     "q": "Ali lahko spremljam zdravje svojih živali?",
     "a": "Da, cepljenja, zdravljenja in zdravstveni dogodki se beležijo po posamezni živali ali skupini."
    },
    {
     "q": "Je aplikacija primerna za majhne reje?",
     "a": "Da, orodje je zasnovano tako, da ostane preprosto in dostopno za male kmete in rejce."
    }
   ]
  }
 },
 "exploitation-agricole": {
  "fr": {
   "slug": "logiciel-gestion-exploitation-agricole",
   "title": "Logiciel de gestion d'exploitation agricole | Ma Petite Ferme",
   "description": "Logiciel de gestion d'exploitation agricole : animaux, productions, stocks, clients, ventes et facturation dans un seul outil. Simple, en français — essai gratuit.",
   "h1": "Pilotez votre exploitation agricole en un seul endroit",
   "intro": "De la production à la vente, Ma Petite Ferme centralise la gestion de votre exploitation : cheptel, stocks, dépenses, clients, commandes et factures, avec des statistiques pour suivre votre rentabilité.",
   "bullets": [
    "Vue d'ensemble de votre exploitation : productions, stocks et dépenses",
    "Gérez clients, commandes et facturation conforme",
    "Suivez vos indicateurs et exportez vos documents facilement"
   ],
   "faq": [
    {
     "q": "Puis-je gérer plusieurs ateliers ?",
     "a": "Oui, vous pouvez suivre différentes productions et types d'élevage au sein d'une même exploitation."
    },
    {
     "q": "La facturation est-elle incluse ?",
     "a": "Oui, création de factures numérotées et suivi des paiements sont intégrés."
    },
    {
     "q": "Mes données sont-elles sécurisées ?",
     "a": "Vos données sont hébergées de façon sécurisée et vous en gardez le contrôle (RGPD)."
    }
   ]
  },
  "en": {
   "slug": "farm-management-software",
   "title": "Farm Management Software for Small Farms | Ma Petite Ferme",
   "description": "Farm management software: track livestock, crops, stock, customers & invoicing in one place. Simple and affordable — start your free trial today.",
   "h1": "Run Your Entire Farm From One Simple Dashboard",
   "intro": "Ma Petite Ferme brings everything together in one place — from livestock and crop tracking to orders, expenses, and invoicing. Get a clear picture of your farm's performance and grow with confidence.",
   "bullets": [
    "Full farm overview: livestock, inventory, crops and daily expenses at a glance",
    "Manage customers, orders and professional invoicing with ease",
    "Track key performance indicators and export your documents in seconds"
   ],
   "faq": [
    {
     "q": "Can I manage multiple farm activities in one account?",
     "a": "Absolutely. Ma Petite Ferme lets you track different livestock types and production lines all within a single farm profile."
    },
    {
     "q": "Is invoicing included in the software?",
     "a": "Yes — you can create numbered invoices and monitor payments directly inside Ma Petite Ferme, with no extra tool needed."
    },
    {
     "q": "Is my farm data safe and private?",
     "a": "Your data is securely hosted and you stay in full control at all times. Ma Petite Ferme is built with strong privacy standards in mind."
    }
   ]
  },
  "es": {
   "slug": "software-gestion-explotacion-agricola",
   "title": "Software de gestión de explotación agrícola | Ma Petite Ferme",
   "description": "Software de gestión agrícola: animales, producción, stock, clientes, ventas y facturación en una sola herramienta. Sencillo — prueba gratis.",
   "h1": "Gestiona tu explotación agrícola desde un único lugar",
   "intro": "Ma Petite Ferme centraliza todo lo que necesitas para llevar tu granja o explotación: ganado, inventario, gastos, clientes, pedidos y facturas. Accede a estadísticas claras para controlar tu rentabilidad día a día.",
   "bullets": [
    "Visión global de tu explotación: producciones, stock y gastos en tiempo real",
    "Gestiona clientes, pedidos y facturación de forma sencilla y ordenada",
    "Consulta tus indicadores clave y exporta tus documentos cuando los necesites"
   ],
   "faq": [
    {
     "q": "¿Puedo gestionar varias producciones o tipos de ganado a la vez?",
     "a": "Sí, Ma Petite Ferme te permite hacer seguimiento de distintas producciones y tipos de cría dentro de una misma explotación."
    },
    {
     "q": "¿La facturación está incluida en el software?",
     "a": "Sí, puedes crear facturas numeradas y llevar el control de cobros directamente desde la plataforma."
    },
    {
     "q": "¿Están seguros mis datos?",
     "a": "Tus datos se alojan de forma segura y tú mantienes el control total sobre ellos, en cumplimiento con la normativa de protección de datos vigente."
    }
   ]
  },
  "it": {
   "slug": "software-gestione-azienda-agricola",
   "title": "Software gestione azienda agricola: animali, scorte e vendite | Ma Petite Ferme",
   "description": "Software per aziende agricole: gestisci animali, scorte, clienti e fatturazione in un unico strumento. Semplice e completo — prova gratuita.",
   "h1": "Gestisci la tua azienda agricola da un unico posto",
   "intro": "Ma Petite Ferme riunisce in un solo strumento tutto ciò che serve per condurre la tua azienda agricola: bestiame, magazzino, spese, clienti, ordini e fatture. Tieni sotto controllo la redditività con statistiche chiare e aggiornate in tempo reale.",
   "bullets": [
    "Panoramica completa: produzioni, scorte e spese sempre sott'occhio",
    "Gestisci clienti, ordini e fatturazione in modo semplice e conforme",
    "Monitora i tuoi indicatori chiave ed esporta i documenti in pochi clic"
   ],
   "faq": [
    {
     "q": "Posso gestire più tipi di produzione nella stessa azienda?",
     "a": "Sì, puoi seguire produzioni diverse e più tipi di allevamento all'interno della stessa azienda agricola."
    },
    {
     "q": "La fatturazione è inclusa nel software?",
     "a": "Sì, puoi creare fatture numerate e monitorare i pagamenti direttamente dall'applicazione."
    },
    {
     "q": "I miei dati sono al sicuro?",
     "a": "I tuoi dati sono ospitati su infrastrutture sicure e rimangono sempre sotto il tuo controllo, nel rispetto del GDPR."
    }
   ]
  },
  "de": {
   "slug": "landwirtschaft-software-betriebsverwaltung",
   "title": "Landwirtschaft Software für Kleinbetriebe – Tiere, Bestände & Verkauf | Ma Petite Ferme",
   "description": "Landwirtschaft Software: Tiere, Bestände, Kunden und Rechnungen in einem Tool. Einfach & übersichtlich für kleine Höfe – jetzt kostenlos testen.",
   "h1": "Ihren Hof im Griff – alles an einem Ort",
   "intro": "Ma Petite Ferme bündelt die gesamte Verwaltung Ihres landwirtschaftlichen Betriebs: Tierbestand, Lager, Ausgaben, Kunden, Bestellungen und Rechnungen. Behalten Sie Ihre Rentabilität jederzeit im Blick.",
   "bullets": [
    "Gesamtüberblick über Produktion, Lagerbestände und Betriebsausgaben",
    "Kunden, Bestellungen und rechtskonforme Rechnungsstellung einfach verwalten",
    "Kennzahlen verfolgen und Dokumente mit wenigen Klicks exportieren"
   ],
   "faq": [
    {
     "q": "Kann ich mehrere Produktionsbereiche verwalten?",
     "a": "Ja, Sie können verschiedene Produktionszweige und Tierarten innerhalb eines Betriebs gleichzeitig verfolgen."
    },
    {
     "q": "Ist die Rechnungsstellung im Paket enthalten?",
     "a": "Ja, die Erstellung nummerierter Rechnungen und die Zahlungsverfolgung sind vollständig integriert."
    },
    {
     "q": "Sind meine Daten sicher gespeichert?",
     "a": "Ihre Daten werden sicher gehostet und Sie behalten die volle Kontrolle darüber – DSGVO-konform."
    }
   ]
  },
  "nl": {
   "slug": "boerderijbeheer-software",
   "title": "Boerderijbeheer software voor kleine bedrijven | Ma Petite Ferme",
   "description": "Boerderijbeheer software: dieren, voorraden, klanten, verkoop en facturatie in één overzicht. Eenvoudig en efficiënt — gratis proberen.",
   "h1": "Beheer uw hele boerderij op één plek",
   "intro": "Van productie tot verkoop: Ma Petite Ferme bundelt het beheer van uw boerderij in één handig platform. Veestapel, voorraden, kosten, klanten, bestellingen en facturen — alles overzichtelijk bij elkaar.",
   "bullets": [
    "Volledig overzicht van uw bedrijf: productie, voorraden en uitgaven",
    "Beheer klanten, bestellingen en conforme facturatie moeiteloos",
    "Volg uw prestaties op en exporteer documenten met één klik"
   ],
   "faq": [
    {
     "q": "Kan ik meerdere teelten of diersoorten beheren?",
     "a": "Ja, u kunt verschillende producties en soorten veehouderij binnen één bedrijf opvolgen."
    },
    {
     "q": "Is facturatie inbegrepen in het pakket?",
     "a": "Ja, het aanmaken van genummerde facturen en het opvolgen van betalingen zijn volledig geïntegreerd."
    },
    {
     "q": "Zijn mijn gegevens goed beschermd?",
     "a": "Uw gegevens worden veilig opgeslagen en u behoudt er te allen tijde de volledige controle over, conform de AVG-wetgeving."
    }
   ]
  },
  "sv": {
   "slug": "programvara-jordbruksforetag",
   "title": "Programvara för jordbruksföretag – djur, lager och fakturering | Ma Petite Ferme",
   "description": "Programvara för jordbruksföretag: djur, produktion, lager, kunder och fakturering i ett verktyg. Enkelt och smart – prova gratis.",
   "h1": "Styr hela din gård från ett och samma ställe",
   "intro": "Ma Petite Ferme samlar allt du behöver för att driva ditt jordbruksföretag: djurskötsel, lagersaldo, kostnader, kunder och fakturor – med tydlig statistik så du alltid har koll på lönsamheten. Från produktion till försäljning, allt i ett.",
   "bullets": [
    "Överblick över hela gården: produktion, lager och utgifter i realtid",
    "Hantera kunder, beställningar och korrekt fakturering utan krångel",
    "Följ dina nyckeltal och exportera dokument med ett klick"
   ],
   "faq": [
    {
     "q": "Kan jag hantera flera produktionsgrenar samtidigt?",
     "a": "Ja, du kan följa olika djurslag och produktioner inom samma gård utan begränsningar."
    },
    {
     "q": "Ingår fakturering i tjänsten?",
     "a": "Ja, du kan skapa numrerade fakturor och följa betalningar direkt i Ma Petite Ferme."
    },
    {
     "q": "Är mina uppgifter skyddade?",
     "a": "Dina data lagras säkert och du behåller full kontroll över dem i enlighet med gällande dataskyddsregler (GDPR)."
    }
   ]
  },
  "da": {
   "slug": "landbrugs-styringssoftware",
   "title": "Landbrugssoftware til små landbrug og husdyrhold | Ma Petite Ferme",
   "description": "Landbrugssoftware: dyr, produktion, lager, kunder og fakturering samlet ét sted. Nemt at bruge — prøv gratis i dag.",
   "h1": "Styr hele dit landbrug ét sted",
   "intro": "Ma Petite Ferme samler alt fra produktion til salg i ét enkelt værktøj — besætning, lager, udgifter, kunder og fakturaer. Få overblik over din økonomi og rentabilitet med det samme.",
   "bullets": [
    "Komplet overblik over produktion, lager og udgifter på dit landbrug",
    "Håndter kunder, ordrer og lovpligtig fakturering uden besvær",
    "Følg dine nøgletal og eksportér dokumenter med få klik"
   ],
   "faq": [
    {
     "q": "Kan jeg styre flere produktionsgrene på samme landbrug?",
     "a": "Ja, du kan følge forskellige produktioner og dyrehold inden for samme bedrift uden begrænsninger."
    },
    {
     "q": "Er fakturering inkluderet i softwaren?",
     "a": "Ja, du kan oprette nummererede fakturaer og følge betalinger direkte i Ma Petite Ferme."
    },
    {
     "q": "Er mine data sikre?",
     "a": "Dine data opbevares sikkert, og du bevarer fuld kontrol over dem i overensstemmelse med GDPR-reglerne."
    }
   ]
  },
  "bg": {
   "slug": "software-upravlenie-ferma",
   "title": "Софтуер за управление на ферма | Ma Petite Ferme",
   "description": "Софтуер за ферма: животни, производство, складове, клиенти и фактури в едно. Лесен за използване — безплатен пробен период.",
   "h1": "Управлявайте фермата си от едно място",
   "intro": "Ma Petite Ferme събира всичко в една платформа: стадо, складове, разходи, поръчки и фактури. Следете рентабилността си в реално време — без излишна сложност.",
   "bullets": [
    "Преглед на цялата ферма: производство, наличности и разходи",
    "Управление на клиенти, поръчки и коректно фактуриране",
    "Проследявайте ключови показатели и експортирайте документи лесно"
   ],
   "faq": [
    {
     "q": "Мога ли да управлявам различни видове производство?",
     "a": "Да, можете да следите различни отрасли и видове животновъдство в рамките на една и съща ферма."
    },
    {
     "q": "Включено ли е фактурирането?",
     "a": "Да, създаването на номерирани фактури и проследяването на плащанията са вградени в платформата."
    },
    {
     "q": "Сигурни ли са моите данни?",
     "a": "Данните ви се съхраняват сигурно и вие запазвате пълен контрол върху тях в съответствие с GDPR."
    }
   ]
  },
  "hr": {
   "slug": "softver-upravljanje-poljoprivrednim-gospodarstvom",
   "title": "Softver za upravljanje poljoprivrednim gospodarstvom | Ma Petite Ferme",
   "description": "Upravljanje gospodarstvom: stoka, zalihe, klijenti, prodaja i fakturiranje u jednom alatu. Jednostavno i učinkovito — isprobajte besplatno.",
   "h1": "Vaše gospodarstvo pod kontrolom na jednom mjestu",
   "intro": "Ma Petite Ferme objedinjuje sve što vam treba za vođenje malog poljoprivrednog gospodarstva: evidenciju stoke, zalihe, troškove, narudžbe i fakture. Pratite profitabilnost i donosite bolje odluke svaki dan.",
   "bullets": [
    "Pregled cijelog gospodarstva: stoka, zalihe i troškovi u stvarnom vremenu",
    "Upravljajte klijentima, narudžbama i računima na jednostavan način",
    "Pratite ključne pokazatelje i izvozite dokumente u nekoliko klikova"
   ],
   "faq": [
    {
     "q": "Mogu li pratiti više vrsta proizvodnje odjednom?",
     "a": "Da, Ma Petite Ferme omogućuje praćenje različitih vrsta stočarstva i biljne proizvodnje unutar istog gospodarstva."
    },
    {
     "q": "Je li fakturiranje uključeno u softver?",
     "a": "Da, možete kreirati numerirane račune i pratiti plaćanja izravno unutar aplikacije."
    },
    {
     "q": "Jesu li moji podaci sigurni?",
     "a": "Vaši podaci su sigurno pohranjeni, a vi imate potpunu kontrolu nad njima u skladu s propisima o zaštiti osobnih podataka (GDPR)."
    }
   ]
  },
  "el": {
   "slug": "logismiko-diacheirisis-agrotikis-monadas",
   "title": "Λογισμικό διαχείρισης αγροτικής μονάδας | Ma Petite Ferme",
   "description": "Λογισμικό αγροτικής μονάδας: ζώα, παραγωγή, αποθέματα, πελάτες, πωλήσεις και τιμολόγηση σε ένα εργαλείο. Απλό — δοκιμάστε δωρεάν.",
   "h1": "Διαχειριστείτε την αγροτική σας μονάδα από ένα μόνο σημείο",
   "intro": "Από την παραγωγή ως την πώληση, το Ma Petite Ferme συγκεντρώνει όλα όσα χρειάζεστε: κοπάδια, αποθέματα, έξοδα, πελάτες και τιμολόγια. Παρακολουθήστε την κερδοφορία σας με απλά στατιστικά, χωρίς να χάνετε χρόνο.",
   "bullets": [
    "Συνολική εικόνα της μονάδας σας: παραγωγή, αποθέματα και έξοδα",
    "Διαχειριστείτε πελάτες, παραγγελίες και νόμιμη τιμολόγηση",
    "Παρακολουθήστε τους δείκτες σας και εξάγετε έγγραφα εύκολα"
   ],
   "faq": [
    {
     "q": "Μπορώ να διαχειριστώ διαφορετικούς τύπους παραγωγής;",
     "a": "Ναι, μπορείτε να παρακολουθείτε πολλαπλές παραγωγές και είδη εκτροφής μέσα στην ίδια μονάδα."
    },
    {
     "q": "Περιλαμβάνεται η τιμολόγηση;",
     "a": "Ναι, η δημιουργία αριθμημένων τιμολογίων και η παρακολούθηση πληρωμών είναι ενσωματωμένες στο εργαλείο."
    },
    {
     "q": "Είναι ασφαλή τα δεδομένα μου;",
     "a": "Τα δεδομένα σας φιλοξενούνται με ασφάλεια και παραμένουν υπό τον πλήρη έλεγχό σας, σύμφωνα με τον GDPR."
    }
   ]
  },
  "et": {
   "slug": "talu-haldus-tarkvara",
   "title": "Talu haldus tarkvara väiketalunikele | Ma Petite Ferme",
   "description": "Talu haldus tarkvara: loomad, varud, kliendid, müük ja arved ühes kohas. Lihtne ja tõhus — proovi tasuta!",
   "h1": "Halda oma talu ühest kohast",
   "intro": "Ma Petite Ferme koondab kõik talu juhtimiseks vajaliku — karjast varude, kulude, klientide ja arveteni — ühte lihtsasse rakendusse. Jälgi oma talu kasumlikkust reaalajas ja tee õigeid otsuseid.",
   "bullets": [
    "Ülevaade kogu talust: toodang, varud ja kulud ühel pilgul",
    "Halda kliente, tellimusi ja koosta nõuetele vastavaid arveid",
    "Jälgi põhinäitajaid ja ekspordi dokumendid mõne klikiga"
   ],
   "faq": [
    {
     "q": "Kas saan hallata mitut tootmisharu?",
     "a": "Jah, Ma Petite Ferme võimaldab jälgida erinevaid tootmisharusid ja loomakasvatuse liike ühe talu raames."
    },
    {
     "q": "Kas arveldus on rakenduses sees?",
     "a": "Jah, saad luua nummerdatud arveid ja jälgida makseid otse rakenduses."
    },
    {
     "q": "Kas minu andmed on kaitstud?",
     "a": "Kõik andmed on turvaliselt salvestatud ja jäävad sinu kontrolli alla — järgime GDPR-i nõudeid."
    }
   ]
  },
  "hu": {
   "slug": "gazdasag-iranyito-szoftver",
   "title": "Gazdaságirányító szoftver kis farmokhoz | Ma Petite Ferme",
   "description": "Gazdaságirányító szoftver: állatok, készletek, ügyfelek, értékesítés és számlázás egy helyen. Egyszerű, hatékony — próbáld ki ingyen.",
   "h1": "Irányítsd a farmodat egyetlen eszközzel",
   "intro": "A Ma Petite Ferme összevonja a kis gazdaság teljes működését: állatállomány, készletek, kiadások, rendelések és számlák kezelése egy helyen, valós idejű statisztikákkal. A termeléstől az értékesítésig minden áttekinthető és egyszerű.",
   "bullets": [
    "Teljes áttekintés: termelés, készletek és kiadások egy dashboardon",
    "Ügyfelek, rendelések és szabályos számlázás könnyedén",
    "Kövesse mutatóit és exportálja dokumentumait pár kattintással"
   ],
   "faq": [
    {
     "q": "Kezelhetek több termelési ágat egyszerre?",
     "a": "Igen, egy gazdaságon belül több állatfajta és termelési típus is nyomon követhető párhuzamosan."
    },
    {
     "q": "A számlázás is benne van a szoftverben?",
     "a": "Igen, a sorszámozott számlák kiállítása és a fizetések nyomon követése is beépített funkció."
    },
    {
     "q": "Biztonságban vannak az adataim?",
     "a": "Adatai biztonságos szerveren tárolódnak, és Ön teljes ellenőrzést tart felettük — GDPR-megfelelő megoldással."
    }
   ]
  },
  "fi": {
   "slug": "maatilan-hallintaohjelmisto",
   "title": "Maatilan hallintaohjelmisto pienille tiloille | Ma Petite Ferme",
   "description": "Maatilan hallintaohjelmisto: eläimet, tuotanto, varastot, asiakkaat ja laskutus yhdessä työkalussa. Helppo käyttää — kokeile ilmaiseksi.",
   "h1": "Hallitse maatilaasi yhdestä paikasta",
   "intro": "Ma Petite Ferme kokoaa koko maatilasi hallinnan yhteen paikkaan: eläimet, varastot, kulut, asiakkaat, tilaukset ja laskut. Selkeät tilastot auttavat seuraamaan kannattavuuttasi reaaliajassa.",
   "bullets": [
    "Kokonaiskuva tilastasi: tuotanto, varastot ja kulut yhdellä silmäyksellä",
    "Hallitse asiakkaita, tilauksia ja laskutusta vaivattomasti",
    "Seuraa tunnuslukuja ja vie asiakirjat helposti"
   ],
   "faq": [
    {
     "q": "Voinko hallita useita tuotantosuuntia samalla tilalla?",
     "a": "Kyllä, voit seurata eri tuotantoja ja eläinlajeja saman tilan alla ilman rajoituksia."
    },
    {
     "q": "Sisältyykö laskutus ohjelmistoon?",
     "a": "Kyllä, voit luoda numeroituja laskuja ja seurata maksuja suoraan Ma Petite Ferme -sovelluksessa."
    },
    {
     "q": "Ovatko tietoni turvassa?",
     "a": "Tietosi tallennetaan turvallisesti ja pysyvät hallinnassasi — ohjelmisto noudattaa EU:n tietosuoja-asetuksen (GDPR) vaatimuksia."
    }
   ]
  },
  "lv": {
   "slug": "lauksaimniecibas-parvaldibas-programma",
   "title": "Lauksaimniecības pārvaldības programma mazajām saimniecībām | Ma Petite Ferme",
   "description": "Lauksaimniecības pārvaldība: dzīvnieki, krājumi, klienti, pārdošana un rēķini vienā rīkā. Vienkārši un ērti — izmēģini bez maksas.",
   "h1": "Pārvaldi savu saimniecību vienā vietā",
   "intro": "Ma Petite Ferme apvieno visu, kas nepieciešams mazai saimniecībai: lopu uzskaite, krājumi, izdevumi, klienti un rēķini vienā vietā. Iegūsti skaidru pārskatu par rentabilitāti un taupi laiku katru dienu.",
   "bullets": [
    "Pilns pārskats par saimniecību: ražošana, krājumi un izdevumi",
    "Pārvaldi klientus, pasūtījumus un atbilstošus rēķinus",
    "Seko rādītājiem un eksportē dokumentus ērti un ātri"
   ],
   "faq": [
    {
     "q": "Vai varu pārvaldīt vairākus ražošanas virzienus?",
     "a": "Jā, Ma Petite Ferme ļauj sekot dažādiem lopkopības un ražošanas veidiem vienā saimniecībā."
    },
    {
     "q": "Vai rēķinu izrakstīšana ir iekļauta?",
     "a": "Jā, vari izveidot numurētus rēķinus un sekot maksājumiem tieši platformā."
    },
    {
     "q": "Vai mani dati ir droši?",
     "a": "Jā, visi dati tiek glabāti drošā vidē un tu saglabā pilnu kontroli pār tiem saskaņā ar VDAR prasībām."
    }
   ]
  },
  "pl": {
   "slug": "oprogramowanie-zarzadzanie-gospodarstwem",
   "title": "Oprogramowanie do zarządzania gospodarstwem rolnym | Ma Petite Ferme",
   "description": "Oprogramowanie dla gospodarstw: zwierzęta, produkcja, magazyn, klienci i faktury w jednym narzędziu. Proste i skuteczne — wypróbuj za darmo.",
   "h1": "Zarządzaj swoim gospodarstwem w jednym miejscu",
   "intro": "Ma Petite Ferme to kompletne narzędzie dla małych gospodarstw rolnych i hodowców — od zarządzania stadem i zapasami, przez sprzedaż, aż po fakturowanie. Miej wszystko pod kontrolą i śledź rentowność swojej działalności w czasie rzeczywistym.",
   "bullets": [
    "Przegląd całego gospodarstwa: produkcja, magazyn i wydatki w jednym panelu",
    "Zarządzaj klientami, zamówieniami i wystawiaj zgodne faktury bez wysiłku",
    "Monitoruj kluczowe wskaźniki i eksportuj dokumenty jednym kliknięciem"
   ],
   "faq": [
    {
     "q": "Czy mogę zarządzać kilkoma działami produkcji jednocześnie?",
     "a": "Tak, Ma Petite Ferme pozwala śledzić różne typy hodowli i produkcji rolnej w ramach jednego gospodarstwa."
    },
    {
     "q": "Czy fakturowanie jest wbudowane w aplikację?",
     "a": "Tak, możesz tworzyć ponumerowane faktury i śledzić płatności bezpośrednio w narzędziu."
    },
    {
     "q": "Czy moje dane są bezpieczne?",
     "a": "Twoje dane są przechowywane w bezpieczny sposób, a Ty zachowujesz nad nimi pełną kontrolę zgodnie z przepisami RODO."
    }
   ]
  },
  "lt": {
   "slug": "ukio-valdymo-programele",
   "title": "Ūkio valdymo programėlė smulkiems ūkiams | Ma Petite Ferme",
   "description": "Ūkio valdymo programėlė: gyvuliai, produkcija, sandėlis, klientai ir sąskaitos vienoje vietoje. Išbandykite nemokamai!",
   "h1": "Valdykite savo ūkį iš vienos vietos",
   "intro": "Ma Petite Ferme sujungia viską, ko reikia smulkiam ūkiui: gyvulių apskaitą, atsargas, išlaidas, klientus ir sąskaitas faktūras. Stebėkite ūkio pelningumą realiuoju laiku ir priimkite geresnius sprendimus.",
   "bullets": [
    "Pilna ūkio apžvalga: produkcija, sandėlis ir išlaidos vienoje lentelėje",
    "Tvarkykite klientus, užsakymus ir išrašykite atitinkančias sąskaitas faktūras",
    "Sekite pagrindinius rodiklius ir eksportuokite dokumentus keliais paspaudimais"
   ],
   "faq": [
    {
     "q": "Ar galima valdyti kelis gamybos skyrius?",
     "a": "Taip, galite sekti skirtingas produkcijos rūšis ir gyvulininkystės šakas viename ūkyje."
    },
    {
     "q": "Ar sąskaitų faktūrų išrašymas įtrauktas į programėlę?",
     "a": "Taip, galite kurti sunumeruotas sąskaitas faktūras ir sekti mokėjimus tiesiai sistemoje."
    },
    {
     "q": "Ar mano duomenys saugūs?",
     "a": "Visi duomenys saugomi saugiuose serveriuose, o jūs išlaikote visišką kontrolę pagal BDAR reikalavimus."
    }
   ]
  },
  "pt": {
   "slug": "software-gestao-propriedade-rural",
   "title": "Software de gestão de propriedade rural | Ma Petite Ferme",
   "description": "Gestão de propriedade rural: animais, produções, estoques, clientes e faturamento em um só lugar. Simples e completo — experimente grátis.",
   "h1": "Gerencie sua propriedade rural com simplicidade",
   "intro": "Da criação à venda, o Ma Petite Ferme reúne tudo que você precisa para administrar sua pequena propriedade: rebanho, estoques, despesas, clientes, pedidos e notas fiscais. Acompanhe sua rentabilidade com relatórios claros e acessíveis.",
   "bullets": [
    "Visão completa da propriedade: produções, estoques e despesas em tempo real",
    "Gerencie clientes, pedidos e emita cobranças de forma organizada",
    "Acompanhe seus indicadores e exporte documentos com facilidade"
   ],
   "faq": [
    {
     "q": "Posso gerenciar diferentes tipos de criação na mesma propriedade?",
     "a": "Sim, o Ma Petite Ferme permite acompanhar várias produções e tipos de criação dentro de uma mesma propriedade, tudo centralizado em um único painel."
    },
    {
     "q": "O módulo de faturamento está incluído?",
     "a": "Sim, você pode gerar cobranças numeradas e acompanhar os pagamentos diretamente na plataforma, sem precisar de nenhuma ferramenta adicional."
    },
    {
     "q": "Meus dados ficam protegidos?",
     "a": "Sim, seus dados são armazenados com segurança em servidores protegidos e você mantém total controle sobre eles, em conformidade com as normas de proteção de dados."
    }
   ]
  },
  "ro": {
   "slug": "software-gestiune-ferma-mica",
   "title": "Software gestiune fermă mică | Ma Petite Ferme",
   "description": "Software gestiune fermă: animale, stocuri, clienți, vânzări și facturare într-un singur loc. Simplu și intuitiv — încearcă gratuit.",
   "h1": "Gestionează-ți ferma de oriunde, oricând",
   "intro": "Ma Petite Ferme reunește tot ce ai nevoie pentru a conduce o fermă mică sau un crescătorie: efective de animale, stocuri, cheltuieli, comenzi și facturi, cu statistici clare despre rentabilitate. De la producție până la vânzare, totul este centralizat într-o singură aplicație ușor de folosit.",
   "bullets": [
    "Vizualizare completă a fermei: producții, stocuri și cheltuieli în timp real",
    "Gestionează clienți, comenzi și facturare conformă cu legislația",
    "Urmărește indicatorii-cheie și exportă documentele cu un singur clic"
   ],
   "faq": [
    {
     "q": "Pot gestiona mai multe tipuri de animale sau producții?",
     "a": "Da, poți urmări separat diferite specii de animale și tipuri de producție în cadrul aceleiași ferme."
    },
    {
     "q": "Facturarea este inclusă în aplicație?",
     "a": "Da, poți emite facturi numerotate și urmări plățile direct din Ma Petite Ferme."
    },
    {
     "q": "Datele mele sunt în siguranță?",
     "a": "Datele tale sunt stocate în condiții de securitate ridicate, iar tu păstrezi controlul total asupra lor, în conformitate cu GDPR."
    }
   ]
  },
  "sk": {
   "slug": "software-riadenie-farmy",
   "title": "Softvér na riadenie farmy pre malých farmárov | Ma Petite Ferme",
   "description": "Riadenie farmy jednoducho: zvieratá, zásoby, výroba, zákazníci a fakturácia v jednom nástroji. Vyskúšajte Ma Petite Ferme zadarmo.",
   "h1": "Spravujte svoju farmu na jednom mieste",
   "intro": "Ma Petite Ferme spája všetko, čo malý farmár potrebuje: evidenciu zvierat, zásoby, výdavky, objednávky aj fakturáciu. Sledujte rentabilitu svojej farmy prehľadne a bez zbytočnej administratívy.",
   "bullets": [
    "Prehľad celej farmy: chov, zásoby a výdavky na jednom mieste",
    "Spravujte zákazníkov, objednávky a vystavujte faktúry",
    "Sledujte kľúčové ukazovatele a exportujte dokumenty jedným klikom"
   ],
   "faq": [
    {
     "q": "Môžem spravovať viacero typov chovu naraz?",
     "a": "Áno, Ma Petite Ferme umožňuje sledovať rôzne druhy výroby a chovu v rámci jednej farmy."
    },
    {
     "q": "Je fakturácia súčasťou softvéru?",
     "a": "Áno, vytváranie číslovaných faktúr aj sledovanie platieb je plne integrované do nástroja."
    },
    {
     "q": "Sú moje dáta v bezpečí?",
     "a": "Vaše údaje sú bezpečne uložené na serveri a vy si zachovávate plnú kontrolu v súlade s GDPR."
    }
   ]
  },
  "cs": {
   "slug": "software-pro-rizeni-zemedelske-farmy",
   "title": "Řízení zemědělské farmy – software pro malé podniky | Ma Petite Ferme",
   "description": "Řízení farmy snadno: zvířata, sklady, výroba, zákazníci a fakturace v jednom nástroji. Vyzkoušejte Ma Petite Ferme zdarma.",
   "h1": "Vaše farma přehledně na jednom místě",
   "intro": "Ma Petite Ferme propojuje celý chod vaší farmy – od chovu zvířat a skladových zásob až po objednávky, faktury a přehled výnosů. Ušetřete čas a mějte vše pod kontrolou, ať podnikáte v zemědělství nebo živočišné výrobě.",
   "bullets": [
    "Přehled celé farmy: stavy zvířat, sklady a náklady na jednom místě",
    "Spravujte zákazníky, objednávky a vystavujte faktury bez námahy",
    "Sledujte klíčové ukazatele a exportujte dokumenty jedním klikem"
   ],
   "faq": [
    {
     "q": "Mohu spravovat různé druhy výroby zároveň?",
     "a": "Ano, Ma Petite Ferme umožňuje sledovat více provozů najednou – například rostlinnou i živočišnou výrobu v rámci jedné farmy."
    },
    {
     "q": "Je fakturace součástí aplikace?",
     "a": "Ano, vystavování číslovaných faktur a sledování plateb je plně integrováno bez potřeby dalšího nástroje."
    },
    {
     "q": "Jsou moje data v bezpečí?",
     "a": "Vaše data jsou uložena na zabezpečených serverech a vy si zachováváte plnou kontrolu v souladu s GDPR."
    }
   ]
  },
  "sl": {
   "slug": "programska-oprema-upravljanje-kmetije",
   "title": "Upravljanje kmetije – programska oprema za male kmetije | Ma Petite Ferme",
   "description": "Upravljanje kmetije: živali, zaloge, stranke, prodaja in fakturiranje v enem orodju. Preprosto in učinkovito – preizkusite brezplačno.",
   "h1": "Vodite svojo kmetijo na enem mestu",
   "intro": "Ma Petite Ferme združuje vse, kar potrebujete za vodenje male kmetije: živino, zaloge, stroške, naročila in račune v eni pregledni aplikaciji. Spremljajte donosnost svoje kmetije z jasnimi statističnimi podatki.",
   "bullets": [
    "Celoten pregled kmetije: pridelava, zaloge in stroški",
    "Upravljajte stranke, naročila in skladišno fakturiranje",
    "Sledite ključnim kazalnikom in preprosto izvažajte dokumente"
   ],
   "faq": [
    {
     "q": "Ali lahko upravljam več vrst živinoreje ali pridelave hkrati?",
     "a": "Da, v okviru ene kmetije lahko sočasno spremljate različne vrste pridelave in živinoreje."
    },
    {
     "q": "Ali je fakturiranje vključeno v orodje?",
     "a": "Da, ustvarjanje številčenih računov in sledenje plačilom sta že vgrajena v aplikacijo."
    },
    {
     "q": "Ali so moji podatki varni?",
     "a": "Vaši podatki so varno shranjeni v skladu z veljavno zakonodajo o varstvu osebnih podatkov, vi pa ohranite popoln nadzor nad njimi."
    }
   ]
  }
 },
 "vente-circuit-court": {
  "fr": {
   "slug": "logiciel-vente-circuit-court",
   "title": "Logiciel de vente en circuit court | Ma Petite Ferme",
   "description": "Vendez en circuit court avec une boutique en ligne à la ferme : produits, commandes, clients et paiements en ligne. Simple, en français — essai gratuit.",
   "h1": "Vendez vos produits en circuit court, en ligne",
   "intro": "Créez votre boutique en ligne de producteur en quelques minutes, encaissez vos ventes directes et gérez commandes et clients sans effort. Idéal pour la vente directe à la ferme et les circuits courts.",
   "bullets": [
    "Boutique en ligne pour vendre vos produits fermiers",
    "Gérez commandes, retraits et paiements en ligne",
    "Fidélisez vos clients et suivez vos ventes directes"
   ],
   "faq": [
    {
     "q": "Puis-je vendre en ligne mes produits ?",
     "a": "Oui, chaque ferme dispose d'une boutique en ligne avec paiement sécurisé."
    },
    {
     "q": "Comment sont gérées les commandes ?",
     "a": "Les commandes clients arrivent dans votre tableau de bord avec statut et facturation."
    },
    {
     "q": "Est-ce adapté à la vente directe ?",
     "a": "Oui, l'outil est pensé pour la vente directe à la ferme et les circuits courts."
    }
   ]
  },
  "en": {
   "slug": "farm-direct-sales-software",
   "title": "Farm Direct Sales Software: Sell Online with Ease | Ma Petite Ferme",
   "description": "Direct farm sales made simple: online store, orders, customers & payments in one place. Built for small farms — start your free trial today.",
   "h1": "Sell Your Farm Products Directly, Online",
   "intro": "Launch your own farm shop online in minutes, accept payments, and manage orders and customers without the hassle. Perfect for farmers selling direct to consumers and local markets.",
   "bullets": [
    "Your own online storefront to showcase and sell farm products",
    "Manage orders, pickups, and online payments in one dashboard",
    "Build customer loyalty and track every direct sale effortlessly"
   ],
   "faq": [
    {
     "q": "Can I sell my farm products online?",
     "a": "Absolutely — every farm gets a dedicated online store with secure payment processing built in."
    },
    {
     "q": "How are customer orders handled?",
     "a": "All orders land straight in your dashboard, complete with status tracking and invoicing."
    },
    {
     "q": "Is this suited for direct-to-consumer farm sales?",
     "a": "Yes, Ma Petite Ferme is designed specifically for farms selling direct to customers and local communities."
    }
   ]
  },
  "es": {
   "slug": "software-venta-directa-agricola",
   "title": "Venta directa agrícola: tienda online para tu granja | Ma Petite Ferme",
   "description": "Venta directa agrícola: crea tu tienda online, gestiona pedidos, clientes y cobros desde tu granja. Fácil y rápido — prueba gratis.",
   "h1": "Vende tus productos del campo directamente, en línea",
   "intro": "Crea tu tienda online como productor en minutos, cobra tus ventas directas y gestiona pedidos y clientes sin complicaciones. Perfecto para la venta directa en granja y los canales cortos de comercialización.",
   "bullets": [
    "Tienda online para vender tus productos agrícolas y ganaderos",
    "Gestiona pedidos, recogidas y pagos en línea desde un solo lugar",
    "Fideliza a tus clientes y controla tus ventas directas fácilmente"
   ],
   "faq": [
    {
     "q": "¿Puedo vender mis productos agrícolas por internet?",
     "a": "Sí, cada granja dispone de su propia tienda online con pago seguro integrado."
    },
    {
     "q": "¿Cómo se gestionan los pedidos de los clientes?",
     "a": "Los pedidos llegan directamente a tu panel de control con su estado actualizado y facturación incluida."
    },
    {
     "q": "¿Es adecuado para la venta directa en granja?",
     "a": "Sí, la herramienta está diseñada específicamente para la venta directa al consumidor y los canales cortos de distribución."
    }
   ]
  },
  "it": {
   "slug": "software-vendita-filiera-corta",
   "title": "Software vendita filiera corta per agricoltori | Ma Petite Ferme",
   "description": "Filiera corta online: crea il tuo negozio agricolo, gestisci ordini, clienti e pagamenti. Semplice e immediato — prova gratuita.",
   "h1": "Vendi i tuoi prodotti agricoli direttamente online",
   "intro": "Con Ma Petite Ferme apri il tuo negozio online di produttore in pochi minuti, incassi le vendite dirette e gestisci ordini e clienti senza complicazioni. La soluzione ideale per la vendita diretta in azienda agricola e la filiera corta.",
   "bullets": [
    "Negozio online per vendere i tuoi prodotti agricoli a km zero",
    "Gestisci ordini, ritiri e pagamenti online in un unico posto",
    "Fidelizza i clienti e monitora le tue vendite dirette"
   ],
   "faq": [
    {
     "q": "Posso vendere online i miei prodotti agricoli?",
     "a": "Sì, ogni azienda agricola dispone di un negozio online con pagamento sicuro integrato."
    },
    {
     "q": "Come vengono gestiti gli ordini dei clienti?",
     "a": "Gli ordini arrivano direttamente nella tua dashboard con stato aggiornato e fatturazione automatica."
    },
    {
     "q": "Il software è adatto alla vendita diretta in filiera corta?",
     "a": "Assolutamente sì, lo strumento è progettato appositamente per la vendita diretta in azienda agricola e i circuiti a km zero."
    }
   ]
  },
  "de": {
   "slug": "direktvermarktung-software-bauernhof",
   "title": "Direktvermarktung Software für Bauernhöfe | Ma Petite Ferme",
   "description": "Direktvermarktung leicht gemacht: Online-Shop für Ihren Hof, Bestellungen, Kunden und Zahlungen zentral verwalten. Jetzt kostenlos testen.",
   "h1": "Verkaufen Sie Ihre Hofprodukte direkt online",
   "intro": "Eröffnen Sie in wenigen Minuten Ihren eigenen Hofladen im Internet und verwalten Sie Bestellungen, Abholungen und Kundschaft ganz einfach an einem Ort. Ma Petite Ferme ist die ideale Lösung für Direktvermarktung und regionale Absatzwege.",
   "bullets": [
    "Eigener Online-Hofladen für Ihre landwirtschaftlichen Produkte",
    "Bestellungen, Abholtermine und Online-Zahlungen zentral steuern",
    "Stammkunden gewinnen und Direktverkäufe übersichtlich verfolgen"
   ],
   "faq": [
    {
     "q": "Kann ich meine Hofprodukte wirklich online verkaufen?",
     "a": "Ja, jeder Betrieb erhält mit Ma Petite Ferme einen eigenen Online-Shop mit sicherer Zahlungsabwicklung."
    },
    {
     "q": "Wie werden eingehende Bestellungen verwaltet?",
     "a": "Alle Kundenbestellungen erscheinen übersichtlich in Ihrem Dashboard – inklusive Status und Rechnungsstellung."
    },
    {
     "q": "Ist die Software für Direktvermarktung geeignet?",
     "a": "Absolut, Ma Petite Ferme wurde speziell für den Direktverkauf ab Hof und regionale Vermarktungswege entwickelt."
    }
   ]
  },
  "nl": {
   "slug": "software-korte-keten-verkoop",
   "title": "Korte keten verkoop software voor kleine boerderijen | Ma Petite Ferme",
   "description": "Korte keten verkoop: webshop voor uw boerderij met bestellingen, klanten en online betaling. Eenvoudig te starten — gratis proberen.",
   "h1": "Verkoop uw producten rechtstreeks via de korte keten",
   "intro": "Start in enkele minuten uw eigen boerenwebshop, ontvang betalingen en beheer bestellingen en klanten zonder gedoe. Perfect voor directe verkoop aan de boerderij en korte keteninitiatieven.",
   "bullets": [
    "Eigen webshop om uw streekproducten te verkopen",
    "Beheer bestellingen, afhaalmoments en online betalingen",
    "Bouw klantenloyaliteit op en volg uw directe verkoop op"
   ],
   "faq": [
    {
     "q": "Kan ik mijn producten online verkopen?",
     "a": "Ja, elke boerderij krijgt een eigen webshop met beveiligde betaling."
    },
    {
     "q": "Hoe worden bestellingen beheerd?",
     "a": "Klantbestellingen komen binnen in uw dashboard, met status en facturatie overzichtelijk op één plek."
    },
    {
     "q": "Is dit geschikt voor directe verkoop aan de boerderij?",
     "a": "Absoluut, de tool is speciaal ontworpen voor hoeveverkopers en korte ketenproducenten."
    }
   ]
  },
  "sv": {
   "slug": "programvara-direktforsaljning-bondgard",
   "title": "Direktförsäljning bondgård – sälj online enkelt | Ma Petite Ferme",
   "description": "Direktförsäljning från gården: skapa din nätbutik, hantera beställningar, kunder och betalningar online. Enkelt och gratis att testa.",
   "h1": "Sälj dina gårdsprodukter direkt – online",
   "intro": "Skapa din egen nätbutik som producent på några minuter och ta betalt för dina direktförsäljningar utan krångel. Ma Petite Ferme är gjort för småbönder och lokala livsmedelsproducenter som vill nå sina kunder direkt.",
   "bullets": [
    "Nätbutik anpassad för gårdsförsäljning och lokala produkter",
    "Hantera beställningar, upphämtning och onlinebetalningar på ett ställe",
    "Bygg kundlojalitet och följ upp din direktförsäljning i realtid"
   ],
   "faq": [
    {
     "q": "Kan jag sälja mina gårdsprodukter online?",
     "a": "Ja, varje gård får en egen nätbutik med säker betalning direkt via Ma Petite Ferme."
    },
    {
     "q": "Hur hanteras beställningar från mina kunder?",
     "a": "Alla kundbeställningar samlas i din instrumentpanel med status, fakturering och upphämtningsinfo."
    },
    {
     "q": "Passar verktyget för direktförsäljning från gården?",
     "a": "Absolut – Ma Petite Ferme är särskilt utformat för gårdsförsäljning och korta livsmedelskedjor."
    }
   ]
  },
  "bg": {
   "slug": "softuer-direktna-prodajba-ferma",
   "title": "Директна продажба от фермата онлайн | Ma Petite Ferme",
   "description": "Директна продажба от фермата: онлайн магазин, поръчки, клиенти и плащания на едно място. Лесно за старт — безплатен пробен период.",
   "h1": "Продавайте директно от фермата си онлайн",
   "intro": "Създайте онлайн магазин за вашата ферма за минути и приемайте поръчки, плащания и клиенти без излишни усилия. Идеалното решение за малки ферми и директна продажба на местни продукти.",
   "bullets": [
    "Онлайн магазин за продажба на фермерски продукти",
    "Управлявайте поръчки, вземания и онлайн плащания лесно",
    "Изградете лоялна клиентска база и следете продажбите си"
   ],
   "faq": [
    {
     "q": "Мога ли да продавам продуктите си онлайн?",
     "a": "Да, всяка ферма получава собствен онлайн магазин със защитено плащане."
    },
    {
     "q": "Как се управляват поръчките от клиенти?",
     "a": "Поръчките постъпват директно в таблото ви с информация за статус и фактуриране."
    },
    {
     "q": "Подходящо ли е за малка ферма с директна продажба?",
     "a": "Да, инструментът е създаден специално за малки ферми, пазари и директна продажба на местни продукти."
    }
   ]
  },
  "da": {
   "slug": "software-direkte-salg-gaardbutik",
   "title": "Direkte salg fra gården – online gårdbutik | Ma Petite Ferme",
   "description": "Sælg direkte fra gården med en online butik: produkter, ordrer, kunder og betaling samlet ét sted. Prøv gratis i dag.",
   "h1": "Sælg dine gårdprodukter direkte online",
   "intro": "Opret din egen online gårdbutik på få minutter og modtag betaling fra dine kunder uden besvær. Perfekt til lokalt og direkte salg fra gården.",
   "bullets": [
    "Online butik til salg af dine gårdprodukter",
    "Administrer ordrer, afhentning og onlinebetaling nemt",
    "Fasthold dine kunder og følg dit direkte salg"
   ],
   "faq": [
    {
     "q": "Kan jeg sælge mine produkter online?",
     "a": "Ja, hver gård får sin egen online butik med sikker betaling via Ma Petite Ferme."
    },
    {
     "q": "Hvordan håndteres ordrer fra kunderne?",
     "a": "Alle ordrer vises i dit dashboard med status, fakturering og kundeoversigt."
    },
    {
     "q": "Er løsningen egnet til direkte salg fra gården?",
     "a": "Ja, Ma Petite Ferme er bygget til direkte gårdssalg og lokale fødevarekredsløb."
    }
   ]
  },
  "hr": {
   "slug": "softver-izravna-prodaja-farma",
   "title": "Izravna prodaja s farme na internetu | Ma Petite Ferme",
   "description": "Izravna prodaja s farme: online trgovina, narudžbe, kupci i plaćanja na jednom mjestu. Jednostavno za male proizvođače — isprobajte besplatno.",
   "h1": "Prodajte svoje proizvode izravno s farme, online",
   "intro": "Otvorite svoju online trgovinu kao mali poljoprivredni proizvođač za nekoliko minuta i upravljajte narudžbama, kupcima i naplatom bez muke. Savršeno za izravnu prodaju s farme i kratke opskrbne lance.",
   "bullets": [
    "Online trgovina za prodaju vaših farmskih proizvoda",
    "Pratite narudžbe, preuzimanja i online plaćanja",
    "Izgradite vjernost kupaca i nadzrite svoju izravnu prodaju"
   ],
   "faq": [
    {
     "q": "Mogu li prodavati svoje proizvode online?",
     "a": "Da, svaka farma dobiva vlastitu online trgovinu sa sigurnim načinom plaćanja."
    },
    {
     "q": "Kako se upravljaju narudžbama kupaca?",
     "a": "Sve narudžbe pristižu u vaš upravljački panel s prikazom statusa i mogućnošću fakturiranja."
    },
    {
     "q": "Je li alat prilagođen izravnoj prodaji s farme?",
     "a": "Da, Ma Petite Ferme je osmišljen upravo za izravnu prodaju s farme i kratke opskrbne lance."
    }
   ]
  },
  "el": {
   "slug": "logismiko-apeftheias-polisis-agrotikon-proionton",
   "title": "Απευθείας Πώληση Αγροτικών Προϊόντων Online | Ma Petite Ferme",
   "description": "Απευθείας πώληση αγροτικών προϊόντων: ηλεκτρονικό κατάστημα, παραγγελίες, πελάτες και online πληρωμές. Απλό και γρήγορο — δοκιμάστε δωρεάν.",
   "h1": "Πουλήστε τα προϊόντα σας απευθείας, online",
   "intro": "Δημιουργήστε το ηλεκτρονικό σας κατάστημα παραγωγού σε λίγα λεπτά και διαχειριστείτε παραγγελίες, πελάτες και πληρωμές χωρίς κόπο. Ιδανικό για απευθείας πώληση από το αγρόκτημα και τοπικά δίκτυα διανομής.",
   "bullets": [
    "Ηλεκτρονικό κατάστημα για τα αγροτικά σας προϊόντα",
    "Διαχείριση παραγγελιών, παραλαβών και online πληρωμών",
    "Χτίστε πιστή πελατεία και παρακολουθήστε τις πωλήσεις σας"
   ],
   "faq": [
    {
     "q": "Μπορώ να πουλώ τα προϊόντα μου online;",
     "a": "Ναι, κάθε αγρόκτημα διαθέτει ηλεκτρονικό κατάστημα με ασφαλή πληρωμή μέσω Ma Petite Ferme."
    },
    {
     "q": "Πώς διαχειρίζονται οι παραγγελίες;",
     "a": "Οι παραγγελίες των πελατών εμφανίζονται αυτόματα στον πίνακα ελέγχου σας με κατάσταση και τιμολόγηση."
    },
    {
     "q": "Είναι κατάλληλο για απευθείας πώληση από τον παραγωγό;",
     "a": "Ναι, το Ma Petite Ferme έχει σχεδιαστεί ειδικά για απευθείας πώληση από το αγρόκτημα και τοπικά κανάλια διανομής."
    }
   ]
  },
  "fi": {
   "slug": "suoramyynti-ohjelmisto-maatila",
   "title": "Suoramyyntiohjelmisto maatiloille | Ma Petite Ferme",
   "description": "Suoramyynti verkossa helposti: oma tilauskauppa, tuotteet, asiakkaat ja maksut yhdessä paikassa. Kokeile ilmaiseksi — Ma Petite Ferme.",
   "h1": "Myy maatilasi tuotteet suoraan verkossa",
   "intro": "Avaa oma verkkokauppa maatilallesi muutamassa minuutissa ja hallitse tilaukset, asiakkaat ja maksut vaivattomasti. Täydellinen ratkaisu suoramyyntiin ja lähiruoan myyntiin.",
   "bullets": [
    "Oma verkkokauppa maatilan tuotteille",
    "Hallitse tilaukset, noudot ja verkkomaksut helposti",
    "Pidä asiakkaasi tyytyväisinä ja seuraa myyntiäsi reaaliajassa"
   ],
   "faq": [
    {
     "q": "Voinko myydä tuotteitani verkossa?",
     "a": "Kyllä, jokaiselle maatilalle luodaan oma verkkokauppa suojatulla maksujärjestelmällä."
    },
    {
     "q": "Miten tilaukset hallitaan?",
     "a": "Asiakkaiden tilaukset näkyvät suoraan hallintapaneelissasi tiloineen ja laskutuksineen."
    },
    {
     "q": "Sopiiko tämä suoramyyntiin?",
     "a": "Ehdottomasti — työkalu on suunniteltu juuri maatilojen suoramyyntiin ja lähiruokakauppaan."
    }
   ]
  },
  "et": {
   "slug": "otsemuugi-tarkvara-vaikefarmidele",
   "title": "Otsemuügi tarkvara väikefarmidele | Ma Petite Ferme",
   "description": "Otsemuük lihtsaks: veebipood, tellimused, kliendid ja maksed ühes kohas. Proovi tasuta — loodud väikestele farmidele.",
   "h1": "Müü oma farmi tooteid otse — lihtsalt ja kiirelt",
   "intro": "Loo oma farmi veebipood mõne minutiga, võta vastu otsetellimusi ja halda kliente ilma tüsistusteta. Ma Petite Ferme on loodud just väikeste farmide ja otsemuügi jaoks.",
   "bullets": [
    "Veebipood farmi toodete müügiks otse tarbijale",
    "Halda tellimusi, kättesaamisi ja veebimakseid ühest kohast",
    "Hoia kliente ja jälgi oma otsemuügi tulemusi reaalajas"
   ],
   "faq": [
    {
     "q": "Kas saan oma farmi tooteid veebis müüa?",
     "a": "Jah, iga farm saab oma veebipoe koos turvalise makselahendusega — seadistamine võtab vaid mõne minuti."
    },
    {
     "q": "Kuidas tellimuste haldamine toimib?",
     "a": "Klientide tellimused ilmuvad otse sinu juhtpaneelile koos staatuse, arve ja kättesaamise infoga."
    },
    {
     "q": "Kas tarkvara sobib otsemuügiks?",
     "a": "Jah, Ma Petite Ferme on loodud spetsiaalselt farmide otsemuügi ja lühikeste tarneahelate jaoks."
    }
   ]
  },
  "pl": {
   "slug": "oprogramowanie-sprzedaz-bezposrednia-farma",
   "title": "Sprzedaż bezpośrednia z farmy online | Ma Petite Ferme",
   "description": "Sprzedaż bezpośrednia z farmy: sklep online, zamówienia, klienci i płatności w jednym miejscu. Prosto i skutecznie — zacznij za darmo.",
   "h1": "Sprzedawaj produkty z farmy bezpośrednio online",
   "intro": "Uruchom swój sklep internetowy producenta w kilka minut, przyjmuj zamówienia i zarządzaj klientami bez zbędnych komplikacji. Idealne rozwiązanie dla rolników sprzedających bezpośrednio z gospodarstwa.",
   "bullets": [
    "Sklep online do sprzedaży produktów rolnych i hodowlanych",
    "Zarządzaj zamówieniami, odbiorem i płatnościami online",
    "Buduj lojalność klientów i śledź sprzedaż bezpośrednią"
   ],
   "faq": [
    {
     "q": "Czy mogę sprzedawać produkty z farmy przez internet?",
     "a": "Tak, każde gospodarstwo otrzymuje własny sklep online z bezpieczną płatnością."
    },
    {
     "q": "Jak obsługiwane są zamówienia klientów?",
     "a": "Zamówienia trafiają prosto do Twojego pulpitu z informacją o statusie i fakturowaniem."
    },
    {
     "q": "Czy narzędzie nadaje się do sprzedaży bezpośredniej?",
     "a": "Tak, Ma Petite Ferme zostało stworzone z myślą o sprzedaży bezpośredniej z gospodarstwa i krótkich łańcuchach dostaw."
    }
   ]
  },
  "hu": {
   "slug": "farm-kozvetlen-ertekesites-szoftver",
   "title": "Közvetlen értékesítés szoftver kisgazdaságoknak | Ma Petite Ferme",
   "description": "Közvetlen értékesítés online: termékeladás, rendeléskezelés, fizetés egy helyen. Egyszerű kisgazdaságoknak — próbáld ki ingyen.",
   "h1": "Áruld termékeíd közvetlenül, online",
   "intro": "Hozd létre saját farmos webáruházadat percek alatt, kezeld rendeléseidet és vevőidet egyetlen felületen. Tökéletes megoldás a közvetlen értékesítést választó kis gazdaságok számára.",
   "bullets": [
    "Online bolt a farmod termékeinek értékesítéséhez",
    "Rendelések, átvétel és online fizetés egyszerű kezelése",
    "Vásárlói hűség építése és az értékesítés nyomon követése"
   ],
   "faq": [
    {
     "q": "Tudok online értékesíteni a gazdaságomból?",
     "a": "Igen, minden gazdaság saját online boltot kap biztonságos fizetési lehetőséggel."
    },
    {
     "q": "Hogyan érkeznek be a rendelések?",
     "a": "A vásárlói rendelések azonnal megjelennek az irányítópulton, státusszal és számlázással együtt."
    },
    {
     "q": "Alkalmas ez közvetlen értékesítésre a farmon?",
     "a": "Igen, a rendszert kifejezetten a farmon történő közvetlen értékesítésre terveztük."
    }
   ]
  },
  "lt": {
   "slug": "ukio-prekyba-internetu-tiesiogiai",
   "title": "Tiesioginė prekyba ūkio produktais internetu | Ma Petite Ferme",
   "description": "Parduokite ūkio produktus tiesiogiai: internetinė parduotuvė, užsakymai, klientai ir mokėjimai vienoje vietoje. Išbandykite nemokamai.",
   "h1": "Parduokite ūkio produktus tiesiogiai – greitai ir paprastai",
   "intro": "Sukurkite savo ūkio internetinę parduotuvę per kelias minutes ir priimkite užsakymus bei mokėjimus be jokių rūpesčių. Puikiai tinka smulkiems ūkiams, norintiems parduoti produktus tiesiogiai pirkėjams.",
   "bullets": [
    "Internetinė parduotuvė jūsų ūkio produktams parduoti",
    "Valdykite užsakymus, atsiėmimą ir mokėjimus vienoje vietoje",
    "Išlaikykite klientų lojalumą ir sekite tiesioginių pardavimų rezultatus"
   ],
   "faq": [
    {
     "q": "Ar galiu parduoti savo ūkio produktus internetu?",
     "a": "Taip, kiekvienas ūkis gauna savo internetinę parduotuvę su saugiu mokėjimu."
    },
    {
     "q": "Kaip valdomi klientų užsakymai?",
     "a": "Visi užsakymai rodomi jūsų valdymo skydelyje su būsena ir sąskaitos informacija."
    },
    {
     "q": "Ar įrankis tinkamas tiesioginei prekybai?",
     "a": "Taip, Ma Petite Ferme sukurta būtent smulkiems ūkiams, parduodantiems produktus tiesiogiai pirkėjams."
    }
   ]
  },
  "lv": {
   "slug": "tiessales-programmatra-mazajm-saimniecbm",
   "title": "Tiešās pārdošanas programmatūra saimniecībām | Ma Petite Ferme",
   "description": "Tiešā pārdošana no saimniecības: izveidojiet interneta veikalu, pārvaldiet pasūtījumus, klientus un maksājumus. Vienkārši — izmēģiniet bez maksas.",
   "h1": "Pārdodiet savas saimniecības produkciju tiešsaistē",
   "intro": "Izveidojiet savu zemnieka interneta veikalu dažu minūšu laikā, pieņemiet tiešos maksājumus un pārvaldiet pasūtījumus un klientus bez piepūles. Ideāli piemērots tiešajai pārdošanai no saimniecības un vietējai pārtikas apritei.",
   "bullets": [
    "Interneta veikals jūsu saimniecības produktu pārdošanai",
    "Pārvaldiet pasūtījumus, izsniegšanu un tiešsaistes maksājumus",
    "Veidojiet klientu lojalitāti un sekojiet līdzi tiešajām pārdošanām"
   ],
   "faq": [
    {
     "q": "Vai es varu pārdot savus produktus tiešsaistē?",
     "a": "Jā, katrai saimniecībai ir pieejams interneta veikals ar drošu maksājumu apstrādi."
    },
    {
     "q": "Kā tiek pārvaldīti pasūtījumi?",
     "a": "Klientu pasūtījumi nonāk jūsu vadības panelī ar statusu un rēķinu pārvaldību."
    },
    {
     "q": "Vai rīks ir piemērots tiešajai pārdošanai no saimniecības?",
     "a": "Jā, programmatūra ir izstrādāta tieši tiešajai pārdošanai no saimniecības un vietējai pārtikas apritei."
    }
   ]
  },
  "pt": {
   "slug": "software-venda-direta-agricola",
   "title": "Software de venda direta agrícola para pequenos produtores | Ma Petite Ferme",
   "description": "Venda direta na fazenda: loja online, pedidos, clientes e pagamentos num só lugar. Simples e acessível — teste grátis agora.",
   "h1": "Venda seus produtos direto do produtor, pela internet",
   "intro": "Monte sua loja online de produtor em minutos, receba pagamentos e gerencie pedidos e clientes sem complicação. Perfeito para a venda direta na fazenda e circuitos curtos de comercialização.",
   "bullets": [
    "Loja online para vender seus produtos da fazenda com facilidade",
    "Gerencie pedidos, retiradas e pagamentos online em um só painel",
    "Fidelize seus clientes e acompanhe todas as suas vendas diretas"
   ],
   "faq": [
    {
     "q": "Posso vender meus produtos pela internet?",
     "a": "Sim, cada fazenda tem sua própria loja online com pagamento seguro integrado."
    },
    {
     "q": "Como funciona o gerenciamento de pedidos?",
     "a": "Os pedidos dos clientes chegam direto no seu painel com status atualizado e faturamento automático."
    },
    {
     "q": "O sistema é adequado para venda direta ao consumidor?",
     "a": "Sim, a ferramenta foi criada especialmente para a venda direta na fazenda e os circuitos curtos de comercialização."
    }
   ]
  },
  "ro": {
   "slug": "software-vanzare-directa-ferma",
   "title": "Vânzare directă de la fermă online | Ma Petite Ferme",
   "description": "Vânzare directă de la fermă: magazin online, comenzi, clienți și plăți integrate. Simplu și eficient pentru micii producători — încearcă gratuit.",
   "h1": "Vinde produsele fermei tale direct, online",
   "intro": "Creează-ți magazinul online de producător în câteva minute și gestionează comenzile, clienții și încasările fără bătăi de cap. Perfect pentru vânzarea directă de la fermă și circuitele scurte de distribuție.",
   "bullets": [
    "Magazin online dedicat produselor tale de fermă",
    "Gestionează comenzi, ridicări și plăți online cu ușurință",
    "Fidelizează-ți clienții și urmărește vânzările directe în timp real"
   ],
   "faq": [
    {
     "q": "Pot să îmi vând produsele fermei direct online?",
     "a": "Da, fiecare fermă beneficiază de propriul magazin online cu plată securizată, gata de utilizare imediat."
    },
    {
     "q": "Cum sunt gestionate comenzile clienților?",
     "a": "Toate comenzile apar direct în tabloul tău de bord, cu statusul actualizat și facturare automată."
    },
    {
     "q": "Este potrivit pentru vânzarea directă de la poarta fermei?",
     "a": "Absolut, instrumentul este conceput special pentru producătorii care vând direct clienților, fără intermediari."
    }
   ]
  },
  "sk": {
   "slug": "software-priamy-predaj-farma",
   "title": "Priamy predaj z farmy online | Ma Petite Ferme",
   "description": "Priamy predaj z farmy: vytvorte si e-shop, spravujte objednávky, zákazníkov a platby online. Jednoducho a rýchlo — vyskúšajte zadarmo.",
   "h1": "Predávajte produkty z farmy priamo online",
   "intro": "Spustite vlastný farmársky e-shop za pár minút, prijímajte objednávky a platby bez zbytočnej administratívy. Ideálne riešenie pre priamy predaj z farmy aj lokálne potravinové reťazce.",
   "bullets": [
    "E-shop na predaj farmárskych produktov priamo zákazníkom",
    "Spravujte objednávky, vyzdvihnutia a online platby na jednom mieste",
    "Budujte vernosť zákazníkov a sledujte tržby z priameho predaja"
   ],
   "faq": [
    {
     "q": "Môžem predávať produkty z farmy online?",
     "a": "Áno, každá farma získa vlastný e-shop so zabezpečenou online platbou."
    },
    {
     "q": "Ako funguje správa objednávok?",
     "a": "Všetky objednávky zákazníkov sa zobrazia vo vašom prehľadnom paneli vrátane stavu a fakturácie."
    },
    {
     "q": "Je riešenie vhodné pre priamy predaj z farmy?",
     "a": "Áno, nástroj je navrhnutý priamo pre farmárov predávajúcich lokálne a v rámci krátkych dodávateľských reťazcov."
    }
   ]
  },
  "cs": {
   "slug": "software-primy-prodej-farma",
   "title": "Přímý prodej z farmy online | Ma Petite Ferme",
   "description": "Přímý prodej z farmy: vytvořte si e-shop, spravujte objednávky, zákazníky a platby online. Jednoduché řešení pro malé farmy — vyzkoušejte zdarma.",
   "h1": "Prodávejte přímo z farmy přes internet",
   "intro": "Spusťte svůj farmářský e-shop během pár minut a přijímejte objednávky, platby i zákazníky na jednom místě. Ideální nástroj pro přímý prodej a krátké dodavatelské řetězce.",
   "bullets": [
    "E-shop pro prodej farmářských produktů přímo zákazníkům",
    "Spravujte objednávky, vyzvednutí a online platby přehledně",
    "Budujte věrnost zákazníků a sledujte své tržby z přímého prodeje"
   ],
   "faq": [
    {
     "q": "Mohu prodávat své produkty online?",
     "a": "Ano, každá farma získá vlastní e-shop se zabezpečenou online platbou."
    },
    {
     "q": "Jak funguje správa objednávek?",
     "a": "Objednávky zákazníků se zobrazují v přehledném dashboardu včetně stavu a fakturace."
    },
    {
     "q": "Je nástroj vhodný pro přímý prodej z farmy?",
     "a": "Ano, aplikace je navržena přímo pro přímý prodej a krátké potravinové řetězce."
    }
   ]
  },
  "sl": {
   "slug": "programska-oprema-neposredna-prodaja-kmetija",
   "title": "Neposredna prodaja s kmetije – spletna trgovina | Ma Petite Ferme",
   "description": "Neposredna prodaja s kmetije: spletna trgovina, naročila, stranke in plačila na enem mestu. Preprosto in učinkovito – brezplačen preizkus.",
   "h1": "Prodajajte pridelke neposredno s kmetije",
   "intro": "Ustvarite svojo spletno trgovino kmeta v nekaj minutah, sprejemate plačila in upravljate naročila ter stranke brez nepotrebnega dela. Idealno za neposredno prodajo s kmetije in kratke dobavne verige.",
   "bullets": [
    "Spletna trgovina za prodajo kmetijskih pridelkov in izdelkov",
    "Upravljajte naročila, prevzeme in spletna plačila",
    "Gradite zvestobo strank in spremljajte svojo prodajo"
   ],
   "faq": [
    {
     "q": "Ali lahko prodajam svoje pridelke prek spleta?",
     "a": "Da, vsaka kmetija dobi lastno spletno trgovino z varnim plačilnim sistemom."
    },
    {
     "q": "Kako so upravljana naročila strank?",
     "a": "Naročila se samodejno pojavijo v vaši nadzorni plošči s statusom in možnostjo izdaje računov."
    },
    {
     "q": "Je orodje primerno za neposredno prodajo s kmetije?",
     "a": "Da, rešitev je zasnovana posebej za neposredno prodajo s kmetije in kratke dobavne verige."
    }
   ]
  }
 },
 "facturation": {
  "fr": {
   "slug": "logiciel-facturation-agriculteur",
   "title": "Logiciel de facturation pour agriculteur | Ma Petite Ferme",
   "description": "Logiciel de facturation pour agriculteurs et producteurs : factures numérotées, avoirs, clients et paiements. Conforme et simple, en français — essai gratuit.",
   "h1": "Facturez vos ventes en toute conformité",
   "intro": "Éditez des factures numérotées automatiquement, gérez vos avoirs, vos clients et le suivi des paiements. Ma Petite Ferme simplifie la facturation des producteurs fermiers et petites exploitations.",
   "bullets": [
    "Factures PDF numérotées séquentiellement et avoirs conformes",
    "Gérez clients, commandes et suivi des paiements",
    "Exportez et retrouvez tous vos documents en un clic"
   ],
   "faq": [
    {
     "q": "La numérotation est-elle conforme ?",
     "a": "Oui, les factures suivent une numérotation séquentielle sans rupture, avec avoirs pour les remboursements."
    },
    {
     "q": "Puis-je gérer mes clients ?",
     "a": "Oui, chaque client dispose d'une fiche avec son historique de commandes et de factures."
    },
    {
     "q": "Les factures sont-elles en PDF ?",
     "a": "Oui, chaque facture est générée en PDF téléchargeable et envoyable au client."
    }
   ]
  },
  "en": {
   "slug": "farm-invoicing-software",
   "title": "Farm Invoicing Software for Small Producers | Ma Petite Ferme",
   "description": "Farm invoicing software: auto-numbered invoices, credit notes, client tracking & payments. Simple, compliant, built for small farms — free trial.",
   "h1": "Invoice Your Farm Sales With Confidence",
   "intro": "Create automatically numbered invoices, manage credit notes, track clients and monitor payments — all in one place. Ma Petite Ferme makes billing effortless for small farms and independent producers.",
   "bullets": [
    "Auto-numbered PDF invoices and compliant credit notes",
    "Manage clients, orders and payment tracking in one dashboard",
    "Export and retrieve all your billing documents in a single click"
   ],
   "faq": [
    {
     "q": "Are invoices properly numbered and compliant?",
     "a": "Yes, Ma Petite Ferme generates sequential invoice numbers with no gaps, plus credit notes for any refunds — fully audit-ready."
    },
    {
     "q": "Can I manage my customer records?",
     "a": "Absolutely. Each client gets a dedicated profile with their full order history and all associated invoices."
    },
    {
     "q": "Are invoices delivered as PDF files?",
     "a": "Yes, every invoice is instantly generated as a downloadable PDF you can send directly to your customer."
    }
   ]
  },
  "es": {
   "slug": "software-facturacion-agricultores",
   "title": "Software de facturación para agricultores | Ma Petite Ferme",
   "description": "Facturación para agricultores y productores: facturas numeradas, abonos, clientes y pagos. Simple, conforme y en español — prueba gratuita.",
   "h1": "Factura tus ventas con total conformidad",
   "intro": "Crea facturas numeradas automáticamente, gestiona tus abonos, clientes y el seguimiento de cobros desde un solo lugar. Ma Petite Ferme simplifica la facturación de pequeños agricultores y explotaciones familiares.",
   "bullets": [
    "Facturas PDF numeradas de forma secuencial y abonos conformes",
    "Gestiona clientes, pedidos y seguimiento de pagos",
    "Exporta y recupera todos tus documentos en un clic"
   ],
   "faq": [
    {
     "q": "¿La numeración de las facturas cumple la normativa?",
     "a": "Sí, las facturas siguen una numeración secuencial sin saltos, con abonos para gestionar devoluciones y reembolsos."
    },
    {
     "q": "¿Puedo gestionar mis clientes dentro del software?",
     "a": "Sí, cada cliente tiene su propia ficha con el historial completo de pedidos y facturas emitidas."
    },
    {
     "q": "¿Las facturas se generan en PDF?",
     "a": "Sí, cada factura se genera en formato PDF, lista para descargar o enviar directamente al cliente."
    }
   ]
  },
  "it": {
   "slug": "software-fatturazione-agricoltori",
   "title": "Software fatturazione agricoltori e produttori | Ma Petite Ferme",
   "description": "Fatturazione per agricoltori: fatture numerate, note di credito, clienti e pagamenti. Semplice e conforme — prova gratuita.",
   "h1": "Fattura le tue vendite in modo semplice e conforme",
   "intro": "Crea fatture numerate automaticamente, gestisci note di credito, clienti e pagamenti in pochi clic. Ma Petite Ferme è pensato per piccoli agricoltori e produttori locali che vogliono stare in regola senza perdere tempo.",
   "bullets": [
    "Fatture PDF numerate in sequenza e note di credito conformi alla normativa",
    "Gestione clienti, ordini e monitoraggio pagamenti in un unico posto",
    "Esporta e ritrova tutti i tuoi documenti in un solo clic"
   ],
   "faq": [
    {
     "q": "La numerazione delle fatture è conforme alla legge italiana?",
     "a": "Sì, le fatture seguono una numerazione sequenziale senza interruzioni, con note di credito per eventuali rimborsi, nel rispetto della normativa fiscale italiana."
    },
    {
     "q": "Posso gestire i miei clienti all'interno del software?",
     "a": "Sì, ogni cliente ha una scheda dedicata con lo storico degli ordini e delle fatture emesse."
    },
    {
     "q": "Le fatture vengono generate in PDF?",
     "a": "Sì, ogni fattura è disponibile in formato PDF, pronta da scaricare o da inviare direttamente al cliente."
    }
   ]
  },
  "nl": {
   "slug": "facturatie-software-boer",
   "title": "Facturatie software voor boeren en kleine boerderijen | Ma Petite Ferme",
   "description": "Facturatie software voor boeren: genummerde facturen, creditnota's, klantenbeheer en betalingen bijhouden. Eenvoudig en conform — gratis proberen.",
   "h1": "Factureer uw verkopen snel en correct",
   "intro": "Maak automatisch genummerde facturen aan, beheer uw creditnota's, klanten en betalingen op één plek. Ma Petite Ferme maakt facturatie eenvoudig voor kleine boerderijen en hoeveverkoop.",
   "bullets": [
    "Opeenvolgend genummerde PDF-facturen en conforme creditnota's",
    "Klanten, bestellingen en betalingen overzichtelijk beheren",
    "Alle documenten in één klik exporteren en terugvinden"
   ],
   "faq": [
    {
     "q": "Voldoet de nummering aan de wettelijke vereisten?",
     "a": "Ja, facturen worden opeenvolgend genummerd zonder onderbrekingen, inclusief creditnota's voor terugbetalingen."
    },
    {
     "q": "Kan ik mijn klanten beheren in het systeem?",
     "a": "Ja, elke klant heeft een eigen fiche met een overzicht van bestellingen en factuurgeschiedenis."
    },
    {
     "q": "Worden facturen als PDF aangemaakt?",
     "a": "Ja, elke factuur wordt gegenereerd als downloadbare PDF die u direct naar uw klant kunt sturen."
    }
   ]
  },
  "de": {
   "slug": "rechnungssoftware-landwirt",
   "title": "Rechnungssoftware für Landwirte und Hofbetriebe | Ma Petite Ferme",
   "description": "Rechnungssoftware für Landwirte: nummerierte Rechnungen, Gutschriften, Kundenverwaltung und Zahlungsübersicht. Einfach und rechtskonform — kostenlos testen.",
   "h1": "Rechnungen für Ihren Hof – einfach und rechtssicher",
   "intro": "Erstellen Sie automatisch nummerierte Rechnungen, verwalten Sie Gutschriften, Kundendaten und Zahlungseingänge auf einen Blick. Ma Petite Ferme macht die Abrechnung für kleine Landwirtschaftsbetriebe und Direktvermarkter zum Kinderspiel.",
   "bullets": [
    "Automatisch nummerierte PDF-Rechnungen und rechtskonforme Gutschriften",
    "Kunden, Bestellungen und Zahlungsstatus zentral verwalten",
    "Alle Dokumente mit einem Klick exportieren und wiederfinden"
   ],
   "faq": [
    {
     "q": "Entspricht die Nummerierung den gesetzlichen Vorgaben?",
     "a": "Ja, alle Rechnungen werden fortlaufend und lückenlos nummeriert. Gutschriften für Rückerstattungen sind ebenfalls rechtskonform integriert."
    },
    {
     "q": "Kann ich meine Kunden direkt im System verwalten?",
     "a": "Ja, jeder Kunde erhält ein eigenes Profil mit vollständiger Bestell- und Rechnungshistorie."
    },
    {
     "q": "Werden die Rechnungen als PDF ausgegeben?",
     "a": "Ja, jede Rechnung wird als PDF generiert – direkt zum Herunterladen oder zum Versand an Ihre Kunden."
    }
   ]
  },
  "sv": {
   "slug": "faktureringsprogram-lantbruk",
   "title": "Faktureringsprogram för lantbrukare | Ma Petite Ferme",
   "description": "Faktureringsprogram för lantbrukare: numrerade fakturor, kreditnotor, kunder och betalningar. Enkelt och korrekt — testa gratis idag.",
   "h1": "Fakturera din gårdsförsäljning enkelt och korrekt",
   "intro": "Skapa automatiskt numrerade fakturor, hantera kreditnotor, kunder och betalningsuppföljning på ett ställe. Ma Petite Ferme gör faktureringen enkel för dig som driver ett litet lantbruk eller gårdsbutik.",
   "bullets": [
    "Sekventiellt numrerade PDF-fakturor och korrekta kreditnotor",
    "Hantera kunder, beställningar och betalningshistorik samlat",
    "Exportera och hitta alla dina dokument med ett klick"
   ],
   "faq": [
    {
     "q": "Följer numreringen svenska krav?",
     "a": "Ja, fakturorna numreras sekventiellt utan avbrott och kreditnotor skapas korrekt för eventuella återbetalningar."
    },
    {
     "q": "Kan jag hålla koll på mina kunder?",
     "a": "Ja, varje kund har ett eget kort med fullständig historik över beställningar och fakturor."
    },
    {
     "q": "Får jag fakturorna som PDF?",
     "a": "Ja, varje faktura genereras som en PDF som du enkelt kan ladda ner och skicka direkt till kunden."
    }
   ]
  },
  "da": {
   "slug": "fakturering-software-landmand",
   "title": "Faktureringssoftware til landmænd og producenter | Ma Petite Ferme",
   "description": "Faktureringssoftware til landmænd: nummererede fakturaer, kreditnotaer, kunder og betalinger. Enkelt og lovkrav. Prøv gratis.",
   "h1": "Fakturer dine salg nemt og korrekt",
   "intro": "Opret automatisk nummererede fakturaer, håndter kreditnotaer, kunder og betalingsopfølgning på ét sted. Ma Petite Ferme gør fakturering enkel for smålandbrug og lokale producenter.",
   "bullets": [
    "PDF-fakturaer med løbende nummerering og lovpligtige kreditnotaer",
    "Administrer kunder, ordrer og betalingsstatus samlet",
    "Eksporter og find alle dine dokumenter med ét klik"
   ],
   "faq": [
    {
     "q": "Overholder nummereringen de danske krav?",
     "a": "Ja, fakturaerne følger en ubrudt sekventiel nummerering og inkluderer kreditnotaer ved refunderinger, i overensstemmelse med gældende regler."
    },
    {
     "q": "Kan jeg administrere mine kunder i systemet?",
     "a": "Ja, hver kunde har sin egen profil med komplet historik over ordrer og fakturaer."
    },
    {
     "q": "Genereres fakturaerne som PDF?",
     "a": "Ja, hver faktura oprettes automatisk som en PDF, der kan downloades og sendes direkte til kunden."
    }
   ]
  },
  "bg": {
   "slug": "softuer-fakturirane-zemedelec",
   "title": "Софтуер за фактуриране за земеделци | Ma Petite Ferme",
   "description": "Фактуриране за земеделци и производители: номерирани фактури, кредитни известия, клиенти и плащания. Лесно и надеждно — безплатен пробен период.",
   "h1": "Издавайте фактури бързо и законосъобразно",
   "intro": "Ma Petite Ferme ви позволява да създавате автоматично номерирани фактури, да управлявате кредитни известия, клиенти и плащания без усилие. Идеалното решение за малки ферми и земеделски производители в България.",
   "bullets": [
    "Автоматично номерирани PDF фактури и законосъобразни кредитни известия",
    "Управлявайте клиенти, поръчки и проследяване на плащания",
    "Намирайте и експортирайте всички документи с едно кликване"
   ],
   "faq": [
    {
     "q": "Номерирането на фактурите отговаря ли на изискванията?",
     "a": "Да, фактурите следват последователно номериране без прекъсвания, с кредитни известия за възстановявания."
    },
    {
     "q": "Мога ли да управлявам своите клиенти?",
     "a": "Да, всеки клиент разполага с профил с пълна история на поръчките и фактурите."
    },
    {
     "q": "Фактурите генерират ли се като PDF?",
     "a": "Да, всяка фактура се генерира като PDF файл, който може да бъде изтеглен и изпратен директно на клиента."
    }
   ]
  },
  "hr": {
   "slug": "softver-fakturiranje-poljoprivrednici",
   "title": "Fakturiranje za poljoprivrednike i male farme | Ma Petite Ferme",
   "description": "Fakturiranje za poljoprivrednike: numerirani računi, povrati, klijenti i plaćanja. Jednostavno i usklađeno — isprobajte besplatno.",
   "h1": "Izdajte račune za svoju farmu bez muke",
   "intro": "Automatizirajte numeriranje računa, pratite plaćanja i upravljajte klijentima na jednom mjestu. Ma Petite Ferme je stvorena za male farme i obiteljske proizvođače koji žele urednu i usklađenu administraciju.",
   "bullets": [
    "Numerirani PDF računi i povratnice sukladni propisima",
    "Pregledna kartoteka klijenata s poviješću narudžbi i plaćanja",
    "Preuzimanje i slanje svih dokumenata jednim klikom"
   ],
   "faq": [
    {
     "q": "Je li numeriranje računa usklađeno s propisima?",
     "a": "Da, Ma Petite Ferme generira račune sa sekvencijalnim numeriranjem bez prekida, zajedno s ispravnim povratnicama za povrate."
    },
    {
     "q": "Mogu li pratiti sve svoje klijente?",
     "a": "Da, svaki klijent ima vlastitu karticu s cjelokupnom poviješću narudžbi, računa i plaćanja."
    },
    {
     "q": "Jesu li računi dostupni u PDF formatu?",
     "a": "Da, svaki račun automatski se generira kao PDF koji možete odmah preuzeti ili poslati klijentu e-poštom."
    }
   ]
  },
  "el": {
   "slug": "logismiko-timologisis-agrotis",
   "title": "Λογισμικό τιμολόγησης για αγρότες | Ma Petite Ferme",
   "description": "Τιμολόγηση για αγρότες και παραγωγούς: αριθμημένα τιμολόγια, πιστωτικά, πελάτες, πληρωμές. Απλό και νόμιμο — δοκιμάστε δωρεάν.",
   "h1": "Τιμολογήστε τις πωλήσεις σας σωστά και εύκολα",
   "intro": "Δημιουργήστε αυτόματα αριθμημένα τιμολόγια, διαχειριστείτε πιστωτικά σημειώματα, πελάτες και παρακολούθηση πληρωμών. Το Ma Petite Ferme απλοποιεί την τιμολόγηση για μικρές αγροτικές εκμεταλλεύσεις και παραγωγούς.",
   "bullets": [
    "Αριθμημένα PDF τιμολόγια σε αύξουσα σειρά και νόμιμα πιστωτικά σημειώματα",
    "Διαχείριση πελατών, παραγγελιών και παρακολούθηση πληρωμών",
    "Εξαγωγή και εύρεση όλων των εγγράφων σας με ένα κλικ"
   ],
   "faq": [
    {
     "q": "Η αρίθμηση των τιμολογίων είναι νόμιμη;",
     "a": "Ναι, τα τιμολόγια ακολουθούν αυστηρά διαδοχική αρίθμηση χωρίς κενά, με πιστωτικά σημειώματα για επιστροφές χρημάτων."
    },
    {
     "q": "Μπορώ να διαχειριστώ τους πελάτες μου;",
     "a": "Ναι, κάθε πελάτης έχει το δικό του προφίλ με πλήρες ιστορικό παραγγελιών και τιμολογίων."
    },
    {
     "q": "Τα τιμολόγια εκδίδονται σε PDF;",
     "a": "Ναι, κάθε τιμολόγιο δημιουργείται αυτόματα σε PDF, έτοιμο για λήψη ή αποστολή στον πελάτη."
    }
   ]
  },
  "fi": {
   "slug": "laskutusohjelmisto-maatilalle",
   "title": "Laskutusohjelmisto maatilalle | Ma Petite Ferme",
   "description": "Laskutusohjelmisto maanviljelijöille: numeroidut laskut, hyvityslaskut, asiakkaat ja maksuseuranta. Helppo ja luotettava — kokeile ilmaiseksi.",
   "h1": "Hallitse tilasi laskutus vaivattomasti",
   "intro": "Ma Petite Ferme luo automaattisesti numeroidut laskut, hyvityslaskut ja maksuseurannan pienille maatiloille ja tuottajille. Pidä kirjanpitosi järjestyksessä ilman turhaa vaivaa.",
   "bullets": [
    "Automaattisesti numeroidut PDF-laskut ja vaatimusten mukaiset hyvityslaskut",
    "Hallinnoi asiakkaita, tilauksia ja maksuseurantaa yhdessä paikassa",
    "Lataa ja löydä kaikki dokumentit yhdellä klikkauksella"
   ],
   "faq": [
    {
     "q": "Ovatko laskujen numerot lainmukaisia?",
     "a": "Kyllä, Ma Petite Ferme numeroi laskut automaattisesti peräkkäin ilman aukkoja, mikä vastaa kirjanpitovaatimuksia."
    },
    {
     "q": "Voinko hallita asiakastietoja?",
     "a": "Kyllä, jokaisella asiakkaalla on oma profiili tilaus- ja laskuhistorioineen."
    },
    {
     "q": "Saanko laskut PDF-muodossa?",
     "a": "Kyllä, jokainen lasku luodaan PDF-tiedostona, jonka voit ladata tai lähettää suoraan asiakkaalle."
    }
   ]
  },
  "et": {
   "slug": "arveldustarkvara-pollumajandus",
   "title": "Arveldustarkvara põllumajandustootjatele | Ma Petite Ferme",
   "description": "Arveldustarkvara väiketaludele: nummerdatud arved, kreeditarved, kliendid ja maksete jälgimine. Lihtne ja usaldusväärne — proovi tasuta.",
   "h1": "Halda oma talu arveldust lihtsalt ja korrektselt",
   "intro": "Loo automaatselt nummerdatud arveid, halda kreeditarveid ja jälgi makseid ühes kohas. Ma Petite Ferme muudab väiketalu ja tootja igapäevase arvelduse kiireks ja vaevavaaks.",
   "bullets": [
    "Järjepidevalt nummerdatud PDF-arved ja korrektne kreeditarve",
    "Halda kliente, tellimusi ja maksete staatust",
    "Leia ja ekspordi kõik dokumendid ühe klikiga"
   ],
   "faq": [
    {
     "q": "Kas arvete nummerdamine vastab nõuetele?",
     "a": "Jah, arved genereeritakse järjepideva numbrijadana ilma vahelejätmisteta, kreeditarved on samuti nõuetekohased."
    },
    {
     "q": "Kas saan hallata oma kliendiandmeid?",
     "a": "Jah, igal kliendil on oma kaart koos tellimuste ja arvete ajalooga."
    },
    {
     "q": "Kas arved väljastatakse PDF-formaadis?",
     "a": "Jah, iga arve genereeritakse allalaaditava ja kliendile saadetava PDF-failina."
    }
   ]
  },
  "lv": {
   "slug": "raotaju-rekinu-programmatra",
   "title": "Rēķinu programmatūra lauksaimniekiem | Ma Petite Ferme",
   "description": "Rēķinu programmatūra lauksaimniekiem: numurēti rēķini, kredītrēķini, klienti un maksājumi. Vienkārši un droši — izmēģini bez maksas.",
   "h1": "Izrakstiet rēķinus ātri un pareizi",
   "intro": "Ma Petite Ferme ļauj mazajiem lauksaimniekiem un ražotājiem ērti izveidot numurētus rēķinus, pārvaldīt klientus un izsekot maksājumiem. Aizmirstiet par papīra kaudzi — viss ir vienuviet, vienkārši un droši.",
   "bullets": [
    "Automātiski numurēti PDF rēķini un atbilstoši kredītrēķini",
    "Pārvaldiet klientus, pasūtījumus un maksājumu statusu",
    "Eksportējiet un atrodiet visus dokumentus ar vienu klikšķi"
   ],
   "faq": [
    {
     "q": "Vai rēķinu numerācija ir juridiskai prasībai atbilstoša?",
     "a": "Jā, rēķini tiek numurēti secīgi bez pārtraukumiem, un kredītrēķini tiek izsniegti atbilstoši normatīvajām prasībām."
    },
    {
     "q": "Vai varu glabāt klientu informāciju?",
     "a": "Jā, katram klientam ir sava karte ar visu pasūtījumu un rēķinu vēsturi."
    },
    {
     "q": "Vai rēķini ir pieejami PDF formātā?",
     "a": "Jā, katrs rēķins tiek automātiski ģenerēts PDF failā, ko var lejupielādēt vai nosūtīt klientam."
    }
   ]
  },
  "pt": {
   "slug": "software-faturamento-produtor-rural",
   "title": "Software de faturamento para produtor rural | Ma Petite Ferme",
   "description": "Faturamento para produtores rurais: notas numeradas, devoluções, clientes e pagamentos. Simples e confiável — experimente grátis.",
   "h1": "Emita suas notas fiscais com segurança e facilidade",
   "intro": "Gere faturas numeradas automaticamente, controle devoluções, clientes e recebimentos em um só lugar. Ma Petite Ferme foi feita para simplificar a gestão financeira de pequenos produtores e agricultores familiares.",
   "bullets": [
    "Faturas em PDF numeradas sequencialmente e notas de crédito conformes",
    "Gerencie clientes, pedidos e acompanhamento de pagamentos",
    "Exporte e acesse todos os seus documentos com um clique"
   ],
   "faq": [
    {
     "q": "A numeração das faturas segue algum padrão?",
     "a": "Sim, todas as faturas recebem numeração sequencial contínua, sem lacunas, garantindo conformidade e rastreabilidade."
    },
    {
     "q": "Posso cadastrar e acompanhar meus clientes?",
     "a": "Sim, cada cliente tem um cadastro completo com histórico de pedidos e faturas emitidas."
    },
    {
     "q": "As faturas são geradas em PDF?",
     "a": "Sim, cada fatura é gerada em PDF, pronta para download ou envio direto ao cliente."
    }
   ]
  },
  "hu": {
   "slug": "szamlazasi-szoftver-gazdalkodoknak",
   "title": "Számlázási szoftver gazdálkodóknak | Ma Petite Ferme",
   "description": "Számlázás kisgazdaságoknak: sorszámozott számlák, jóváírások, ügyfelek és fizetések kezelése. Egyszerű és megbízható — próbáld ingyen.",
   "h1": "Számlázz egyszerűen és szabályosan",
   "intro": "Állíts ki automatikusan sorszámozott számlákat, kezeld jóváírásaidat, ügyfeleidet és fizetéseid nyilvántartását. A Ma Petite Ferme megkönnyíti a kisgazdaságok és termelők számlázását.",
   "bullets": [
    "Sorszámozott PDF-számlák és szabályos jóváírások automatikusan",
    "Ügyfelek, rendelések és fizetési előzmények egy helyen",
    "Minden dokumentum exportálható és megtalálható egy kattintással"
   ],
   "faq": [
    {
     "q": "Megfelel a sorszámozás a jogszabályi előírásoknak?",
     "a": "Igen, a számlák folyamatos, megszakítás nélküli sorszámozást kapnak, visszatérítésekhez jóváírással kiegészítve."
    },
    {
     "q": "Kezelhetem az ügyfeleimet is?",
     "a": "Igen, minden ügyfélhez külön adatlap tartozik a rendelési és számlázási előzmények teljes áttekintésével."
    },
    {
     "q": "PDF formátumban kapom meg a számlákat?",
     "a": "Igen, minden számla letölthető és az ügyfélnek azonnal elküldhető PDF formátumban készül el."
    }
   ]
  },
  "pl": {
   "slug": "oprogramowanie-fakturowanie-rolnik",
   "title": "Fakturowanie dla rolników i producentów | Ma Petite Ferme",
   "description": "Fakturowanie dla rolników: numerowane faktury PDF, korekty, klienci i płatności. Proste i zgodne z przepisami — zacznij za darmo.",
   "h1": "Wystawiaj faktury szybko i zgodnie z przepisami",
   "intro": "Ma Petite Ferme pozwala rolnikom i małym gospodarstwom wystawiać automatycznie numerowane faktury PDF, zarządzać korektami oraz śledzić płatności klientów. Koniec z papierowym chaosem — wszystko w jednym miejscu.",
   "bullets": [
    "Faktury PDF z automatyczną, ciągłą numeracją i zgodne korekty",
    "Kartoteki klientów z historią zamówień i płatności",
    "Eksportuj i odnajduj wszystkie dokumenty jednym kliknięciem"
   ],
   "faq": [
    {
     "q": "Czy numeracja faktur spełnia wymogi prawne?",
     "a": "Tak, faktury otrzymują kolejne numery bez przerw w sekwencji, a korekty są wystawiane zgodnie z obowiązującymi przepisami."
    },
    {
     "q": "Czy mogę zarządzać bazą klientów?",
     "a": "Tak, każdy klient ma własną kartotekę z pełną historią zamówień i wystawionych faktur."
    },
    {
     "q": "Czy faktury są generowane w formacie PDF?",
     "a": "Tak, każda faktura jest automatycznie tworzona jako plik PDF gotowy do pobrania lub wysyłki do klienta."
    }
   ]
  },
  "ro": {
   "slug": "software-facturare-fermier",
   "title": "Software facturare pentru fermieri | Ma Petite Ferme",
   "description": "Facturare pentru fermieri si producatori: facturi numerotate, stornari, clienti si plati. Simplu, conform si gratuit de incercat.",
   "h1": "Facturează vânzările fermei tale fără bătăi de cap",
   "intro": "Generează facturi numerotate automat, gestionează stornările, clienții și încasările dintr-un singur loc. Ma Petite Ferme este soluția de facturare gândită special pentru micii fermieri și producători locali.",
   "bullets": [
    "Facturi PDF numerotate secvențial și stornări conforme cu legislația",
    "Gestionează clienți, comenzi și urmărirea plăților",
    "Exportă și regăsește toate documentele tale cu un singur clic"
   ],
   "faq": [
    {
     "q": "Numerotarea facturilor respectă cerințele legale?",
     "a": "Da, facturile sunt numerotate secvențial fără întreruperi, iar stornările sunt generate automat pentru rambursări."
    },
    {
     "q": "Pot gestiona mai mulți clienți în aplicație?",
     "a": "Da, fiecare client are o fișă proprie cu istoricul complet al comenzilor și facturilor emise."
    },
    {
     "q": "Facturile sunt disponibile în format PDF?",
     "a": "Da, fiecare factură este generată automat în PDF, gata de descărcat sau trimis direct clientului."
    }
   ]
  },
  "lt": {
   "slug": "saskaitu-issyrasymo-programele-ukiui",
   "title": "Sąskaitų išrašymo programėlė ūkininkams | Ma Petite Ferme",
   "description": "Sąskaitų išrašymas ūkininkams: sunumeruotos sąskaitos, kreditai, klientai ir mokėjimai. Paprasta ir tvarkinga — išbandykite nemokamai.",
   "h1": "Išrašykite sąskaitas teisingai ir greitai",
   "intro": "Ma Petite Ferme leidžia ūkininkams ir smulkiems gamintojams automatiškai numeruoti sąskaitas, valdyti klientus ir sekti mokėjimus. Viskas vienoje vietoje — tvarkinga, paprasta ir patikima.",
   "bullets": [
    "Automatiškai sunumeruotos PDF sąskaitos ir taisyklingi kreditiniai dokumentai",
    "Valdykite klientus, užsakymus ir mokėjimų istoriją",
    "Eksportuokite ir raskite visus dokumentus vienu paspaudimu"
   ],
   "faq": [
    {
     "q": "Ar sąskaitų numeracija atitinka reikalavimus?",
     "a": "Taip, sąskaitos numeruojamos nuosekliai be pertrūkių, o grąžinimams išrašomi taisyklingi kreditiniai dokumentai."
    },
    {
     "q": "Ar galiu tvarkyti savo klientų duomenis?",
     "a": "Taip, kiekvienam klientui sukuriama kortelė su visa užsakymų ir sąskaitų istorija."
    },
    {
     "q": "Ar sąskaitos generuojamos PDF formatu?",
     "a": "Taip, kiekviena sąskaita automatiškai sukuriama kaip PDF failas, kurį galima atsisiųsti arba išsiųsti klientui."
    }
   ]
  },
  "sk": {
   "slug": "fakturacny-software-pre-farmara",
   "title": "Fakturačný softvér pre farmárov a malé farmy | Ma Petite Ferme",
   "description": "Fakturačný softvér pre farmárov: číslované faktúry, dobropisy, správa klientov a platieb. Jednoduchý a spoľahlivý — vyskúšajte zadarmo.",
   "h1": "Vystavujte faktúry rýchlo a bez starostí",
   "intro": "Automaticky číslované faktúry, dobropisy a prehľad platieb na jednom mieste. Ma Petite Ferme uľahčuje fakturáciu malým farmám a rodinným hospodárstvam na Slovensku.",
   "bullets": [
    "Číslované PDF faktúry a dobropisy v súlade s predpismi",
    "Správa klientov, objednávok a sledovanie platieb",
    "Všetky dokumenty nájdete a exportujete jedným kliknutím"
   ],
   "faq": [
    {
     "q": "Je číslovanie faktúr v súlade so slovenskou legislatívou?",
     "a": "Áno, faktúry sú číslované sekvenčne bez prerušenia, s možnosťou vystaviť dobropis pri vrátení platby."
    },
    {
     "q": "Môžem spravovať svojich odberateľov?",
     "a": "Áno, každý klient má vlastnú kartu s históriou objednávok a vystavených faktúr."
    },
    {
     "q": "Sú faktúry generované vo formáte PDF?",
     "a": "Áno, každú faktúru môžete stiahnuť ako PDF alebo ju priamo odoslať klientovi."
    }
   ]
  },
  "cs": {
   "slug": "fakturacni-software-zemedelec",
   "title": "Fakturační software pro zemědělce | Ma Petite Ferme",
   "description": "Fakturace pro zemědělce a malé farmy: číslované faktury, dobropisy, zákazníci a platby. Jednoduché a přehledné — vyzkoušejte zdarma.",
   "h1": "Vystavujte faktury snadno a správně",
   "intro": "Ma Petite Ferme umožňuje malým farmám a pěstitelům vystavovat automaticky číslované faktury, spravovat dobropisy a sledovat platby zákazníků. Vše na jednom místě, bez zbytečné administrativy.",
   "bullets": [
    "Číslované PDF faktury a dobropisy v souladu s předpisy",
    "Přehled zákazníků, objednávek a stavu plateb",
    "Všechny dokumenty exportujete nebo najdete jediným kliknutím"
   ],
   "faq": [
    {
     "q": "Je číslování faktur v souladu s předpisy?",
     "a": "Ano, faktury jsou číslovány průběžně bez přerušení a systém automaticky generuje dobropisy pro případné vrácení plateb."
    },
    {
     "q": "Mohu spravovat záznamy o zákaznících?",
     "a": "Ano, každý zákazník má vlastní kartu s historií objednávek a vystavených faktur."
    },
    {
     "q": "Jsou faktury ve formátu PDF?",
     "a": "Ano, každá faktura je vygenerována jako PDF, které si můžete stáhnout nebo přímo odeslat zákazníkovi."
    }
   ]
  },
  "sl": {
   "slug": "programska-oprema-fakturiranje-kmetija",
   "title": "Fakturiranje za kmete in pridelovalce | Ma Petite Ferme",
   "description": "Programska oprema za fakturiranje kmetij: oštevilčeni računi, dobropisi, stranke in plačila. Preprosto in skladno — brezplačen preizkus.",
   "h1": "Izdajajte račune brez zapletov",
   "intro": "Ma Petite Ferme vam omogoča samodejno oštevilčevanje računov, upravljanje dobropisov in sledenje plačilom za vaše kmetijsko podjetje. Preprosta rešitev, zasnovana posebej za male kmetije in pridelovalce.",
   "bullets": [
    "Samodejno zaporedno oštevilčeni računi v PDF in skladni dobropisi",
    "Upravljajte stranke, naročila in sledenje plačilom na enem mestu",
    "Izvozite in poiščite vse dokumente z enim klikom"
   ],
   "faq": [
    {
     "q": "Ali je oštevilčevanje računov skladno z zakonodajo?",
     "a": "Da, računi sledijo zaporedni številčni shemi brez prekinitev, vključno z dobropisi za povračila."
    },
    {
     "q": "Ali lahko upravljam podatke o svojih strankah?",
     "a": "Da, vsaka stranka ima svojo kartico z zgodovino naročil in računov."
    },
    {
     "q": "Ali so računi na voljo v obliki PDF?",
     "a": "Da, vsak račun se samodejno ustvari kot PDF, ki ga lahko prenesete ali pošljete stranki."
    }
   ]
  }
 },
 "gratuit": {
  "fr": {
   "slug": "logiciel-gratuit-agriculteur",
   "title": "Logiciel de gestion agricole gratuit | Ma Petite Ferme",
   "description": "Logiciel de gestion agricole gratuit pour éleveurs et producteurs : animaux, productions et ventes dès 0 €/mois. Simple, en français — commencez gratuitement.",
   "h1": "Un logiciel de gestion agricole gratuit pour démarrer",
   "intro": "Commencez gratuitement avec l'offre à 0 €/mois de Ma Petite Ferme : gérez vos animaux, vos productions et vos premières ventes, puis évoluez vers une offre supérieure quand vous grandissez.",
   "bullets": [
    "Offre gratuite à 0 €/mois pour bien démarrer",
    "Gérez animaux, productions et ventes essentielles",
    "Passez à une offre supérieure quand votre ferme grandit"
   ],
   "faq": [
    {
     "q": "L'offre gratuite est-elle vraiment à 0 € ?",
     "a": "Oui, vous pouvez utiliser Ma Petite Ferme gratuitement, sans carte bancaire pour démarrer."
    },
    {
     "q": "Que contient l'offre gratuite ?",
     "a": "Les fonctions essentielles pour gérer votre élevage et vos ventes ; les offres payantes ajoutent des fonctionnalités avancées."
    },
    {
     "q": "Puis-je changer d'offre plus tard ?",
     "a": "Oui, vous pouvez passer à une offre supérieure à tout moment depuis votre compte."
    }
   ]
  },
  "en": {
   "slug": "free-farm-management-software",
   "title": "Free Farm Management Software for Small Farms | Ma Petite Ferme",
   "description": "Free farm management software: track livestock, crops and sales from $0/month. Easy to use, no credit card needed — start free with Ma Petite Ferme today.",
   "h1": "Free Farm Management Software to Get You Started",
   "intro": "Ma Petite Ferme offers a free plan so small farms and homesteads can hit the ground running — manage your animals, harvests, and sales at zero cost. Scale up to a paid plan whenever your operation grows.",
   "bullets": [
    "Free $0/month plan — no credit card required to sign up",
    "Track livestock, crops, and essential sales in one place",
    "Upgrade to a higher plan anytime as your farm expands"
   ],
   "faq": [
    {
     "q": "Is the free plan really $0 with no hidden fees?",
     "a": "Absolutely. You can start using Ma Petite Ferme at no cost and no credit card is required to create your account."
    },
    {
     "q": "What features are included in the free plan?",
     "a": "The free plan covers the core tools you need to manage your livestock and track sales; paid plans unlock advanced features for growing operations."
    },
    {
     "q": "Can I switch to a paid plan later?",
     "a": "Yes — you can upgrade to any higher-tier plan at any time directly from your Ma Petite Ferme account dashboard."
    }
   ]
  },
  "es": {
   "slug": "software-gestion-agricola-gratis",
   "title": "Software de gestión agrícola gratis | Ma Petite Ferme",
   "description": "Software agrícola gratis para ganaderos y productores: animales, producción y ventas desde 0 €/mes. Sencillo y sin tarjeta — empieza ahora.",
   "h1": "Gestiona tu granja gratis desde el primer día",
   "intro": "Ma Petite Ferme te ofrece un plan gratuito a 0 €/mes para que empieces sin riesgo: controla tus animales, tus producciones y tus primeras ventas con total facilidad. Cuando tu explotación crezca, escalar a un plan superior es cuestión de un clic.",
   "bullets": [
    "Plan gratuito a 0 €/mes, sin tarjeta bancaria necesaria",
    "Gestión de animales, producción y ventas esenciales desde el primer acceso",
    "Amplía tu plan cuando tu granja o ganadería lo necesite"
   ],
   "faq": [
    {
     "q": "¿El plan gratuito es realmente a 0 €?",
     "a": "Sí, puedes usar Ma Petite Ferme sin coste alguno y sin necesidad de introducir ninguna tarjeta bancaria para empezar."
    },
    {
     "q": "¿Qué incluye el plan gratuito?",
     "a": "Incluye las funciones esenciales para gestionar tu ganadería y tus ventas; los planes de pago añaden herramientas avanzadas para explotaciones en crecimiento."
    },
    {
     "q": "¿Puedo cambiar de plan más adelante?",
     "a": "Por supuesto, puedes actualizar a un plan superior en cualquier momento directamente desde tu cuenta, sin interrupciones."
    }
   ]
  },
  "it": {
   "slug": "software-gestione-agricola-gratuito",
   "title": "Software gestione agricola gratuito per piccoli allevatori | Ma Petite Ferme",
   "description": "Software agricolo gratuito per allevatori e produttori: animali, produzioni e vendite da 0 €/mese. Semplice e intuitivo — inizia subito gratis.",
   "h1": "Gestisci la tua fattoria gratis, fin dal primo giorno",
   "intro": "Con il piano gratuito a 0 €/mese di Ma Petite Ferme puoi subito tenere traccia dei tuoi animali, delle produzioni e delle vendite. Quando la tua attività cresce, passare a un piano superiore è semplice e veloce.",
   "bullets": [
    "Piano gratuito a 0 €/mese, nessuna carta di credito richiesta",
    "Gestisci animali, produzioni e vendite essenziali in un unico posto",
    "Scala verso un piano avanzato quando la tua fattoria si espande"
   ],
   "faq": [
    {
     "q": "Il piano gratuito è davvero a 0 €?",
     "a": "Sì, puoi iniziare a usare Ma Petite Ferme senza pagare nulla e senza inserire i dati della carta di credito."
    },
    {
     "q": "Cosa include il piano gratuito?",
     "a": "Tutte le funzioni essenziali per gestire il tuo allevamento e le tue vendite; i piani a pagamento aggiungono strumenti avanzati per esigenze maggiori."
    },
    {
     "q": "Posso cambiare piano in seguito?",
     "a": "Certo, puoi passare a un piano superiore in qualsiasi momento direttamente dal tuo account, senza interruzioni."
    }
   ]
  },
  "de": {
   "slug": "kostenlose-landwirtschaft-software",
   "title": "Kostenlose Landwirtschaftssoftware für Kleinbetriebe | Ma Petite Ferme",
   "description": "Kostenlose Landwirtschaftssoftware: Tiere, Produktion und Verkäufe ab 0 €/Monat verwalten. Einfach & sofort startklar — jetzt kostenlos loslegen.",
   "h1": "Kostenlos starten – Landwirtschaftssoftware für Ihren Betrieb",
   "intro": "Mit dem 0-€-Tarif von Ma Petite Ferme verwalten Sie Ihre Tiere, Erzeugnisse und ersten Verkäufe ohne Risiko. Wächst Ihr Betrieb, wechseln Sie einfach auf einen leistungsstärkeren Plan.",
   "bullets": [
    "Gratis-Tarif ab 0 €/Monat – ohne Kreditkarte starten",
    "Tiere, Produktion und Kernverkäufe zentral im Blick behalten",
    "Jederzeit flexibel auf einen höheren Plan upgraden"
   ],
   "faq": [
    {
     "q": "Ist der Gratis-Tarif wirklich komplett kostenlos?",
     "a": "Ja, Sie können Ma Petite Ferme dauerhaft kostenlos nutzen – keine Kreditkarte erforderlich, um zu starten."
    },
    {
     "q": "Welche Funktionen sind im kostenlosen Tarif enthalten?",
     "a": "Alle wesentlichen Funktionen zur Verwaltung Ihres Tierbestands und Ihrer Verkäufe sind enthalten; kostenpflichtige Pläne bieten erweiterte Möglichkeiten."
    },
    {
     "q": "Kann ich später auf einen anderen Tarif wechseln?",
     "a": "Ja, ein Upgrade auf einen höheren Plan ist jederzeit direkt aus Ihrem Konto heraus möglich."
    }
   ]
  },
  "sv": {
   "slug": "gratis-lantbruksprogram",
   "title": "Gratis lantbruksprogram för småbönder | Ma Petite Ferme",
   "description": "Gratis lantbruksprogram för dig med liten gård: hantera djur, produktion och försäljning från 0 kr/mån. Enkelt och smidigt — kom igång gratis idag.",
   "h1": "Gratis lantbruksprogram – kom igång utan kostnad",
   "intro": "Med Ma Petite Fermes gratisplan på 0 kr/månad får du direkt koll på dina djur, din produktion och dina försäljningar. Uppgradera enkelt när din gård växer och du behöver mer.",
   "bullets": [
    "Gratisplan på 0 kr/mån – inga dolda avgifter",
    "Hantera djur, produktion och grundläggande försäljning",
    "Uppgradera smidigt när gårdens behov ökar"
   ],
   "faq": [
    {
     "q": "Är gratisplanen verkligen helt gratis?",
     "a": "Ja, du kan använda Ma Petite Ferme utan kostnad och behöver inget kreditkort för att komma igång."
    },
    {
     "q": "Vad ingår i gratisplanen?",
     "a": "Du får tillgång till de viktigaste funktionerna för att sköta ditt djurhållning och din försäljning. Betalplaner lägger till avancerade verktyg när du är redo."
    },
    {
     "q": "Kan jag byta plan senare?",
     "a": "Ja, du kan när som helst uppgradera till en högre plan direkt från ditt konto utan avbrott i tjänsten."
    }
   ]
  },
  "nl": {
   "slug": "gratis-boerderij-beheersoftware",
   "title": "Gratis boerderijbeheersoftware voor kleine boeren | Ma Petite Ferme",
   "description": "Gratis boerderijsoftware voor boeren en kwekers: dieren, productie en verkoop vanaf 0 €/maand. Eenvoudig starten, geen creditcard nodig.",
   "h1": "Gratis boerderijsoftware om meteen mee te starten",
   "intro": "Start vandaag kosteloos met het 0 €/maand-abonnement van Ma Petite Ferme en beheer uw dieren, productie en eerste verkopen. Groeit uw bedrijf? Schakel dan eenvoudig over naar een uitgebreider pakket.",
   "bullets": [
    "Gratis abonnement à 0 €/maand, geen creditcard vereist",
    "Beheer dieren, productie en essentiële verkoopgegevens",
    "Upgrade naar een hoger pakket wanneer uw boerderij groeit"
   ],
   "faq": [
    {
     "q": "Is het gratis abonnement echt helemaal kosteloos?",
     "a": "Ja, u kunt Ma Petite Ferme gratis gebruiken zonder creditcard om te beginnen."
    },
    {
     "q": "Wat is er inbegrepen in het gratis abonnement?",
     "a": "Alle basisfuncties om uw dieren en verkopen te beheren; betaalde abonnementen voegen geavanceerde functies toe."
    },
    {
     "q": "Kan ik later van abonnement wisselen?",
     "a": "Ja, u kunt op elk moment vanuit uw account upgraden naar een hoger abonnement."
    }
   ]
  },
  "da": {
   "slug": "gratis-landbrugssoftware",
   "title": "Gratis landbrugssoftware til små landbrug | Ma Petite Ferme",
   "description": "Gratis landbrugssoftware til landmænd: styr dyr, produktion og salg fra 0 kr/md. Nemt og overskueligt — kom i gang gratis i dag.",
   "h1": "Gratis landbrugssoftware — kom godt i gang",
   "intro": "Start helt gratis med Ma Petite Fermes 0 kr/md-plan og få styr på dine dyr, din produktion og dit salg fra dag ét. Opgrader nemt til en større plan, når din bedrift vokser.",
   "bullets": [
    "Gratis plan til 0 kr/md — ingen kreditkort kræves",
    "Administrer dyr, produktion og salg samlet ét sted",
    "Opgrader til en større plan, når du har brug for mere"
   ],
   "faq": [
    {
     "q": "Er gratisplanen virkelig helt gratis?",
     "a": "Ja, du kan bruge Ma Petite Ferme uden at betale en krone — og du behøver ikke indtaste et kreditkortnummer for at komme i gang."
    },
    {
     "q": "Hvad er inkluderet i gratisplanen?",
     "a": "Du får adgang til de vigtigste funktioner til at styre dyr, produktion og salg. De betalte planer tilbyder avancerede funktioner til større bedrifter."
    },
    {
     "q": "Kan jeg skifte plan senere?",
     "a": "Ja, du kan til enhver tid opgradere til en højere plan direkte fra din konto — hurtigt og uden besvær."
    }
   ]
  },
  "bg": {
   "slug": "bezplaten-softuer-ferma",
   "title": "Безплатен софтуер за управление на ферма | Ma Petite Ferme",
   "description": "Безплатен софтуер за ферма: животни, производство и продажби от 0 €/месец. Лесен старт без карта — опитайте безплатно днес.",
   "h1": "Управлявайте фермата си безплатно от ден първи",
   "intro": "Ma Petite Ferme ви предлага безплатен план от 0 €/месец, с който проследявате животните, производството и продажбите си без никакъв риск. Когато фермата ви расте, просто преминете към по-разширен план.",
   "bullets": [
    "Безплатен план от 0 €/месец — без банкова карта",
    "Управлявайте животни, производство и основни продажби",
    "Надградете плана си лесно, когато имате нужда от повече"
   ],
   "faq": [
    {
     "q": "Наистина ли безплатният план е на 0 €?",
     "a": "Да, можете да използвате Ma Petite Ferme напълно безплатно, без да въвеждате банкова карта при регистрацията."
    },
    {
     "q": "Какво включва безплатният план?",
     "a": "Всички основни функции за управление на животни, производство и продажби; платените планове добавят разширени инструменти и отчети."
    },
    {
     "q": "Мога ли да сменя плана си по-късно?",
     "a": "Разбира се — можете да преминете към по-висок план по всяко време директно от вашия профил в Ma Petite Ferme."
    }
   ]
  },
  "el": {
   "slug": "",
   "title": "Δωρεάν λογισμικό διαχείρισης αγροκτήματος | Ma Petite Ferme",
   "description": "Δωρεάν λογισμικό για μικρές φάρμες: ζώα, παραγωγή και πωλήσεις από 0 €/μήνα. Απλό και γρήγορο — ξεκινήστε δωρεάν σήμερα.",
   "h1": "Δωρεάν λογισμικό για τη μικρή σας φάρμα",
   "intro": "Ξεκινήστε χωρίς κόστος με το πλάνο 0 €/μήνα του Ma Petite Ferme: παρακολουθήστε τα ζώα σας, την παραγωγή και τις πρώτες πωλήσεις σας. Μεγαλώνετε με τον ρυθμό σας και αναβαθμιστείτε όταν το αγρόκτημά σας το απαιτεί.",
   "bullets": [
    "Πλάνο 0 €/μήνα — χωρίς πιστωτική κάρτα για να ξεκινήσετε",
    "Διαχειριστείτε ζώα, παραγωγή και βασικές πωλήσεις εύκολα",
    "Αναβαθμιστείτε σε ανώτερο πλάνο όταν η φάρμα σας μεγαλώσει"
   ],
   "faq": [
    {
     "q": "Είναι πραγματικά δωρεάν το βασικό πλάνο;",
     "a": "Ναι, μπορείτε να χρησιμοποιήσετε το Ma Petite Ferme εντελώς δωρεάν, χωρίς να χρειαστεί πιστωτική κάρτα για να ξεκινήσετε."
    },
    {
     "q": "Τι περιλαμβάνει το δωρεάν πλάνο;",
     "a": "Όλες τις βασικές λειτουργίες για τη διαχείριση της εκτροφής και των πωλήσεών σας. Τα επί πληρωμή πλάνα προσθέτουν προχωρημένα εργαλεία για μεγαλύτερες ανάγκες."
    },
    {
     "q": "Μπορώ να αλλάξω πλάνο αργότερα;",
     "a": "Φυσικά, μπορείτε να αναβαθμιστείτε σε ανώτερο πλάνο οποιαδήποτε στιγμή μέσα από τον λογαριασμό σας, χωρίς καμία δέσμευση."
    }
   ]
  },
  "hr": {
   "slug": "besplatni-softver-za-upravljanje-farmom",
   "title": "Besplatni softver za upravljanje farmom | Ma Petite Ferme",
   "description": "Besplatni softver za male farme i uzgajivače: upravljajte životinjama, proizvodnjom i prodajom od 0 €/mj. Jednostavno — počnite besplatno.",
   "h1": "Besplatni softver za vašu malu farmu",
   "intro": "Započnite bez troškova s Ma Petite Ferme ponudom od 0 €/mjesec: pratite životinje, upravljajte proizvodnjom i prvim prodajama, a kada vaša farma poraste — jednostavno prijeđite na napredniji plan.",
   "bullets": [
    "Besplatni plan od 0 €/mj za lagani početak",
    "Pratite životinje, proizvodnju i ključne prodaje",
    "Nadogradite plan kada vaša farma naraste"
   ],
   "faq": [
    {
     "q": "Je li besplatni plan stvarno bez naknade?",
     "a": "Da, Ma Petite Ferme možete koristiti potpuno besplatno — nije potrebna kreditna kartica za početak."
    },
    {
     "q": "Što je uključeno u besplatni plan?",
     "a": "Sve osnovne funkcije za upravljanje uzgojem i prodajom; plaćeni planovi donose napredne mogućnosti za rastuće farme."
    },
    {
     "q": "Mogu li promijeniti plan kasnije?",
     "a": "Da, na viši plan možete prijeći u bilo kojem trenutku izravno iz svog korisničkog računa."
    }
   ]
  },
  "fi": {
   "slug": "ilmainen-maatilan-hallintaohjelmisto",
   "title": "Ilmainen maatilan hallintaohjelmisto | Ma Petite Ferme",
   "description": "Ilmainen maatilan hallintaohjelmisto: eläimet, tuotanto ja myynti 0 €/kk. Helppo aloittaa heti ilman luottokorttia — kokeile Ma Petite Fermeä nyt.",
   "h1": "Aloita ilmaiseksi – maatilan hallinta helposti",
   "intro": "Ma Petite Fermen ilmainen 0 €/kk-paketti on täydellinen pienelle tilalle: hallitse eläimiäsi, tuotantoasi ja myyntiäsi heti alusta alkaen. Kun tilasi kasvaa, voit siirtyä laajempaan pakettiin milloin tahansa.",
   "bullets": [
    "0 €/kk ilmaispaketti – ei luottokorttia tarvita",
    "Hallitse eläimet, tuotanto ja tärkeimmät myynnit yhdessä paikassa",
    "Päivitä pakettia helposti tilan kasvaessa"
   ],
   "faq": [
    {
     "q": "Onko ilmaispaketti todella maksuton?",
     "a": "Kyllä, Ma Petite Fermeä voi käyttää ilmaiseksi ilman luottokorttia – rekisteröidy ja aloita heti."
    },
    {
     "q": "Mitä ilmaispaketti sisältää?",
     "a": "Saat käyttöösi tärkeimmät toiminnot eläinten, tuotannon ja myynnin hallintaan. Maksulliset paketit tarjoavat lisäksi edistyneempiä ominaisuuksia."
    },
    {
     "q": "Voinko vaihtaa pakettia myöhemmin?",
     "a": "Kyllä, voit siirtyä laajempaan pakettiin koska tahansa suoraan tililtäsi ilman sitoutumista."
    }
   ]
  },
  "et": {
   "slug": "tasuta-pollumajanduse-tarkara",
   "title": "Tasuta põllumajanduse haldamistarkvara | Ma Petite Ferme",
   "description": "Tasuta põllumajandustarkvara: loomad, toodang ja müük alates 0 €/kuus. Lihtne ja praktiline — alusta kohe tasuta.",
   "h1": "Halda oma väikest farmi — tasuta alustades",
   "intro": "Ma Petite Ferme 0 €/kuus paketiga saad kohe alustada: halda loomi, toodangut ja esimesi müüke ilma kulutusteta. Kui sinu farm kasvab, uuenda paketti vastavalt vajadustele.",
   "bullets": [
    "0 €/kuus tasuta pakett — alusta kohe, ilma pangakaardita",
    "Halda loomi, toodangut ja põhimüüke ühes kohas",
    "Uuenda paketti igal ajal, kui farm laieneb"
   ],
   "faq": [
    {
     "q": "Kas tasuta pakett on päriselt 0 eurot?",
     "a": "Jah, Ma Petite Ferme tasuta paketti saab kasutada ilma pangakaardi andmeid sisestamata — 0 €/kuus."
    },
    {
     "q": "Mida tasuta pakett sisaldab?",
     "a": "Tasuta pakett hõlmab põhifunktsioone loomade, toodangu ja müügi haldamiseks. Tasulised paketid lisavad täiustatud võimalusi."
    },
    {
     "q": "Kas saan hiljem paketti vahetada?",
     "a": "Jah, saad oma kontolt igal ajal tasuta paketilt tasulisele üle minna, kui su farm vajab rohkem tööriistu."
    }
   ]
  },
  "hu": {
   "slug": "ingyenes-gazdasag-iranyito-szoftver",
   "title": "Ingyenes gazdaságirányítási szoftver kis farmokhoz | Ma Petite Ferme",
   "description": "Ingyenes gazdaságirányítási szoftver: állatok, termelés és értékesítés kezelése 0 €/hótól. Egyszerű és hatékony — kezdje el ingyen még ma!",
   "h1": "Indítsd el farmod ingyen, nullától!",
   "intro": "A Ma Petite Ferme 0 €/hó-s csomagjával azonnal elkezdheted kezelni állataidat, termelésed és első értékesítéseidet — és akkor lépsz tovább, amikor a farmod megkívánja. Nincs kockázat, nincs bankártya a regisztrációhoz.",
   "bullets": [
    "0 €/hó-s ingyenes csomag a biztos kezdéshez",
    "Állatok, termelés és alapvető értékesítés egy helyen",
    "Bővített funkciókra válthatsz, ahogy farmod növekszik"
   ],
   "faq": [
    {
     "q": "Valóban teljesen ingyenes a 0 €-s csomag?",
     "a": "Igen, a Ma Petite Ferme alapcsomagja teljesen ingyenes, bankártyát sem kérünk a regisztrációhoz."
    },
    {
     "q": "Mit tartalmaz az ingyenes csomag?",
     "a": "Az összes alapvető funkciót megkapod az állatok, a termelés és az értékesítés kezeléséhez; a fizetős csomagok fejlettebb eszközöket adnak hozzá."
    },
    {
     "q": "Válthatok magasabb csomagra később?",
     "a": "Természetesen, fiókodból bármikor, egy kattintással válthatsz bővebb csomagra, amint szükségessé válik."
    }
   ]
  },
  "lv": {
   "slug": "bezmaksas-lauksaimniecibas-programma",
   "title": "Bezmaksas lauksaimniecības pārvaldības programma | Ma Petite Ferme",
   "description": "Bezmaksas programma mazajiem lauksaimniekiem: dzīvnieki, raža un pārdošana no 0 €/mēn. Vienkārša un ērta — sāciet bez maksas jau šodien!",
   "h1": "Bezmaksas programma mazai saimniecībai",
   "intro": "Sāciet bez maksas ar Ma Petite Ferme 0 €/mēn. plānu: pārvaldiet savus dzīvniekus, ražošanu un pirmos pārdošanas darījumus. Augot saimniecībai, vienmēr varat pāriet uz jaudīgāku plānu.",
   "bullets": [
    "0 €/mēn. bezmaksas plāns iesācējiem bez maksājumu kartes",
    "Pārvaldiet dzīvniekus, ražu un pārdošanu vienuviet",
    "Pārejiet uz augstāku plānu, kad saimniecība aug"
   ],
   "faq": [
    {
     "q": "Vai bezmaksas plāns tiešām ir bez maksas?",
     "a": "Jā, Ma Petite Ferme var izmantot bez maksas — nav nepieciešama bankas karte, lai sāktu darbu."
    },
    {
     "q": "Ko ietver bezmaksas plāns?",
     "a": "Visas būtiskās funkcijas dzīvnieku, ražošanas un pārdošanas pārvaldībai; maksas plāni piedāvā papildu iespējas."
    },
    {
     "q": "Vai varu mainīt plānu vēlāk?",
     "a": "Jā, jebkurā laikā varat pāriet uz augstāku plānu tieši no sava konta iestatījumiem."
    }
   ]
  },
  "pl": {
   "slug": "darmowe-oprogramowanie-dla-rolnikow",
   "title": "Darmowe oprogramowanie dla rolników i hodowców | Ma Petite Ferme",
   "description": "Darmowe oprogramowanie dla rolników: zarządzaj zwierzętami, produkcją i sprzedażą od 0 zł/mies. Proste i skuteczne — zacznij bezpłatnie już dziś.",
   "h1": "Darmowe oprogramowanie dla małych gospodarstw",
   "intro": "Ma Petite Ferme oferuje bezpłatny plan 0 zł/miesiąc, dzięki któremu od razu zaczniesz zarządzać zwierzętami, produkcją i sprzedażą. Gdy Twoje gospodarstwo rośnie, możesz w każdej chwili przejść na wyższy plan.",
   "bullets": [
    "Bezpłatny plan 0 zł/mies. — zacznij bez ryzyka i bez karty kredytowej",
    "Zarządzaj stadem, produkcją i podstawową sprzedażą w jednym miejscu",
    "Rozwijaj się we własnym tempie i przejdź na wyższy plan, gdy zajdzie potrzeba"
   ],
   "faq": [
    {
     "q": "Czy plan bezpłatny naprawdę nic nie kosztuje?",
     "a": "Tak, możesz korzystać z Ma Petite Ferme całkowicie bezpłatnie — bez podawania karty kredytowej na start."
    },
    {
     "q": "Co zawiera bezpłatny plan?",
     "a": "Wszystkie podstawowe funkcje do zarządzania hodowlą i sprzedażą. Płatne plany odblokowują zaawansowane możliwości dla rosnących gospodarstw."
    },
    {
     "q": "Czy mogę zmienić plan później?",
     "a": "Oczywiście — możesz przejść na wyższy plan w dowolnym momencie bezpośrednio z poziomu swojego konta."
    }
   ]
  },
  "pt": {
   "slug": "software-gratuito-gestao-agricola",
   "title": "Software gratuito para gestão agrícola | Ma Petite Ferme",
   "description": "Software gratuito para pequenos agricultores e criadores: animais, produções e vendas a 0 €/mês. Simples e intuitivo — comece já gratuitamente.",
   "h1": "Gerencie sua pequena propriedade sem pagar nada",
   "intro": "Com o plano gratuito da Ma Petite Ferme, você controla seus animais, produções e vendas desde o primeiro dia, sem gastar nada. Quando seu negócio crescer, é só evoluir para um plano mais completo.",
   "bullets": [
    "Plano 100% gratuito a 0 €/mês para começar sem risco",
    "Controle animais, produções e vendas essenciais num só lugar",
    "Faça upgrade para um plano superior conforme sua propriedade cresce"
   ],
   "faq": [
    {
     "q": "O plano gratuito é realmente de 0 €?",
     "a": "Sim, você utiliza o Ma Petite Ferme sem pagar nada e sem precisar cadastrar cartão de crédito para começar."
    },
    {
     "q": "O que está incluído no plano gratuito?",
     "a": "Todas as funções essenciais para gerir sua criação e suas vendas; os planos pagos adicionam recursos avançados para propriedades maiores."
    },
    {
     "q": "Posso mudar de plano depois?",
     "a": "Sim, você pode fazer upgrade para um plano superior a qualquer momento diretamente pela sua conta, sem perder nenhum dado."
    }
   ]
  },
  "lt": {
   "slug": "nemokama-ukio-valdymo-programele",
   "title": "Nemokama ūkio valdymo programėlė | Ma Petite Ferme",
   "description": "Nemokama ūkio valdymo programėlė: tvarkykite gyvulius, produkciją ir pardavimus nuo 0 €/mėn. Paprasta ir greita — pradėkite nemokamai.",
   "h1": "Nemokama programėlė jūsų ūkiui valdyti",
   "intro": "Pradėkite nemokamai su Ma Petite Ferme 0 €/mėn. planu: tvarkykite gyvulius, produkciją ir pirmuosius pardavimus. Augant ūkiui, bet kada galite pereiti prie platesnio plano.",
   "bullets": [
    "0 €/mėn. planas — pradėkite be jokių išlaidų",
    "Valdykite gyvulius, produkciją ir svarbiausius pardavimus",
    "Lengvai pereikite prie aukštesnio plano, kai ūkis auga"
   ],
   "faq": [
    {
     "q": "Ar nemokamas planas tikrai nieko nekainuoja?",
     "a": "Taip, Ma Petite Ferme galite naudoti nemokamai — pradedant nereikia įvesti banko kortelės duomenų."
    },
    {
     "q": "Ką apima nemokamas planas?",
     "a": "Svarbiausias funkcijas gyvulių ir pardavimų valdymui; mokami planai suteikia papildomų ir išplėstinių galimybių."
    },
    {
     "q": "Ar galiu vėliau pakeisti planą?",
     "a": "Taip, bet kada galite pereiti prie aukštesnio plano tiesiogiai iš savo paskyros."
    }
   ]
  },
  "ro": {
   "slug": "software-gratuit-ferma-mica",
   "title": "Software gratuit pentru fermieri mici | Ma Petite Ferme",
   "description": "Software gratuit pentru fermieri: gestionezi animale, productii si vanzari de la 0 €/luna. Simplu si intuitiv — incepe gratuit azi.",
   "h1": "Gestioneaza ferma ta gratuit, fara niciun cost",
   "intro": "Ma Petite Ferme iti ofera un plan complet la 0 €/luna ca sa pornesti fara riscuri: inregistrezi animale, urmaresti productiile si gestionezi primele vanzari. Cand ferma ta creste, treci usor la un plan superior.",
   "bullets": [
    "Plan gratuit la 0 €/luna, fara card bancar necesar",
    "Gestioneaza animale, productii si vanzari esentiale intr-un singur loc",
    "Upgradeaza oricand, pe masura ce ferma ta se dezvolta"
   ],
   "faq": [
    {
     "q": "Planul gratuit chiar nu costa nimic?",
     "a": "Da, poti folosi Ma Petite Ferme fara niciun cost si fara sa introduci date bancare pentru a incepe."
    },
    {
     "q": "Ce functii include planul gratuit?",
     "a": "Toate functiile esentiale pentru a gestiona animalele si vanzarile tale; planurile platite adauga instrumente avansate de raportare si automatizare."
    },
    {
     "q": "Pot schimba planul mai tarziu?",
     "a": "Absolut, poti trece la un plan superior oricand direct din contul tau Ma Petite Ferme, in cateva clicuri."
    }
   ]
  },
  "sk": {
   "slug": "bezplatny-software-pre-farmarov",
   "title": "Bezplatný softvér pre farmárov a chovateľov | Ma Petite Ferme",
   "description": "Bezplatný softvér pre farmárov: správa zvierat, produkcií a predajov od 0 €/mesiac. Jednoduchý štart bez platobnej karty — vyskúšajte zadarmo.",
   "h1": "Bezplatný softvér pre vašu malú farmu",
   "intro": "Začnite s Ma Petite Ferme úplne zadarmo — náš plán 0 €/mesiac vám umožní spravovať zvieratá, produkciu aj predaje bez akýchkoľvek počiatočných nákladov. Keď vaša farma porastie, jednoducho prejdite na vyšší plán.",
   "bullets": [
    "Plán zadarmo od 0 €/mesiac bez platobnej karty",
    "Spravujte zvieratá, produkciu a základné predaje",
    "Kedykoľvek prejdite na vyšší plán podľa potreby"
   ],
   "faq": [
    {
     "q": "Je bezplatný plán naozaj zadarmo?",
     "a": "Áno, Ma Petite Ferme môžete začať používať bez platobnej karty a bez akýchkoľvek poplatkov — plán 0 €/mesiac je skutočne bezplatný."
    },
    {
     "q": "Čo je zahrnuté v bezplatnom pláne?",
     "a": "Bezplatný plán obsahuje základné funkcie na správu chovu a predajov. Platené plány pridávajú pokročilé nástroje a neobmedzený prístup k dátam."
    },
    {
     "q": "Môžem neskôr prejsť na platený plán?",
     "a": "Áno, kedykoľvek môžete zo svojho účtu prejsť na vyšší plán bez straty akýchkoľvek údajov."
    }
   ]
  },
  "cs": {
   "slug": "software-zdarma-pro-farmare",
   "title": "Software zdarma pro farmáře a chovatele | Ma Petite Ferme",
   "description": "Software zdarma pro malé farmy: správa zvířat, produkce a prodejů od 0 Kč/měsíc. Jednoduché a přehledné — začněte zdarma ještě dnes.",
   "h1": "Správa farmy zdarma — začněte bez rizika",
   "intro": "Ma Petite Ferme nabízí plán zdarma (0 Kč/měsíc), se kterým okamžitě zvládnete evidenci zvířat, sledování produkce i první prodeje. Až vaše farma poroste, jednoduše přejdete na vyšší plán.",
   "bullets": [
    "Plán zdarma za 0 Kč/měsíc — žádná platební karta nutná",
    "Spravujte zvířata, produkci i prodeje na jednom místě",
    "Kdykoli přejděte na vyšší plán, jak se vaše farma rozrůstá"
   ],
   "faq": [
    {
     "q": "Je plán zdarma skutečně bez poplatků?",
     "a": "Ano, Ma Petite Ferme můžete začít používat zcela zdarma bez zadávání platební karty."
    },
    {
     "q": "Co plán zdarma zahrnuje?",
     "a": "Základní funkce pro správu chovu a prodejů; placené plány pak přidávají pokročilé nástroje a rozšířené možnosti."
    },
    {
     "q": "Mohu plán později změnit?",
     "a": "Ano, na vyšší plán můžete kdykoli přejít přímo ze svého účtu, rychle a bez komplikací."
    }
   ]
  },
  "sl": {
   "slug": "brezplacna-kmetijska-programska-oprema",
   "title": "Brezplačna programska oprema za kmetije | Ma Petite Ferme",
   "description": "Brezplačna kmetijska programska oprema za rejce in pridelovalce: živali, pridelki in prodaja od 0 €/mes. Preprosto — začnite brezplačno.",
   "h1": "Brezplačna programska oprema za upravljanje vaše kmetije",
   "intro": "Začnite brezplačno z Ma Petite Ferme in že od prvega dne upravljajte živali, pridelke in prodajo — brez stroškov. Ko vaša kmetija raste, preprosto preidete na naprednejši paket.",
   "bullets": [
    "Brezplačni paket za 0 €/mesec — brez kreditne kartice",
    "Upravljajte živali, pridelke in osnovno prodajo na enem mestu",
    "Kadarkoli nadgradite na višji paket, ko kmetija raste"
   ],
   "faq": [
    {
     "q": "Ali je brezplačni paket res brez stroškov?",
     "a": "Da, Ma Petite Ferme lahko začnete uporabljati popolnoma brezplačno, brez vnosa podatkov o plačilni kartici."
    },
    {
     "q": "Kaj vključuje brezplačni paket?",
     "a": "Vse ključne funkcije za vodenje živinoreje in prodaje; plačljivi paketi dodajajo naprednejše možnosti za zahtevnejše kmetije."
    },
    {
     "q": "Ali lahko paket pozneje zamenjam?",
     "a": "Da, na višji paket lahko preidete kadarkoli neposredno iz svojega računa, brez zapletov."
    }
   ]
  }
 }
};
